/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
};

/** Reference object for AI knowledge base response. */
export type AiKnowledgeBaseReference = {
  __typename?: 'AIKnowledgeBaseReference';
  /** The type of content of the reference. */
  contentType: ContentTypes;
  /** The id of the reference content. */
  id: Scalars['String']['output'];
  /** The content name of the reference. */
  name: Scalars['String']['output'];
};

/** A response generated by AI knowledge base from a submitted prompt. */
export type AiPromptResponse = {
  __typename?: 'AIPromptResponse';
  /** The references used to generate the response. */
  references: Array<AiKnowledgeBaseReference>;
  /** The response generated by AI knowledge base from a submitted prompt. */
  response: Scalars['String']['output'];
};

/** Input type for creating a new agreement text record. */
export type AgreementTextCreateInput = {
  /** Whether or not to set text as the company default */
  companyDefault?: Scalars['Boolean']['input'];
  /** The text body of the agreement. */
  text: Scalars['String']['input'];
};

/** Information specific to articles */
export type ArticleExtras = {
  __typename?: 'ArticleExtras';
  /** Name of author */
  author?: Maybe<Scalars['String']['output']>;
  /** Description of content */
  description?: Maybe<Scalars['String']['output']>;
  /** Estimated time to complete content */
  duration?: Maybe<Scalars['Float']['output']>;
  /** Content of article */
  html?: Maybe<Scalars['String']['output']>;
  /** Name of Content */
  title?: Maybe<Scalars['String']['output']>;
};

/** Data specific to assessments */
export type AssessmentExtras = {
  __typename?: 'AssessmentExtras';
  /** Can buddy grade this content? */
  allowBuddyGrading?: Maybe<Scalars['Boolean']['output']>;
  /** Can manager grade this content? */
  allowManagerGrading?: Maybe<Scalars['Boolean']['output']>;
  /** Does assessment allow retakes? */
  allowRetake: Scalars['Boolean']['output'];
  /** Type of Assessment */
  assessmentType: Scalars['String']['output'];
  /** Notify buddy when content is ready for grading? */
  assignBuddyGrading?: Maybe<Scalars['Boolean']['output']>;
  /** Notify manager when content is ready for grading? */
  assignManagerGrading?: Maybe<Scalars['Boolean']['output']>;
  /** ID of assigned graders */
  assignedGraders?: Maybe<Array<AssignedGrader>>;
  /** Name of author */
  author?: Maybe<Scalars['String']['output']>;
  /** Description of content */
  description?: Maybe<Scalars['String']['output']>;
  /** Should cover of assessment be hidden? */
  hideCover: Scalars['Boolean']['output'];
  /** Number of times user can retake assessment */
  numberOfRetakes?: Maybe<Scalars['Float']['output']>;
  /** Percentage user needs to achieve to pass assessment */
  percentToPass?: Maybe<Scalars['Float']['output']>;
  /** Assessment questions */
  questions: Array<QuestionData>;
  /** Will correct answers be shown to user? */
  showUserCorrect: Scalars['Boolean']['output'];
  /** Will correct answers be shown after user fails assessment? */
  showUserCorrectAfterFail: Scalars['Boolean']['output'];
  /** Will user grade be displayed? */
  showUserGrade: Scalars['Boolean']['output'];
  /** Name of Content */
  title?: Maybe<Scalars['String']['output']>;
};

/** Assigned content that has been completed. */
export type AssignableCompletedContent = {
  __typename?: 'AssignableCompletedContent';
  /** Date the assignment was completed on. */
  completedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Content ID. */
  content: Scalars['ID']['output'];
  /** Engagement ID. */
  userContent?: Maybe<Scalars['ID']['output']>;
};

/** Assignable content entity. */
export type AssignableContent = {
  __typename?: 'AssignableContent';
  /** Content ID. */
  content: Scalars['ID']['output'];
  /** Content type, such as Article or Media. */
  contentType: Scalars['String']['output'];
  /** Content name. */
  name: Scalars['String']['output'];
  /** UserContent ID. */
  userContent?: Maybe<Scalars['ID']['output']>;
  /** UserContent type, such as UserWorkshop or ScormRegistration. */
  userContentType?: Maybe<Scalars['String']['output']>;
};

/** Assigned Grader Info */
export type AssignedGrader = {
  __typename?: 'AssignedGrader';
  /** ID of assigned grader */
  id: Scalars['String']['output'];
  /** Assigned grader image */
  image?: Maybe<Scalars['String']['output']>;
  /** Name of assigned grader */
  name: Scalars['String']['output'];
};

/** Assignee information. */
export type AssigneeData = {
  __typename?: 'AssigneeData';
  /** Assignee name. */
  fullName: Scalars['String']['output'];
  /** Assignee ID. */
  id: Scalars['ID']['output'];
};

/** An assignment of content to a user. */
export type Assignment = {
  __typename?: 'Assignment';
  /** List of content that has been assigned. */
  assignedContent: Array<AssignableContent>;
  /** Assignee info */
  assignee: AssigneeData;
  /** User creating this assignment. */
  assigner: Scalars['ID']['output'];
  /** The assignment template that was used to create this assignment. */
  assignmentTemplate?: Maybe<Scalars['ID']['output']>;
  /** Has the assignment been completed? */
  completed: Scalars['Boolean']['output'];
  /** List of assigned content that has been completed. */
  completedContent: Array<AssignableCompletedContent>;
  /** When was the assignment completed?  `null` if the assignment has not been completed. */
  completedDate?: Maybe<Scalars['DateTime']['output']>;
  /** Assignment completion percentage. */
  completionPercentage: Scalars['Float']['output'];
  /** Assignment completion status. */
  completionStatus: CompletionStatus;
  /** Completion type. */
  completionType: Scalars['String']['output'];
  /** Created date. */
  createdAt: Scalars['DateTime']['output'];
  /** Date the assignment is due.  `null` if the assignment has no firm due date. */
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  /** Should the user's buddy be contacted as an escalation contact? */
  escalateBuddy: Scalars['Boolean']['output'];
  /** Should the manager be contacted as an escalation contact? */
  escalateManager: Scalars['Boolean']['output'];
  /** Who should be contacted in overdue and similar situations? */
  escalationContacts: Array<Scalars['ID']['output']>;
  /** Is the failure due to a hired due date? */
  failedHiredDue: Scalars['Boolean']['output'];
  /** Internal group ID for assignments that were created at the same time. */
  groupId?: Maybe<Scalars['ID']['output']>;
  /** Is this assignment from a manual ingestion? */
  historical: Scalars['Boolean']['output'];
  /** Assignment ID. */
  id: Scalars['ID']['output'];
  /** Who marked the assignment completed? */
  manualCompletedBy?: Maybe<Scalars['ID']['output']>;
  /** Date the assignment was marked completed. */
  manualCompletedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Has the assignment been marked completed by an administrative action? */
  manualCompletion: Scalars['Boolean']['output'];
  /** Overall message history details. */
  messageHistory: Array<MessageHistory>;
  /** Assignment name (Workflow name) */
  name?: Maybe<Scalars['String']['output']>;
  /** Notifications addressing issues other than reminders. */
  nonReminderMessages: Array<Scalars['ID']['output']>;
  /** Notifications for overdue assignments. */
  overdueMessages: Array<OverdueMessage>;
  /** Notifications for assignee reminders. */
  reminderMessages: Array<ReminderMessage>;
  /** Does the assignment require a recompletion? */
  requireRecompletion: Scalars['Boolean']['output'];
  /** Sent message details. */
  sentMessages: Array<Scalars['ID']['output']>;
  /** Workflows that triggered due to this assignment. */
  triggeredWorkflows: Array<Scalars['ID']['output']>;
  /** Last updated date. */
  updatedAt: Scalars['DateTime']['output'];
  /** Was a workflow triggered from this assignment? */
  workflowTriggered: Scalars['Boolean']['output'];
};

/** Input type for modifying assignments based on lists of ids. */
export type AssignmentActionInput = {
  /** IDs of assignments */
  assignmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** IDs of groups */
  groupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** IDs of workflows */
  workflowIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** An Assignment list container object. */
export type AssignmentContainer = {
  __typename?: 'AssignmentContainer';
  /** A list of edges. */
  edges: Array<AssignmentEdge>;
  /** The pagination details. */
  pageInfo: PageInfo;
};

/** A container for Assignments. */
export type AssignmentEdge = {
  __typename?: 'AssignmentEdge';
  /** The cursor for this edge. */
  cursor: Scalars['String']['output'];
  /** The node for this edge. */
  node: Assignment;
};

/** Input type for creating a new assignment from an assignment template. */
export type AssignmentFromTemplateCreateInput = {
  /** Assignment template ID. */
  assignmentTemplate: Scalars['ID']['input'];
  /** User ID. */
  user: Scalars['ID']['input'];
};

/** Options related to assignments. */
export type AssignmentOption = {
  __typename?: 'AssignmentOption';
  /** Delay option for assignments. */
  delay?: Maybe<Scalars['String']['output']>;
};

/** Setting options for Assignments. */
export type AssignmentOptionInput = {
  /** Delay option for assignments. */
  delay?: InputMaybe<Scalars['String']['input']>;
};

/** The number of users returned from an audience filter */
export type AudienceCount = {
  __typename?: 'AudienceCount';
  /** The number of users returned. */
  totalUsers: Scalars['Float']['output'];
};

/** Audience filters for returning user count. */
export type AudienceCountInput = {
  /** Date range for the audience */
  dateRange?: InputMaybe<DateQueryOperatorArgs>;
  /** Days for relative range for the audience */
  days?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the audience */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Matching criteria for the audience */
  matchingCriteria?: InputMaybe<MatchingCriteria>;
  /** Type of audience */
  type: AudienceType;
};

/** The date range of the audience */
export type AudienceDateRange = {
  __typename?: 'AudienceDateRange';
  /** The beginning of the date range. */
  after?: Maybe<Scalars['DateTime']['output']>;
  /** The end of the date range. */
  before?: Maybe<Scalars['DateTime']['output']>;
};

/** Audience object for workflow trigger */
export type AudienceInput = {
  /** Date range for the audience */
  dateRange?: InputMaybe<DateQueryOperatorArgs>;
  /** Days for relative range for the audience */
  days?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the audience */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Matching criteria for the audience */
  matchingCriteria: MatchingCriteria;
  /** Type of audience */
  type: AudienceType;
};

/** The populated object instance with the content type. */
export type AudienceInstance = {
  __typename?: 'AudienceInstance';
  /** The date range for the audience. */
  dateRange?: Maybe<AudienceDateRange>;
  /** The days associated with the audience. */
  days?: Maybe<Scalars['Float']['output']>;
  /** The ID of audience */
  id?: Maybe<Scalars['String']['output']>;
  /** The image of the instance of the audience if audience is a user. */
  image?: Maybe<Scalars['String']['output']>;
  /** The criteria for matching the audience. */
  matchingCriteria: MatchingCriteria;
  /** The name of the instance of the audience. */
  name: Scalars['String']['output'];
  /** The segmentation type of audience */
  segmentationType: Scalars['String']['output'];
  /** The type of audience */
  type: AudienceType;
};

/** Types for segmenting audience */
export enum AudienceType {
  /** Specify a group id */
  Group = 'GROUP',
  /** Specify a date range or day delta for hired date */
  HiredDate = 'HIRED_DATE',
  /** Specify "partner" or "tenant" */
  PartnerType = 'PARTNER_TYPE',
  /** Specify a segmentation category id */
  Segment = 'SEGMENT',
  /** Specify a specific user id */
  User = 'USER'
}

/** A model for aggregating satisfications of several contents. */
export type Badge = {
  __typename?: 'Badge';
  /** Is the badge current active and processing satisfactions? */
  active: Scalars['Boolean']['output'];
  /** Content elements requiring satisfaction for this badge. */
  completableEntities: Array<BadgeCompletableEntity>;
  /** Date this was created. */
  createdAt: Scalars['DateTime']['output'];
  /** User ID of the creator of this badge. */
  creator: Scalars['ID']['output'];
  /** Badge description. */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the badge. */
  id: Scalars['ID']['output'];
  /** Badge title. */
  title: Scalars['String']['output'];
  /** Date this was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Visual artifact that shows with each badge. */
  uploadedImage?: Maybe<Scalars['String']['output']>;
};

/** A badge award represents a user's achievement of a badge when marked with an acquired date. */
export type BadgeAward = {
  __typename?: 'BadgeAward';
  /** Date this badge was acquired.  Null if it was not acquired yet. */
  acquiredDate?: Maybe<Scalars['DateTime']['output']>;
  /** Badge ID. */
  badge: Scalars['ID']['output'];
  /** The badge that was awarded. */
  badgeDetails: Badge;
  /** Total number of user seats available to this Partner. */
  completableEntities: Array<BadgeAwardCompletableEntity>;
  /** Date this was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the badge award. */
  id: Scalars['ID']['output'];
  /** Date this was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** User ID. */
  user: Scalars['ID']['output'];
};

/** Completable content entities that this badge checks for satisfaction. */
export type BadgeAwardCompletableEntity = {
  __typename?: 'BadgeAwardCompletableEntity';
  /** Date this content was satisfied. */
  completionDate: Scalars['DateTime']['output'];
  /** Has all content been satisfied for this badge to be awarded? */
  completionStatus: Scalars['Boolean']['output'];
  /** Content ID. */
  entity: Scalars['String']['output'];
  /** Content type, such as Article or Media. */
  entityType: Scalars['String']['output'];
};

/** A badge award relay connection object. */
export type BadgeAwardContainer = {
  __typename?: 'BadgeAwardContainer';
  /** A list of edges. */
  edges: Array<BadgeAwardEdge>;
  /** The pagination details. */
  pageInfo: PageInfo;
};

/** A container for badge awards. */
export type BadgeAwardEdge = {
  __typename?: 'BadgeAwardEdge';
  /** The cursor for this edge. */
  cursor: Scalars['String']['output'];
  /** The node for this edge. */
  node: BadgeAward;
};

/** Completable content entities that this badge checks for satisfaction. */
export type BadgeCompletableEntity = {
  __typename?: 'BadgeCompletableEntity';
  /** Is this content included in the badge's satisfaction rules? */
  active: Scalars['Boolean']['output'];
  /** User ID the content was added by. */
  addedBy: Scalars['String']['output'];
  /** Content ID. */
  entity: Scalars['ID']['output'];
  /** Content type, such as Article or Media. */
  entityType: Scalars['String']['output'];
};

/** Content entity used for satisifaction checks in a badge. */
export type BadgeCompletableEntityInput = {
  /** Is this content included in the badge's satisfaction rules? */
  active: Scalars['Boolean']['input'];
  /** Content ID. */
  entity: Scalars['ID']['input'];
  /** Content type, such as Article or Media. */
  entityType: Scalars['String']['input'];
};

/** A badge list container object. */
export type BadgeContainer = {
  __typename?: 'BadgeContainer';
  /** A list of edges. */
  edges: Array<BadgeEdge>;
  /** The pagination details. */
  pageInfo: PageInfo;
};

/** Input type for creating a new Badge. */
export type BadgeCreateInput = {
  /** Is the badge current active and processing satisfactions? */
  active: Scalars['Boolean']['input'];
  /** Content elements requiring satisfaction for this badge. */
  completableEntities: Array<BadgeCompletableEntityInput>;
  /** Badge description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Badge title. */
  title: Scalars['String']['input'];
  /** Visual artifact that shows with each badge. */
  uploadedImage?: InputMaybe<Scalars['String']['input']>;
};

/** A container for badges. */
export type BadgeEdge = {
  __typename?: 'BadgeEdge';
  /** The cursor for this edge. */
  cursor: Scalars['String']['output'];
  /** The node for this edge. */
  node: Badge;
};

/** Input type for updating a Badge. */
export type BadgeUpdateInput = {
  /** Is the badge current active and processing satisfactions? */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Content elements requiring satisfaction for this badge. */
  completableEntities?: InputMaybe<Array<BadgeCompletableEntityInput>>;
  /** Badge description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Badge title. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Visual artifact that shows with each badge. */
  uploadedImage?: InputMaybe<Scalars['String']['input']>;
};

/** A general matcher for types that are boolean-like. */
export type BooleanQueryOperatorArgs = {
  /** A specific single value to match. */
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  /** A list of values to match. */
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Question option value is of type boolean */
export type BooleanType = {
  __typename?: 'BooleanType';
  /** Name of question option setting */
  name?: Maybe<Scalars['String']['output']>;
  /** Value is a boolean */
  value?: Maybe<Scalars['Boolean']['output']>;
};

/** A list of users returned from searching by a list of emails. */
export type BulkUserRead = {
  __typename?: 'BulkUserRead';
  /** The list of users. */
  users: Array<User>;
};

/** Cadence options */
export enum Cadence {
  /** Every day */
  Daily = 'DAILY',
  /** Every month */
  Monthly = 'MONTHLY',
  /** Every week */
  Weekly = 'WEEKLY'
}

/** Card details for a purchase */
export type CardDetails = {
  __typename?: 'CardDetails';
  /** Brand of card used for purchase */
  brand: Scalars['String']['output'];
  /** Last four digits of card used for purchase */
  lastFour: Scalars['String']['output'];
};

/** Category lineage information */
export type CategoryLineage = {
  __typename?: 'CategoryLineage';
  /** Link identifier */
  id?: Maybe<Scalars['String']['output']>;
  /** Category name */
  name?: Maybe<Scalars['String']['output']>;
  /** Category parent information */
  parent?: Maybe<CategoryLineage>;
};

/** Input type for creating category lineage */
export type CategoryLineageInput = {
  /** Link identifier */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Category name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Category parent information */
  parent?: InputMaybe<CategoryLineageInput>;
};

/** Input type for creating a Certificate */
export type CertificateInput = {
  /** Name of certificate */
  name: Scalars['String']['input'];
  /** Information about the certificate */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Messaging settings for different notification channels. */
export type ChannelSettings = {
  __typename?: 'ChannelSettings';
  /** Name of the setting. */
  name: Scalars['String']['output'];
  /** Value of the setting. */
  value: Scalars['String']['output'];
};

/** Input type for adding channel settings. */
export type ChannelSettingsInput = {
  /** Name of the setting. */
  name: Scalars['String']['input'];
  /** Value of the setting. */
  value: Scalars['String']['input'];
};

/** Optional settings for answer choices */
export type ChoiceOptionData = {
  __typename?: 'ChoiceOptionData';
  /** Answer choice copy */
  copy?: Maybe<Scalars['String']['output']>;
  /** ID of answer choice */
  id?: Maybe<Scalars['String']['output']>;
  /** Image for answer choice */
  image?: Maybe<Scalars['String']['output']>;
  /** Points allocated to answer choice */
  points?: Maybe<Scalars['Float']['output']>;
  /** Position of answer choice */
  position?: Maybe<Scalars['Float']['output']>;
};

/** Input type for creating a content collaborator */
export type CollaboratorInput = {
  /** Affiliated groups */
  groups: Array<ContentGroupInput>;
  /** Collaborator identifier */
  id: Scalars['String']['input'];
  /** Affiliated departments */
  linkedDepartments: Array<ContentCategoryInput>;
  /** Affiliated grades */
  linkedGrade: ContentCategoryInput;
  /** Affiliate locations */
  linkedLocations: Array<ContentCategoryInput>;
  /** Affiliated org levels */
  linkedOrgLevel: ContentCategoryInput;
  /** Affiliated teams */
  linkedTeams: Array<ContentCategoryInput>;
  /** Collaborator name */
  name: Scalars['String']['input'];
};

/** A model for storing company wide integration data */
export type CompanyIntegration = {
  __typename?: 'CompanyIntegration';
  /** Stripe Integration Account Data */
  stripe: StripeIntegrationData;
};

/** A summary of company user statistics */
export type CompanyUserStats = {
  __typename?: 'CompanyUserStats';
  /** Count of current active company users */
  activeUsers: Scalars['Float']['output'];
  /** Count of company admin users */
  adminUsers: Scalars['Float']['output'];
  /** Number of company available seats */
  availableSeats: Scalars['Float']['output'];
  /** Count of company creator users */
  creatorUsers: Scalars['Float']['output'];
  /** Count of company external users */
  externalUsers: Scalars['Float']['output'];
  /** Count of company users who logged in for the first time within the last 30 days */
  firstLoginLastThirty: Scalars['Float']['output'];
  /** Count of company users who last logged in this month */
  lastLoginThisMonth: Scalars['Float']['output'];
  /** Count of company users pending invitation */
  pendingUsers: Scalars['Float']['output'];
  /** Count of company suspended users */
  suspendedUsers: Scalars['Float']['output'];
};

/** Assignment completion status. */
export enum CompletionStatus {
  /** Assignment completed late. */
  CompletedLate = 'COMPLETED_LATE',
  /** Assignment completed on time. */
  CompletedOnTime = 'COMPLETED_ON_TIME',
  /** Assignment in progress. */
  InProgress = 'IN_PROGRESS',
  /** Assignment not started. */
  NotStarted = 'NOT_STARTED',
  /** Assignment overdue. */
  Overdue = 'OVERDUE',
  /** Assignment pending on time. */
  PendingOnTime = 'PENDING_ON_TIME',
  /** Assignment was archived. */
  Unassigned = 'UNASSIGNED'
}

/** Audience Filters. */
export enum ConditionalObjectType {
  /** Audience is all groups. */
  AllGroups = 'ALL_GROUPS',
  /** Audience is any user added to any group. */
  AllGroupsAdded = 'ALL_GROUPS_ADDED',
  /** Audience is all teams. */
  AllTeams = 'ALL_TEAMS',
  /** Audience is any user added to any team. */
  AllTeamsAdded = 'ALL_TEAMS_ADDED',
  /** Audience Department. */
  Department = 'DEPARTMENT',
  /** Audience is users added to this department. */
  DepartmentAdded = 'DEPARTMENT_ADDED',
  /** Audience Grade. */
  Grade = 'GRADE',
  /** Audience is users added to this grade. */
  GradeAdded = 'GRADE_ADDED',
  /** Audience Group. */
  Group = 'GROUP',
  /** Audience is all groups with all fields. */
  GroupsFieldsAll = 'GROUPS_FIELDS_ALL',
  /** Audience is users added to this group. */
  GroupAdded = 'GROUP_ADDED',
  /** Audience is all groups with this department. */
  GroupDepartment = 'GROUP_DEPARTMENT',
  /** Audience is all groups with this grade. */
  GroupGrade = 'GROUP_GRADE',
  /** Audience is all groups with this location. */
  GroupLocation = 'GROUP_LOCATION',
  /** Audience is all groups with this org level. */
  GroupOrgLevel = 'GROUP_ORG_LEVEL',
  /** Audience is all groups with this team. */
  GroupTeam = 'GROUP_TEAM',
  /** Audience is users hired exactly a custom number of days ago. */
  HiredExactlyCustomDaysAgo = 'HIRED_EXACTLY_CUSTOM_DAYS_AGO',
  /** Audience is users hired within the last 30 days. */
  HiredWithin_30Days = 'HIRED_WITHIN_30_DAYS',
  /** Audience is users hired within a custom number of days. */
  HiredWithinCustomDays = 'HIRED_WITHIN_CUSTOM_DAYS',
  /** Audience Location. */
  Location = 'LOCATION',
  /** Audience is users added to this location. */
  LocationAdded = 'LOCATION_ADDED',
  /** Audience Org Level. */
  OrgLevel = 'ORG_LEVEL',
  /** Audience is users added to this org level. */
  OrgLevelAdded = 'ORG_LEVEL_ADDED',
  /** Audience Team. */
  Team = 'TEAM',
  /** Audience is users added to this team. */
  TeamAdded = 'TEAM_ADDED',
  /** Audience is specified users and groups. */
  UsersAndGroups = 'USERS_AND_GROUPS'
}

/** Content that is available to Continu users */
export type Content = {
  __typename?: 'Content';
  /** Does content allow comments? */
  allowComments?: Maybe<Scalars['Boolean']['output']>;
  /** Does content need approval? */
  approvalRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Has content been approved? */
  approved?: Maybe<Scalars['Boolean']['output']>;
  /** Is content archived? */
  archived: Scalars['Boolean']['output'];
  /** Average rating of content */
  averageRating?: Maybe<Scalars['Float']['output']>;
  /** Content banner image */
  bannerImage?: Maybe<Scalars['String']['output']>;
  /** Does content produce a certificate for the user when satisfied? */
  certificate?: Maybe<Scalars['Boolean']['output']>;
  /** Name and information about the certificate */
  certificateData?: Maybe<Array<ContentCertificateData>>;
  /** Company */
  company: Scalars['String']['output'];
  /** Content type */
  contentType: ContentTypes;
  /** Justification for cover image - left/center/right */
  coverJustification?: Maybe<Scalars['String']['output']>;
  /** Creator of Content */
  creator: Scalars['String']['output'];
  /** Current version of content and content-type specific data */
  currentVersion?: Maybe<ExtrasUnion>;
  /** Will content be hidden from explore? */
  exploreHide: Scalars['Boolean']['output'];
  /** Justification for featured image - left/center/right */
  featuredJustification?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the content. */
  id: Scalars['ID']['output'];
  /** Content image */
  image?: Maybe<Scalars['String']['output']>;
  /** IDs of category segmentations the content is associated with */
  linkedCategory?: Maybe<Array<CategoryLineage>>;
  /** Do Extend Account users and/or tenant users have access to this content? */
  partnerPermissions?: Maybe<PartnerPermissionTypes>;
  /** IDs of private collaborators associated with content */
  privacyCollaborators?: Maybe<Array<ContentCollaborator>>;
  /** IDs of private departments associated with content */
  privacyDepartments?: Maybe<Array<CategoryLineage>>;
  /** IDs of private grades associated with content */
  privacyGrades?: Maybe<Array<CategoryLineage>>;
  /** IDs of private groups associated with content */
  privacyGroups?: Maybe<Array<ContentGroup>>;
  /** IDs of private locations associated with content */
  privacyLocations?: Maybe<Array<CategoryLineage>>;
  /** IDs of private org levels associated with content */
  privacyOrgLevels?: Maybe<Array<CategoryLineage>>;
  /** IDs of private teams associated with content */
  privacyTeams?: Maybe<Array<CategoryLineage>>;
  /** Is this content private? */
  private?: Maybe<Scalars['Boolean']['output']>;
  /** Ratings Configuration */
  ratingConfiguration: RatingConfig;
  /** Agreement Text user is signing off on */
  signatureAgreementText?: Maybe<SignatureAgreementText>;
  /** Does content need a signature to be complete? */
  signatureRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Surveys for the content */
  surveys?: Maybe<Array<ContentSurvey>>;
  /** Tags related to content */
  tags?: Maybe<Array<Scalars['String']['output']>>;
  /** Number of likes content has from users */
  totalLikes?: Maybe<Scalars['Float']['output']>;
};

/** Content linked category information */
export type ContentCategory = {
  __typename?: 'ContentCategory';
  /** Link identifier */
  id?: Maybe<Scalars['String']['output']>;
  /** Category name */
  name?: Maybe<Scalars['String']['output']>;
};

/** Input type for creating a category */
export type ContentCategoryInput = {
  /** Link identifier */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Category name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Certificate data for content */
export type ContentCertificateData = {
  __typename?: 'ContentCertificateData';
  /** Name of certificate */
  name: Scalars['String']['output'];
  /** Information about the certificate */
  value?: Maybe<Scalars['String']['output']>;
};

/** Content collaborator information */
export type ContentCollaborator = {
  __typename?: 'ContentCollaborator';
  /** Affiliated groups */
  groups: Array<ContentGroup>;
  /** Collaborator identifier */
  id: Scalars['String']['output'];
  /** Affiliated departments */
  linkedDepartments: Array<ContentCategory>;
  /** Affiliated grades */
  linkedGrade: ContentCategory;
  /** Affiliate locations */
  linkedLocations: Array<ContentCategory>;
  /** Affiliated org levels */
  linkedOrgLevel: ContentCategory;
  /** Affiliated teams */
  linkedTeams: Array<ContentCategory>;
  /** Collaborator name */
  name: Scalars['String']['output'];
};

/** Input type for creating a new content. */
export type ContentCreateInput = {
  /** Does content allow comments? */
  allowComments?: InputMaybe<Scalars['Boolean']['input']>;
  /** Does content need approval? */
  approvalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Has content been approved? */
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is content archived? */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Average rating of content */
  averageRating?: InputMaybe<Scalars['Float']['input']>;
  /** Content banner image */
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  /** Does content produce a certificate for the user when satisfied? */
  certificate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name and information about the certificate */
  certificateData?: InputMaybe<Array<CertificateInput>>;
  /** Company */
  company?: InputMaybe<Scalars['String']['input']>;
  /** Content type */
  contentType?: InputMaybe<ContentTypes>;
  /** Justification for cover image - left/center/right */
  coverJustification?: InputMaybe<Scalars['String']['input']>;
  /** Creator of Content */
  creator?: InputMaybe<Scalars['String']['input']>;
  /** Current version of content */
  currentVersion?: InputMaybe<Scalars['String']['input']>;
  /** Will content be hidden from explore? */
  exploreHide?: InputMaybe<Scalars['Boolean']['input']>;
  /** Justification for featured image - left/center/right */
  featuredJustification?: InputMaybe<Scalars['String']['input']>;
  /** Content image */
  image?: InputMaybe<Scalars['String']['input']>;
  /** IDs of category segmentations the content is associated with */
  linkedCategory?: InputMaybe<Array<CategoryLineageInput>>;
  /** Do Extend Account users and/or tenant users have access to this content? */
  partnerPermissions?: InputMaybe<PartnerPermissionTypes>;
  /** IDs of private collaborators associated with content */
  privacyCollaborators?: InputMaybe<Array<CollaboratorInput>>;
  /** IDs of private departments associated with content */
  privacyDepartments?: InputMaybe<Array<CategoryLineageInput>>;
  /** IDs of private grades associated with content */
  privacyGrades?: InputMaybe<Array<CategoryLineageInput>>;
  /** IDs of private groups associated with content */
  privacyGroups?: InputMaybe<Array<ContentGroupInput>>;
  /** IDs of private locations associated with content */
  privacyLocations?: InputMaybe<Array<CategoryLineageInput>>;
  /** IDs of private org levels associated with content */
  privacyOrgLevels?: InputMaybe<Array<CategoryLineageInput>>;
  /** IDs of private teams associated with content */
  privacyTeams?: InputMaybe<Array<CategoryLineageInput>>;
  /** Is this content private? */
  private?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ratings Configuration */
  ratingConfiguration?: InputMaybe<RatingInput>;
  /** ID of agreement text user is agreeing to when signing */
  signatureAgreementText?: InputMaybe<Scalars['String']['input']>;
  /** Does content need a signature to be complete? */
  signatureRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Surveys for the content */
  surveys?: InputMaybe<Array<SurveyInput>>;
  /** Tags related to content */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Number of likes content has from users */
  totalLikes?: InputMaybe<Scalars['Float']['input']>;
};

/** Populated content object */
export type ContentDetails = {
  __typename?: 'ContentDetails';
  /** The displayName of content of any type.  Note this is a virtual field */
  displayName: Scalars['String']['output'];
  /** The id of the content */
  id: Scalars['String']['output'];
  /** The thumbnail image of the content */
  image?: Maybe<Scalars['String']['output']>;
  /** The name of a track */
  name?: Maybe<Scalars['String']['output']>;
  /** The title of non-track content */
  title?: Maybe<Scalars['String']['output']>;
  /** The type of the content */
  type: Scalars['String']['output'];
};

/** Group information */
export type ContentGroup = {
  __typename?: 'ContentGroup';
  /** Group identifier */
  id: Scalars['String']['output'];
  /** Group name */
  name: Scalars['String']['output'];
};

/** Input type for creating a group */
export type ContentGroupInput = {
  /** Group identifier */
  id: Scalars['String']['input'];
  /** Group name */
  name: Scalars['String']['input'];
};

/** The populated object instance with the content type. */
export type ContentInstance = {
  __typename?: 'ContentInstance';
  /** The type of content (Article, Scorm, etc.). */
  contentType: ContentTypes;
  /** ID of object instance */
  id?: Maybe<Scalars['String']['output']>;
  /** Whether content is recompletable. */
  isRecompletable?: Maybe<Scalars['String']['output']>;
  /** Title of content or segmentation associated with this object instance. */
  title?: Maybe<Scalars['String']['output']>;
};

/** the populated object instance with the content type. */
export type ContentInstanceInput = {
  /** The type of content (Article, Scorm, etc.). */
  contentType: ContentTypes;
  /** The ID of object instance */
  id?: InputMaybe<Scalars['String']['input']>;
};

/** The populated content instance with a thumbnail image field. */
export type ContentListItemInstance = {
  __typename?: 'ContentListItemInstance';
  /** The type of content (Article, Scorm, etc.). */
  contentType: ContentTypes;
  /** The content duration */
  duration?: Maybe<Scalars['Float']['output']>;
  /** ID of object instance */
  id?: Maybe<Scalars['String']['output']>;
  /** Whether content is recompletable. */
  isRecompletable?: Maybe<Scalars['String']['output']>;
  /** A thumbnail image for the content to display on a list */
  thumbnail?: Maybe<Scalars['String']['output']>;
  /** Title of content or segmentation associated with this object instance. */
  title?: Maybe<Scalars['String']['output']>;
};

/** Content Survey */
export type ContentSurvey = {
  __typename?: 'ContentSurvey';
  /** Survey ID */
  id: Scalars['String']['output'];
  /** Survey title */
  title: Scalars['String']['output'];
};

/** The different types of content available to users. */
export enum ContentTypes {
  /** Content is an article */
  Article = 'ARTICLE',
  /** Content is an assessment */
  Assessment = 'ASSESSMENT',
  /** Content is an event */
  Event = 'EVENT',
  /** Content is a file */
  File = 'FILE',
  /** Content is imported content */
  ImportedContent = 'IMPORTED_CONTENT',
  /** Content is a journey */
  Journey = 'JOURNEY',
  /** Content is of type media/file/video */
  Media = 'MEDIA',
  /** Content is a multi-session workshop */
  MultiSessionWorkshop = 'MULTI_SESSION_WORKSHOP',
  /** Content is a session part of a multi-session workshop */
  MultiSessionWorkshopSession = 'MULTI_SESSION_WORKSHOP_SESSION',
  /** Content is a poll */
  Poll = 'POLL',
  /** Content is a presentation */
  Presentation = 'PRESENTATION',
  /** Content is a quiz */
  Quiz = 'QUIZ',
  /** Content is a scorm content */
  Scorm = 'SCORM',
  /** Content is a track */
  Track = 'TRACK',
  /** Content is a video */
  Video = 'VIDEO',
  /** Content is a workshop */
  Workshop = 'WORKSHOP'
}

/** Input type for creating a subscription */
export type CreateSubscriptionData = {
  /** ID of product */
  productId: Scalars['String']['input'];
  /** ID of stripe setup intent */
  stripeSetupIntentId?: InputMaybe<Scalars['String']['input']>;
};

/** A general matcher for types that are date-like. */
export type DateQueryOperatorArgs = {
  /** A date that all results must be after or on. */
  after?: InputMaybe<Scalars['DateTime']['input']>;
  /** A date that all results must be before or on. */
  before?: InputMaybe<Scalars['DateTime']['input']>;
};

/** File embed setting configuration */
export type EmbedSetting = {
  __typename?: 'EmbedSetting';
  /** File height */
  height?: Maybe<Scalars['Float']['output']>;
  /** Embed ratio */
  ratio?: Maybe<Scalars['Float']['output']>;
  /** Embed type */
  type: Scalars['String']['output'];
  /** File width */
  width?: Maybe<Scalars['Float']['output']>;
};

/** An engagement between a user and a piece of content. */
export type Engagement = {
  __typename?: 'Engagement';
  /** If the content is scheduled to be marked completed. */
  awaitingManualCompletion: Scalars['Boolean']['output'];
  /** Content ID. */
  content: Scalars['ID']['output'];
  /** The type of the content element. */
  contentType: Scalars['String']['output'];
  /** The contexts of the user engagement. */
  contexts?: Maybe<Array<EngagementUserContext>>;
  /** Creation date of the engagement. */
  createdAt: Scalars['DateTime']['output'];
  /** Is this from a historical import? */
  historical: Scalars['Boolean']['output'];
  /** Who marked the content completed. */
  manualCompletedBy?: Maybe<Scalars['String']['output']>;
  /** When the content was marked completed. */
  manualCompletedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Was this content marked completed by an administrator? */
  manualCompletion: Scalars['Boolean']['output'];
  /** When the content was satisfied by the user. */
  satisfiedDate?: Maybe<Scalars['DateTime']['output']>;
  /** Has the content been satisfied by the user? */
  satisfiedStatus: Scalars['Boolean']['output'];
  /** The date at which the engagement was assigned or started. */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** Last updated date of the engagement. */
  updatedAt: Scalars['DateTime']['output'];
  /** User ID. */
  user: Scalars['ID']['output'];
};

/** An Engagement list container object. */
export type EngagementContainer = {
  __typename?: 'EngagementContainer';
  /** A list of edges. */
  edges: Array<EngagementEdge>;
  /** The pagination details. */
  pageInfo: PageInfo;
};

/** A container for Engagements. */
export type EngagementEdge = {
  __typename?: 'EngagementEdge';
  /** The cursor for this edge. */
  cursor: Scalars['String']['output'];
  /** The node for this edge. */
  node: Engagement;
};

/** An uniquely identified instance of a user's interaction with a piece of context. */
export type EngagementUserContext = {
  __typename?: 'EngagementUserContext';
  /** The ID of the context. */
  context: Scalars['ID']['output'];
  /** The type of the context. */
  contextType: Scalars['String']['output'];
  /** The ID of the user context. */
  userContext: Scalars['ID']['output'];
  /** The type of the user context. */
  userContextType: Scalars['String']['output'];
};

/** Workflow escalation contact info. */
export type EscalationContact = {
  __typename?: 'EscalationContact';
  /** The name of the contact. */
  fullName: Scalars['String']['output'];
  /** The ID of the contact. */
  id: Scalars['String']['output'];
  /** The image of the contact. */
  image?: Maybe<Scalars['String']['output']>;
};

/** Union of different content type-specific data to be returned */
export type ExtrasUnion = ArticleExtras | AssessmentExtras | FileExtras | ImportedContentExtras | JourneyExtras | ScormExtras | TrackExtras | VideoExtras | WorkshopExtras;

/** Data specific to files */
export type FileExtras = {
  __typename?: 'FileExtras';
  /** Name of author */
  author?: Maybe<Scalars['String']['output']>;
  /** Description of content */
  description?: Maybe<Scalars['String']['output']>;
  /** Can content be downloaded? */
  downloadable: Scalars['Boolean']['output'];
  /** Draft state of content */
  draft: Scalars['Boolean']['output'];
  /** Estimated time to complete content */
  duration?: Maybe<Scalars['Float']['output']>;
  /** Is this an embedded content? */
  embed: Scalars['Boolean']['output'];
  /** File embed settings */
  embedSettings?: Maybe<EmbedSetting>;
  /** Link to media */
  link: Scalars['String']['output'];
  /** Content source */
  source?: Maybe<Scalars['String']['output']>;
  /** Source identifier */
  sourceId?: Maybe<Scalars['String']['output']>;
  /** Source identifier v2 */
  sourceIdV2?: Maybe<Scalars['String']['output']>;
  /** Source v2 */
  sourceV2?: Maybe<Scalars['String']['output']>;
  /** Identifier of AI text generation job */
  textGenerationJob?: Maybe<Scalars['String']['output']>;
  /** Status of AI text generation */
  textGenerationStatus?: Maybe<TextGenerationStatus>;
  /** Name of Content */
  title?: Maybe<Scalars['String']['output']>;
  /** AI generated transcript for media */
  transcript?: Maybe<Scalars['String']['output']>;
  /** Does media use generative ai? */
  useGenerativeAi?: Maybe<Scalars['Boolean']['output']>;
};

/** Continu Groups provide a method for grouping and providing access controls to content visibility for users. */
export type Group = {
  __typename?: 'Group';
  /** The time the group was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The description of the group. */
  description?: Maybe<Scalars['String']['output']>;
  /** The external ID of the group. */
  externalId?: Maybe<Scalars['String']['output']>;
  /** The ID of the group */
  id: Scalars['ID']['output'];
  /** Visible name used in the group. */
  name: Scalars['String']['output'];
  /** Segmentation data of the group. */
  segmentations: Array<SegmentationRead>;
  /** Time the group was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** A Group list containter object. */
export type GroupContainer = {
  __typename?: 'GroupContainer';
  /** A list of edges. */
  edges: Array<GroupEdge>;
  /** The pagination details. */
  pageInfo: PageInfo;
};

/** A container for segmentation groups. */
export type GroupEdge = {
  __typename?: 'GroupEdge';
  /** The cursor for this edge. */
  cursor: Scalars['String']['output'];
  /** The node for this edge. */
  node: Group;
};

/** A general matcher for types that are ID-like. */
export type IdQueryOperatorArgs = {
  /** A specific single value to match. */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** A list of values to match. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Data specific to imported content */
export type ImportedContentExtras = {
  __typename?: 'ImportedContentExtras';
  /** Description of content */
  description?: Maybe<Scalars['String']['output']>;
  /** Estimated time to complete content */
  duration?: Maybe<Scalars['Float']['output']>;
  /** Information on instructors of imported content */
  instructors: Array<InstructorReadModel>;
  /** Learn items of imported content */
  learnItems?: Maybe<Array<Scalars['String']['output']>>;
  /** Imported Content component */
  lilStructure: Array<ImportedContentSection>;
  /** Has imported content been published? */
  published: Scalars['Boolean']['output'];
  /** Name of Content */
  title?: Maybe<Scalars['String']['output']>;
  /** Imported content vendor */
  vendor: Scalars['String']['output'];
  /** Vendor identifier of imported content */
  vendorContentId: Scalars['String']['output'];
  /** Full link to vendor */
  vendorFullLink?: Maybe<Scalars['String']['output']>;
  /** Link to vendor */
  vendorLink?: Maybe<Scalars['String']['output']>;
};

/** Information on imported content component */
export type ImportedContentSection = {
  __typename?: 'ImportedContentSection';
  /** Child sections of imported content section */
  children: Array<ImportedContentSection>;
  /** Difficulty of imported content section */
  difficulty?: Maybe<Scalars['String']['output']>;
  /** Duration of imported content section */
  duration?: Maybe<Scalars['Float']['output']>;
  /** Title of imported content section */
  title: Scalars['String']['output'];
  /** Imported content section type */
  type?: Maybe<Scalars['String']['output']>;
};

/** An instructor of a Track or Imported Content */
export type Instructor = {
  __typename?: 'Instructor';
  /** Is instructor archived? */
  archived: Scalars['Boolean']['output'];
  /** Instructor bio */
  bio?: Maybe<Scalars['String']['output']>;
  /** Time instructor was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Instructor email */
  email?: Maybe<Scalars['String']['output']>;
  /** The ID of the instructor */
  id: Scalars['ID']['output'];
  /** Instructor profile image */
  image?: Maybe<Scalars['String']['output']>;
  /** Instructor name */
  name: Scalars['String']['output'];
  /** Notes from instructor */
  notes?: Maybe<Scalars['String']['output']>;
  /** Is instructor saved to be reused? */
  reusable: Scalars['Boolean']['output'];
  /** Social media links of instructor */
  socials?: Maybe<InstructorSocialLinks>;
  /** Time instructor was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** An Instructor list container object. */
export type InstructorContainer = {
  __typename?: 'InstructorContainer';
  /** A list of edges. */
  edges: Array<InstructorEdge>;
  /** The pagination details. */
  pageInfo: PageInfo;
};

/** Input type for creating a new instructor. */
export type InstructorCreateInput = {
  /** Instructor bio */
  bio?: InputMaybe<Scalars['String']['input']>;
  /** Instructor email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Instructor profile image */
  image?: InputMaybe<Scalars['String']['input']>;
  /** Instructor name */
  name: Scalars['String']['input'];
  /** Notes from instructor */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Is instructor saved to be reused? */
  reusable: Scalars['Boolean']['input'];
  /** Social media links of instructor */
  socials?: InputMaybe<InstructorSocialLinksInput>;
};

/** A container for instructors. */
export type InstructorEdge = {
  __typename?: 'InstructorEdge';
  /** The cursor for this edge. */
  cursor: Scalars['String']['output'];
  /** The node for this edge. */
  node: Instructor;
};

/** A Track or Imported Content instructor */
export type InstructorReadModel = {
  __typename?: 'InstructorReadModel';
  /** Is instructor archived? */
  archived: Scalars['Boolean']['output'];
  /** Instructor bio */
  bio?: Maybe<Scalars['String']['output']>;
  /** Time instructor was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Instructor email */
  email?: Maybe<Scalars['String']['output']>;
  /** The ID of the instructor */
  id: Scalars['ID']['output'];
  /** Instructor profile image */
  image?: Maybe<Scalars['String']['output']>;
  /** Instructor name */
  name: Scalars['String']['output'];
  /** Notes from instructor */
  notes?: Maybe<Scalars['String']['output']>;
  /** Is instructor saved to be reused? */
  reusable: Scalars['Boolean']['output'];
  /** Social media links of instructor */
  socials?: Maybe<InstructorSocialLinks>;
  /** Time instructor was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Social media links of instructor */
export type InstructorSocialLinks = {
  __typename?: 'InstructorSocialLinks';
  /** Instructor Dribbble link */
  dribbble?: Maybe<Scalars['String']['output']>;
  /** Instructor Facebook profile link */
  facebook?: Maybe<Scalars['String']['output']>;
  /** Instructor Github link */
  github?: Maybe<Scalars['String']['output']>;
  /** Instructor Instagram link */
  instagram?: Maybe<Scalars['String']['output']>;
  /** Instructor Linkedin profile link */
  linkedin?: Maybe<Scalars['String']['output']>;
  /** Instructor Slack link */
  slack?: Maybe<Scalars['String']['output']>;
  /** Instructor Twitter profile link */
  twitter?: Maybe<Scalars['String']['output']>;
  /** Instructor Youtube link */
  youtube?: Maybe<Scalars['String']['output']>;
};

/** Input type for social media links of instructor */
export type InstructorSocialLinksInput = {
  /** Instructor Dribbble link */
  dribbble?: InputMaybe<Scalars['String']['input']>;
  /** Instructor Facebook profile link */
  facebook?: InputMaybe<Scalars['String']['input']>;
  /** Instructor Github link */
  github?: InputMaybe<Scalars['String']['input']>;
  /** Instructor Instagram link */
  instagram?: InputMaybe<Scalars['String']['input']>;
  /** Instructor Linkedin profile link */
  linkedin?: InputMaybe<Scalars['String']['input']>;
  /** Instructor Slack link */
  slack?: InputMaybe<Scalars['String']['input']>;
  /** Instructor Twitter profile link */
  twitter?: InputMaybe<Scalars['String']['input']>;
  /** Instructor Youtube link */
  youtube?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating an Instructor. */
export type InstructorUpdateInput = {
  /** Is instructor archived? */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Instructor bio */
  bio?: InputMaybe<Scalars['String']['input']>;
  /** Instructor email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Instructor profile image */
  image?: InputMaybe<Scalars['String']['input']>;
  /** Instructor name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Notes from instructor */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Is instructor saved to be reused? */
  reusable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Social media links of instructor */
  socials?: InputMaybe<InstructorSocialLinksInput>;
};

/** Data specific to journeys */
export type JourneyExtras = {
  __typename?: 'JourneyExtras';
  /** Description of content */
  description?: Maybe<Scalars['String']['output']>;
  /** Journey content that can be completed */
  satisfiableEntities: Array<SatisfiableEntityData>;
  /** Name of Content */
  title?: Maybe<Scalars['String']['output']>;
};

/** Options that can be hidden from a manager when configuring user segmentations. */
export enum ManagerConfigurationHideOptions {
  /** Cannot view departments segmentation. */
  LinkedDepartments = 'LINKED_DEPARTMENTS',
  /** Cannot view grade segmentation. */
  LinkedGrade = 'LINKED_GRADE',
  /** Cannot view groups segmentation. */
  LinkedGroups = 'LINKED_GROUPS',
  /** Cannot view locations segmentation. */
  LinkedLocations = 'LINKED_LOCATIONS',
  /** Cannot view org level segmentation. */
  LinkedOrgLevel = 'LINKED_ORG_LEVEL',
  /** Cannot view teams segmentation. */
  LinkedTeams = 'LINKED_TEAMS'
}

/** How specified audiences of type SEGMENT or GROUP should be combined */
export enum MatchingCriteria {
  /** Users must match all audience criteria with this type */
  MatchAll = 'MATCH_ALL',
  /** Users must match any audience criteria with this type */
  MatchAny = 'MATCH_ANY',
  /** Users must not match any audience criteria with this type */
  MatchNone = 'MATCH_NONE'
}

/** Details of attempted message sends. */
export type MessageHistory = {
  __typename?: 'MessageHistory';
  /** When message was attempted to send. */
  date: Scalars['DateTime']['output'];
  /** Message ID. */
  messageIdentifier: Scalars['ID']['output'];
  /** Who all the messages were scheduled for. */
  sentTo: Array<Scalars['ID']['output']>;
};

/** Messaging settings for a notification. */
export type MessagingSettings = {
  __typename?: 'MessagingSettings';
  /** Email settings */
  email: Array<ChannelSettings>;
  /** In-app settings. */
  inApp: Array<ChannelSettings>;
  /** Slack settings. */
  slack: Array<ChannelSettings>;
};

/** Input type for messaging settings. */
export type MessagingSettingsInput = {
  /** Email settings */
  email: Array<ChannelSettingsInput>;
  /** In-app settings. */
  inApp: Array<ChannelSettingsInput>;
  /** Slack settings. */
  slack: Array<ChannelSettingsInput>;
};

/** Slack channel information */
export type MessagingSlackChannel = {
  __typename?: 'MessagingSlackChannel';
  /** Slack channel identifier */
  id: Scalars['String']['output'];
  /** Slack channel name */
  name: Scalars['String']['output'];
};

/** Type of workshop registration */
export enum MultiSessionWorkshopTypes {
  /** Cohort signup */
  Cohort = 'COHORT',
  /** Freeform signup */
  Freeform = 'FREEFORM'
}

/** Continu GraphQL Mutations */
export type Mutation = {
  __typename?: 'Mutation';
  /** Archive Assignments */
  archiveAssignments: Scalars['Boolean']['output'];
  /** Archive or unarchive a product by its ID. */
  archiveProduct: NewEntityId;
  /** Cancel subscription in Stripe */
  cancelSubscription: StripeSubscriptionId;
  /** Mark Assignments Complete */
  completeAssignments: Scalars['Boolean']['output'];
  /** Create a new Agreement Text record */
  createAgreementText: NewEntityId;
  /** Create an assignment from an assignment template. */
  createAssignmentFromTemplate: Scalars['Boolean']['output'];
  /** Create a new Badge. */
  createBadge: NewEntityId;
  /** Create a new content */
  createContent: NewEntityId;
  /** Create a new instructor. */
  createInstructor: NewEntityId;
  /** Create a new notification. */
  createNotification: NotificationMutationResponse;
  /** Create a new Partner. */
  createPartner: NewEntityId;
  /** Create a new Product. */
  createProduct: ProductMutationResponse;
  /** Create new subscription in Stripe */
  createSubscription: StripeSubscriptionId;
  /** Create a new User. */
  createUser: NewEntityId;
  /** Create a new UserContentView. */
  createUserContentView: NewEntityId;
  /** Create a new Workflow. */
  createWorkflow: NewEntityId;
  /** Connect a Salesforce instance to a Continu company. */
  salesforceConnect: SalesforceConnect;
  /** Send assignment reminder message */
  sendAssignmentReminder: Scalars['Boolean']['output'];
  /** Complete account linkage between Stripe and Continu tenant. */
  stripeCompleteAccount: Scalars['Boolean']['output'];
  /** Initiate payment method setup flow for a Stripe customer. */
  stripeInitiateAccount: StripeInitiateAccount;
  /** Initiate payment method setup flow for a Stripe customer. */
  stripeInitiatePaymentMethod: StripeInitiatePaymentMethodCreation;
  /** Submit Payment to Stripe */
  stripeSubmitOneTimePayment: StripePaymentStatus;
  /** Trigger point in time workflow manually. */
  triggerPointInTimeWorkflow: Scalars['Boolean']['output'];
  /** Update an existing Badge by their internal ID. */
  updateBadge: NewEntityId;
  /** Update an existing instructor by their internal ID. */
  updateInstructor: InstructorReadModel;
  /** Update an existing notification. */
  updateNotification: NotificationMutationResponse;
  /** Update an existing Partner by their internal ID. */
  updatePartner: NewEntityId;
  /** Update an existing Product by their internal ID. */
  updateProduct: ProductMutationResponse;
  /** Update Workflow Result Group and Assignments */
  updateResultGroup: NewEntityId;
  /** Update subscription payment method in Stripe */
  updateSubscriptionPaymentMethod: StripeSubscriptionId;
  /** Update an existing User by their internal ID. */
  updateUser: NewEntityId;
  /** Update Workflow. */
  updateWorkflow: NewEntityId;
};


/** Continu GraphQL Mutations */
export type MutationArchiveAssignmentsArgs = {
  archiveInput: AssignmentActionInput;
};


/** Continu GraphQL Mutations */
export type MutationArchiveProductArgs = {
  archiveInput: ProductArchiveInput;
  id: Scalars['String']['input'];
};


/** Continu GraphQL Mutations */
export type MutationCancelSubscriptionArgs = {
  subscriptionData: SubscriptionData;
};


/** Continu GraphQL Mutations */
export type MutationCompleteAssignmentsArgs = {
  completeInput: AssignmentActionInput;
};


/** Continu GraphQL Mutations */
export type MutationCreateAgreementTextArgs = {
  create: AgreementTextCreateInput;
};


/** Continu GraphQL Mutations */
export type MutationCreateAssignmentFromTemplateArgs = {
  create: AssignmentFromTemplateCreateInput;
};


/** Continu GraphQL Mutations */
export type MutationCreateBadgeArgs = {
  create: BadgeCreateInput;
};


/** Continu GraphQL Mutations */
export type MutationCreateContentArgs = {
  create: ContentCreateInput;
};


/** Continu GraphQL Mutations */
export type MutationCreateInstructorArgs = {
  create: InstructorCreateInput;
};


/** Continu GraphQL Mutations */
export type MutationCreateNotificationArgs = {
  create: NotificationCreateInput;
};


/** Continu GraphQL Mutations */
export type MutationCreatePartnerArgs = {
  create: PartnerCreateInput;
};


/** Continu GraphQL Mutations */
export type MutationCreateProductArgs = {
  create: ProductCreateInput;
};


/** Continu GraphQL Mutations */
export type MutationCreateSubscriptionArgs = {
  subscriptionData: CreateSubscriptionData;
};


/** Continu GraphQL Mutations */
export type MutationCreateUserArgs = {
  create: UserCreateInput;
};


/** Continu GraphQL Mutations */
export type MutationCreateUserContentViewArgs = {
  userContentView: UserContentViewCreateInput;
};


/** Continu GraphQL Mutations */
export type MutationCreateWorkflowArgs = {
  workflow: WorkflowCreateInput;
};


/** Continu GraphQL Mutations */
export type MutationSalesforceConnectArgs = {
  connect: SalesforceConnectInput;
};


/** Continu GraphQL Mutations */
export type MutationSendAssignmentReminderArgs = {
  reminderInput: AssignmentActionInput;
};


/** Continu GraphQL Mutations */
export type MutationStripeCompleteAccountArgs = {
  accountData: StripeCompleteAccount;
};


/** Continu GraphQL Mutations */
export type MutationStripeSubmitOneTimePaymentArgs = {
  paymentData: StripePaymentData;
};


/** Continu GraphQL Mutations */
export type MutationTriggerPointInTimeWorkflowArgs = {
  workflowData: WorkflowTriggerData;
};


/** Continu GraphQL Mutations */
export type MutationUpdateBadgeArgs = {
  id: Scalars['String']['input'];
  update: BadgeUpdateInput;
};


/** Continu GraphQL Mutations */
export type MutationUpdateInstructorArgs = {
  id: Scalars['String']['input'];
  update: InstructorUpdateInput;
};


/** Continu GraphQL Mutations */
export type MutationUpdateNotificationArgs = {
  id: Scalars['String']['input'];
  update: NotificationUpdateInput;
};


/** Continu GraphQL Mutations */
export type MutationUpdatePartnerArgs = {
  id: Scalars['String']['input'];
  update: PartnerUpdateInput;
};


/** Continu GraphQL Mutations */
export type MutationUpdateProductArgs = {
  id: Scalars['String']['input'];
  update: ProductUpdateInput;
};


/** Continu GraphQL Mutations */
export type MutationUpdateResultGroupArgs = {
  id: Scalars['String']['input'];
  resultGroupUpdateInput: ResultGroupUpdateInput;
};


/** Continu GraphQL Mutations */
export type MutationUpdateSubscriptionPaymentMethodArgs = {
  subscriptionUpdatePaymentData: SubscriptionUpdatePaymentData;
};


/** Continu GraphQL Mutations */
export type MutationUpdateUserArgs = {
  id: Scalars['String']['input'];
  update: UserUpdateInput;
};


/** Continu GraphQL Mutations */
export type MutationUpdateWorkflowArgs = {
  id: Scalars['String']['input'];
  workflowUpdateInput: WorkflowUpdateInput;
};

/** A unique identifier that can be used to lookup the currently referenced object type. */
export type NewEntityId = {
  __typename?: 'NewEntityID';
  /** The ID of the object. */
  id: Scalars['String']['output'];
};

/** A dynamic message that is sent to users. */
export type Notification = {
  __typename?: 'Notification';
  /** The different channels notification will be sent through. */
  channels: Array<Scalars['String']['output']>;
  /** ID of content notification is for. */
  contentId?: Maybe<Scalars['String']['output']>;
  /** Content type */
  contentType: NotificationContentType;
  /** Time the Notification was created. */
  createdAt: Scalars['DateTime']['output'];
  /** User who created notification. */
  creator: Scalars['String']['output'];
  /** The ID of the notification */
  id: Scalars['ID']['output'];
  /** Notification messaging settings. */
  messaging: MessagingSettings;
  /** Name of the notification. */
  name: Scalars['String']['output'];
  /** Notification options */
  options: Array<NotificationOption>;
  /** Whether the notification is scheduled. */
  scheduled: Scalars['Boolean']['output'];
  /** Scheduled duration of notification. */
  scheduledDuration?: Maybe<Scalars['Float']['output']>;
  /** Type of notification. */
  type: NotificationType;
  /** Time the Notification was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** A Notification list container object. */
export type NotificationContainer = {
  __typename?: 'NotificationContainer';
  /** A list of edges. */
  edges: Array<NotificationEdge>;
  /** The pagination details. */
  pageInfo: PageInfo;
};

/** The different types of content notification can be sent for. */
export enum NotificationContentType {
  /** Notification is for an article. */
  Article = 'ARTICLE',
  /** Notification is for an assignment. */
  Assignment = 'ASSIGNMENT',
  /** Notification is for media. */
  Media = 'MEDIA',
  /** Notification is for a track. */
  Track = 'TRACK',
  /** Notification is for a workflow. */
  Workflow = 'WORKFLOW',
  /** Notification is for a workshop. */
  Workshop = 'WORKSHOP'
}

/** Input type for creating a new Notification. */
export type NotificationCreateInput = {
  /** The different channels notification will be sent through. */
  channels: Array<Scalars['String']['input']>;
  /** ID of content notification is for. */
  contentId?: InputMaybe<Scalars['String']['input']>;
  /** Content type */
  contentType: NotificationContentType;
  /** User who created notification. */
  creator: Scalars['String']['input'];
  /** Notification messaging settings. */
  messaging: MessagingSettingsInput;
  /** Name of the notification. */
  name: Scalars['String']['input'];
  /** Notification options */
  options: Array<NotificationOptionInput>;
  /** Whether the notification is scheduled. */
  scheduled: Scalars['Boolean']['input'];
  /** Scheduled duration of notification. */
  scheduledDuration?: InputMaybe<Scalars['Float']['input']>;
  /** Type of notification. */
  type: NotificationType;
};

/** A container for notifications. */
export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  /** The cursor for this edge. */
  cursor: Scalars['String']['output'];
  /** The node for this edge. */
  node: Notification;
};

/** Response returned when creating or updating a Notification. */
export type NotificationMutationResponse = {
  __typename?: 'NotificationMutationResponse';
  /** The ID of the object. */
  id: Scalars['String']['output'];
};

/** Options for a notification. */
export type NotificationOption = {
  __typename?: 'NotificationOption';
  /** Option name. */
  name: Scalars['String']['output'];
  /** Option value */
  value: Scalars['String']['output'];
};

/** Notification options. */
export type NotificationOptionInput = {
  /** Option name. */
  name: Scalars['String']['input'];
  /** Option value */
  value: Scalars['String']['input'];
};

/** A dynamic message that is sent to users. */
export type NotificationReadModel = {
  __typename?: 'NotificationReadModel';
  /** The different channels notification will be sent through. */
  channels: Array<Scalars['String']['output']>;
  /** ID of content notification is for. */
  contentId?: Maybe<Scalars['String']['output']>;
  /** Content type */
  contentType: NotificationContentType;
  /** Time the Notification was created. */
  createdAt: Scalars['DateTime']['output'];
  /** User who created notification. */
  creator: Scalars['String']['output'];
  /** The ID of the notification */
  id: Scalars['ID']['output'];
  /** Notification messaging settings. */
  messaging: MessagingSettings;
  /** Name of the notification. */
  name: Scalars['String']['output'];
  /** Notification options */
  options: Array<NotificationOption>;
  /** Whether the notification is scheduled. */
  scheduled: Scalars['Boolean']['output'];
  /** Scheduled duration of notification. */
  scheduledDuration?: Maybe<Scalars['Float']['output']>;
  /** Type of notification. */
  type: NotificationType;
  /** Time the Notification was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Type of user notification. */
export enum NotificationType {
  /** Notification to be sent after the end of an assignment. */
  AfterEnd = 'AFTER_END',
  /** Notification to be sent to assignee upon assignment creaation. */
  AssignmentCreatedAssignee = 'ASSIGNMENT_CREATED_ASSIGNEE',
  /** Notification to be sent to escalator upon assignment creation. */
  AssignmentCreatedEscalator = 'ASSIGNMENT_CREATED_ESCALATOR',
  /** Notification to be sent to assignee when assignee fails an assignment. */
  AssignmentFailedAssignee = 'ASSIGNMENT_FAILED_ASSIGNEE',
  /** Notification to be sent to escalator when an assignee fails an assignment. */
  AssignmentFailedEscalator = 'ASSIGNMENT_FAILED_ESCALATOR',
  /** Notification sent to assignee for an overdue assignment. */
  AssignmentOverdueAssignee = 'ASSIGNMENT_OVERDUE_ASSIGNEE',
  /** Notification to be sent to an assignee when assignee passes an assignment. */
  AssignmentPassedAssignee = 'ASSIGNMENT_PASSED_ASSIGNEE',
  /** Notification to be sent to escalator when an assignee passes an assignment. */
  AssignmentPassedEscalator = 'ASSIGNMENT_PASSED_ESCALATOR',
  /** Notification to be sent as an assignment reminder to assignee. */
  AssignmentReminderAssignee = 'ASSIGNMENT_REMINDER_ASSIGNEE',
  /** Notification to be sent as an assignment reminder to escalator. */
  AssignmentReminderEscalator = 'ASSIGNMENT_REMINDER_ESCALATOR',
  /** Notification to be sent before the start of an assignment. */
  BeforeStart = 'BEFORE_START',
  /** Notification to be sent upon completion of an assignment. */
  Completion = 'COMPLETION',
  /** Notification to be sent upon user registration. */
  OnRegister = 'ON_REGISTER'
}

/** Input type for updating a Notification. */
export type NotificationUpdateInput = {
  /** The different channels notification will be sent through. */
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ID of content notification is for. */
  contentId?: InputMaybe<Scalars['String']['input']>;
  /** Content type */
  contentType?: InputMaybe<NotificationContentType>;
  /** User who created notification. */
  creator?: InputMaybe<Scalars['String']['input']>;
  /** Notification messaging settings. */
  messaging?: InputMaybe<MessagingSettingsInput>;
  /** Name of the notification. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Notification options */
  options?: InputMaybe<Array<NotificationOptionInput>>;
  /** Whether the notification is scheduled. */
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Scheduled duration of notification. */
  scheduledDuration?: InputMaybe<Scalars['Float']['input']>;
  /** Type of notification. */
  type?: InputMaybe<NotificationType>;
};

/** Question option value is of type number */
export type NumberType = {
  __typename?: 'NumberType';
  /** Name of question option setting */
  name?: Maybe<Scalars['String']['output']>;
  /** Value is a number */
  value?: Maybe<Scalars['Float']['output']>;
};

/** The object instance populated with data after referencing its object type. */
export type ObjectInstance = {
  __typename?: 'ObjectInstance';
  /** ID of object instance */
  id?: Maybe<Scalars['String']['output']>;
  /** Title of content or segmentation associated with this object instance. */
  title?: Maybe<Scalars['String']['output']>;
};

/** An input for ordering controls, using field names and asc/desc for direction. */
export type OrderBy = {
  /** The direction to order by. */
  direction: OrderingDirection;
  /** The field to order by. */
  field: Scalars['String']['input'];
};

/** Direction to order specified field by. */
export enum OrderingDirection {
  /** Sort results against this field in ascending order. */
  Asc = 'ASC',
  /** Sort results against this field in descending order. */
  Desc = 'DESC'
}

/** Assigned content that has been completed. */
export type OverdueMessage = {
  __typename?: 'OverdueMessage';
  /** How often should the overdue messages be sent? */
  cadence: Scalars['String']['output'];
  /** Notification ID. */
  message: Scalars['ID']['output'];
  /** Did the overdue message get delivered? */
  satisfied: Scalars['Boolean']['output'];
  /** Total messages attempted. */
  totalMessages: Scalars['Float']['output'];
  /** Number of messages sent. */
  totalSent: Scalars['Float']['output'];
};

/** Container for pagination and cursor details. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating backwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Whether there are more items when paginating forward. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether there are more items when paginating backward. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating forward, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  /** The total number of results this filter will provide.  Only populated when specifically requested. */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** Within a tenant, a partner is a subsection of users that have access to limited content collections in a custom branded view. */
export type Partner = {
  __typename?: 'Partner';
  /** Is the partner currently available for learner logins? */
  active: Scalars['Boolean']['output'];
  /** Branding elements for this Partner. */
  branding: PartnerBranding;
  /** The date the Partner was created */
  createdAt: Scalars['DateTime']['output'];
  /** User ID of the creator of this Partner. */
  creator: Scalars['String']['output'];
  /** Unique identifier for the partner. */
  id: Scalars['ID']['output'];
  /** Name. */
  name: Scalars['String']['output'];
  /** Total number of user seats available to this Partner. */
  seats: Scalars['Float']['output'];
};

/** Partner-specific branding configurations. */
export type PartnerBranding = {
  __typename?: 'PartnerBranding';
  /** List of background image URLs to be selected from for login pages. */
  backgroundImageUrls?: Maybe<Array<Scalars['String']['output']>>;
  /** Primary branding color. */
  colorPrimary?: Maybe<Scalars['String']['output']>;
  /** URL to the logo that will be embedded on login pages and top corners. */
  logoUrl?: Maybe<Scalars['String']['output']>;
};

/** Partner-specific branding configurations. */
export type PartnerBrandingInput = {
  /** List of background image URLs to be selected from for login pages. */
  backgroundImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Primary branding color. */
  colorPrimary?: InputMaybe<Scalars['String']['input']>;
  /** URL to the logo that will be embedded on login pages and top corners. */
  logoUrl?: InputMaybe<Scalars['String']['input']>;
};

/** A Partner list container object. */
export type PartnerContainer = {
  __typename?: 'PartnerContainer';
  /** A list of edges. */
  edges: Array<PartnerEdge>;
  /** The pagination and cursor details. */
  pageInfo: PageInfo;
};

/** Input type for creating a new Partner. */
export type PartnerCreateInput = {
  /** Is the partner currently available for learner logins? */
  active: Scalars['Boolean']['input'];
  /** Branding elements for this Partner. */
  branding: PartnerBrandingInput;
  /** Name. */
  name: Scalars['String']['input'];
  /** Total number of user seats available to this Partner. */
  seats: Scalars['Float']['input'];
};

/** A container for partners. */
export type PartnerEdge = {
  __typename?: 'PartnerEdge';
  /** The cursor for this edge. */
  cursor: Scalars['String']['output'];
  /** The node for this edge. */
  node: Partner;
};

/** Permission levels available to partners */
export enum PartnerPermissionTypes {
  /** Grants partner level access */
  Partner = 'PARTNER',
  /** Grants partner and tenant level access */
  PartnerAndTenant = 'PARTNER_AND_TENANT',
  /** Grants tenant level access */
  Tenant = 'TENANT'
}

/** Input type for updating a Partner. */
export type PartnerUpdateInput = {
  /** Is the partner currently available for learner logins? */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Branding elements for this Partner. */
  branding?: InputMaybe<PartnerBrandingInput>;
  /** Name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Total number of user seats available to this Partner. */
  seats?: InputMaybe<Scalars['Float']['input']>;
};

/** List of payment attempts related to this purchase and their details */
export type PaymentAttempt = {
  __typename?: 'PaymentAttempt';
  /** The currency used for this payment */
  currency?: Maybe<Scalars['String']['output']>;
  /** Method used to attempt this payment */
  paymentMethod?: Maybe<Scalars['String']['output']>;
  /** Date the payment officially settled */
  paymentSettledDate?: Maybe<Scalars['DateTime']['output']>;
  /** The price user attempted to pay for this payment */
  price?: Maybe<Scalars['Float']['output']>;
  /** Whether this payment attempt succeeded */
  successful?: Maybe<Scalars['Boolean']['output']>;
};

/** Payment Method */
export type PaymentMethodGto = {
  __typename?: 'PaymentMethodGTO';
  /** Brand of Card */
  brand: Scalars['String']['output'];
  /** Stripe Payment Method Id */
  id: Scalars['String']['output'];
  /** Last Four Digits of the Card */
  lastFour: Scalars['Float']['output'];
};

/** Customer payments */
export type PaymentsGto = {
  __typename?: 'PaymentsGTO';
  /** Link to payment invoice */
  invoiceUrl: Scalars['String']['output'];
  /** Payment date */
  paymentDate: Scalars['DateTime']['output'];
  /** Payment method */
  paymentMethod: Scalars['String']['output'];
  /** Amount paid */
  paymentTotal: Scalars['Float']['output'];
  /** Payment type */
  paymentType: Scalars['String']['output'];
  /** Product ID */
  productId: Scalars['String']['output'];
  /** Product title */
  productTitle: Scalars['String']['output'];
  /** ID of product in Stripe */
  stripeProductId: Scalars['String']['output'];
  /** ID of subscription in Stripe */
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
};

/** The user that created the workflow. */
export type PopulatedUser = {
  __typename?: 'PopulatedUser';
  /** Name of the user */
  fullName: Scalars['String']['output'];
  /** ID of user */
  id: Scalars['String']['output'];
};

/** A purchasable product that gives access to content on the Continu platform */
export type Product = {
  __typename?: 'Product';
  /** Whether the product supports related products */
  allowRelatedProducts: Scalars['Boolean']['output'];
  /** Whether the product is archived */
  archived: Scalars['Boolean']['output'];
  /** The content items for the Product. */
  contentList: Array<ProductContent>;
  /** Content List details for product. */
  contentListDetails?: Maybe<Array<ContentDetails>>;
  /** Time the Product was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Currency the product is offered in.  Always USD right now. */
  currency?: Maybe<Scalars['String']['output']>;
  /** Whether the product is the default product for the company.  Only one product can be the default. */
  default?: Maybe<Scalars['Boolean']['output']>;
  /** Product description. */
  description: Scalars['String']['output'];
  /** The ID of the product */
  id: Scalars['ID']['output'];
  /** Product images. */
  images: Array<Scalars['String']['output']>;
  /** Is this product active for the current user */
  isActive: Scalars['Boolean']['output'];
  /** Licensing model for the content/segmentations/etc. attached to the Product.  Values values are: permanent, subscription. */
  licensingType: ProductLicensingType;
  /** Price of the Product in dollars (at whatever frequency the license type requires) */
  price: Scalars['Float']['output'];
  /** What the Product provides to the user.  Values values are: content_list. */
  productType: ProductType;
  /** Whether the product is published and ready for purchase, or still in a draft state. */
  published: Scalars['Boolean']['output'];
  /** Number of times this product has been successfully purchased */
  purchaseCount: Scalars['Int']['output'];
  /** Related products */
  relatedProducts: Array<Scalars['String']['output']>;
  /** How long the subscription lasts.  Daily, weekly, monthly, or yearly. */
  subscriptionDuration: ProductSubscriptionDuration;
  /** Product title. */
  title: Scalars['String']['output'];
  /** Total refunds in cents for this product */
  totalRefunded: Scalars['Int']['output'];
  /** Total revenue in cents for this product */
  totalRevenue: Scalars['Int']['output'];
  /** Time the Product was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Input type for archiving a Product. */
export type ProductArchiveInput = {
  /** Whether to archive the product (true) or unarchive it (false). Defaults to true. */
  archive?: Scalars['Boolean']['input'];
};

/** A Product list container object. */
export type ProductContainer = {
  __typename?: 'ProductContainer';
  /** A list of edges. */
  edges: Array<ProductEdge>;
  /** The pagination details. */
  pageInfo: PageInfo;
};

/** The content items for the Product. */
export type ProductContent = {
  __typename?: 'ProductContent';
  /** The ID of the content. */
  entity: Scalars['String']['output'];
  /** The type of content (Article, Scorm, etc.) */
  entityType: Scalars['String']['output'];
};

/** The content items for the Product. */
export type ProductContentInput = {
  /** The ID of the content. */
  entity: Scalars['String']['input'];
  /** The type of content (Article, Scorm, etc.) */
  entityType: Scalars['String']['input'];
};

/** Product Content */
export type ProductContentReadModel = {
  __typename?: 'ProductContentReadModel';
  /** Content banner image */
  bannerImage?: Maybe<Scalars['String']['output']>;
  /** Content type */
  contentType: ContentTypes;
  /** Unique identifier for the content. */
  id: Scalars['ID']['output'];
  /** Name of Content */
  title?: Maybe<Scalars['String']['output']>;
};

/** Input type for creating a new Product. */
export type ProductCreateInput = {
  /** Whether the product supports related products */
  allowRelatedProducts?: Scalars['Boolean']['input'];
  /** The content items for the Product. */
  contentList?: Array<ProductContentInput>;
  /** Currency the product is offered in.  Always USD right now. */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Whether the product is the default product for the company.  Only one product can be the default. */
  default?: InputMaybe<Scalars['Boolean']['input']>;
  /** Product description. */
  description: Scalars['String']['input'];
  /** Product images. */
  images?: Array<Scalars['String']['input']>;
  /** Licensing model for the content/segmentations/etc. attached to the Product.  Values values are: permanent, subscription. */
  licensingType: ProductLicensingType;
  /** Price of the Product in dollars (at whatever frequency the license type requires) */
  price: Scalars['Float']['input'];
  /** What the Product provides to the user.  Values values are: content_list. */
  productType: ProductType;
  /** Whether the product is published and ready for purchase, or still in a draft state. */
  published?: Scalars['Boolean']['input'];
  /** Related products */
  relatedProducts?: Array<Scalars['String']['input']>;
  /** How long the subscription lasts.  Daily, weekly, monthly, or yearly. */
  subscriptionDuration: ProductSubscriptionDuration;
  /** Product title. */
  title: Scalars['String']['input'];
};

/** A container for products. */
export type ProductEdge = {
  __typename?: 'ProductEdge';
  /** The cursor for this edge. */
  cursor: Scalars['String']['output'];
  /** The node for this edge. */
  node: Product;
};

/** The licensing model for the content/segmentations/etc. attached to the Product.  Values values are: permanent, subscription. */
export enum ProductLicensingType {
  /** Permanent ownership of the content/segmentations/etc. */
  Permanent = 'PERMANENT',
  /** Renewable ownership of the content/segmentations/etc. based on timing fields on the Product. */
  Subscription = 'SUBSCRIPTION'
}

/** Response returned when creating or updating a Product. */
export type ProductMutationResponse = {
  __typename?: 'ProductMutationResponse';
  /** The ID of the object. */
  id: Scalars['String']['output'];
  /** Time Product was updated during mutation */
  updatedAt: Scalars['DateTime']['output'];
};

/** A Purchase Data container object. */
export type ProductReportDataContainer = {
  __typename?: 'ProductReportDataContainer';
  /** A list of edges. */
  edges: Array<ProductReportDatumEdge>;
};

/** A model for date and licensing type amounts for purchases or revenue of products. */
export type ProductReportDatum = {
  __typename?: 'ProductReportDatum';
  /** UTC Date for data */
  date: Scalars['String']['output'];
  /** Number for licensing type Permanent, of either revenue or purchases for this date */
  permanent?: Maybe<Scalars['Float']['output']>;
  /** Number for licensing type Subscription, of either revenue or purchases for this date */
  subscription?: Maybe<Scalars['Float']['output']>;
};

/** A container for purchases. */
export type ProductReportDatumEdge = {
  __typename?: 'ProductReportDatumEdge';
  /** The cursor for this edge. */
  cursor: Scalars['String']['output'];
  /** The node for this edge. */
  node: ProductReportDatum;
};

/** Duration of the subscription. Only used with Subscription licensing type. */
export enum ProductSubscriptionDuration {
  /** Subscription lapses every 1 day. */
  Daily = 'DAILY',
  /** Subscription lapses on the same day of the next month. */
  Monthly = 'MONTHLY',
  /** Subscription lapses on the same weekday of the following week. */
  Weekly = 'WEEKLY',
  /** Subscription lapses one year from starting date. */
  Yearly = 'YEARLY'
}

/** What the Product provides to the user.  Values values are: content_list, segmentation. */
export enum ProductType {
  /** The product provides a list of content items. */
  ContentList = 'CONTENT_LIST'
}

/** Input type for updating a Product. */
export type ProductUpdateInput = {
  /** Whether the product supports related products */
  allowRelatedProducts?: InputMaybe<Scalars['Boolean']['input']>;
  /** The content items for the Product. */
  contentList?: InputMaybe<Array<ProductContentInput>>;
  /** Currency the product is offered in.  Always USD right now. */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Whether the product is the default product for the company.  Only one product can be the default. */
  default?: InputMaybe<Scalars['Boolean']['input']>;
  /** Product description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Product images. */
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Licensing model for the content/segmentations/etc. attached to the Product.  Values values are: permanent, subscription. */
  licensingType?: InputMaybe<ProductLicensingType>;
  /** Price of the Product in dollars (at whatever frequency the license type requires) */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** What the Product provides to the user.  Values values are: content_list. */
  productType?: InputMaybe<ProductType>;
  /** Whether the product is published and ready for purchase, or still in a draft state. */
  published?: InputMaybe<Scalars['Boolean']['input']>;
  /** Related products */
  relatedProducts?: InputMaybe<Array<Scalars['String']['input']>>;
  /** How long the subscription lasts.  Daily, weekly, monthly, or yearly. */
  subscriptionDuration?: InputMaybe<ProductSubscriptionDuration>;
  /** Product title. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** State of the user as a function of access to Continu. */
export enum ProvisioningStatus {
  /** User has been deleted. */
  Deleting = 'DELETING',
  /** User has been invited. */
  Inviting = 'INVITING',
  /** User has been invited. */
  InvitingMuted = 'INVITING_MUTED',
  /** User is moving from a previous status to invited. */
  MigratingToInviting = 'MIGRATING_TO_INVITING',
  /** User is moving from a previous status to fully enrolled. */
  MigratingToProvisioning = 'MIGRATING_TO_PROVISIONING',
  /** User is moving from a previous status to fully enrolled. */
  MigratingToProvisioningMuted = 'MIGRATING_TO_PROVISIONING_MUTED',
  /** User has been fully enrolled. */
  Provisioning = 'PROVISIONING',
  /** User has been fully enrolled. */
  ProvisioningMuted = 'PROVISIONING_MUTED',
  /** User has been moved from a previous status to invited. */
  Reinviting = 'REINVITING',
  /** User has been reset from a previous status. */
  Resetting = 'RESETTING',
  /** User has been suspended. */
  Suspending = 'SUSPENDING',
  /** User has been unsuspended but not yet invited or provisioned. */
  Unsuspending = 'UNSUSPENDING'
}

/** A model for a purchase of a product by an eligible user. */
export type Purchase = {
  __typename?: 'Purchase';
  /** Card details for the purchase */
  cardDetails?: Maybe<CardDetails>;
  /** The ID of the purchase */
  id: Scalars['ID']['output'];
  /** Scheduled automatic payment */
  nextScheduledPayment?: Maybe<Scalars['DateTime']['output']>;
  /** Payment attempts related to this purchase */
  paymentAttempts: Array<PaymentAttempt>;
  /** Purchased product ID */
  product: Scalars['ID']['output'];
  /** The product purchased. */
  productDetails: Product;
  /** Amount user is billed in USD each productSubscriptionInterval */
  productPrice: Scalars['Float']['output'];
  /** Purchased product name */
  productTitle: Scalars['String']['output'];
  /** The date the purchase was confirmed and activated */
  purchaseConfirmedDate?: Maybe<Scalars['DateTime']['output']>;
  /** The date the user initiated this purchase */
  purchaseInitiatedDate?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the purchase is set to automatically renew on the next scheduled payment */
  recurring: Scalars['Boolean']['output'];
  /** Whether this purchase active and being billed for */
  subscriptionActive: Scalars['Boolean']['output'];
  /** How long the subscription lasts.  Daily, weekly, monthly, or yearly. */
  subscriptionDuration: ProductSubscriptionDuration;
  /** Purchasing user ID */
  user: Scalars['ID']['output'];
  /** Purchasing user's name */
  userName: Scalars['String']['output'];
};

/** A Purchase list container object. */
export type PurchaseContainer = {
  __typename?: 'PurchaseContainer';
  /** A list of edges. */
  edges: Array<PurchaseEdge>;
  /** The pagination details. */
  pageInfo: PageInfo;
};

/** A container for purchases. */
export type PurchaseEdge = {
  __typename?: 'PurchaseEdge';
  /** The cursor for this edge. */
  cursor: Scalars['String']['output'];
  /** The node for this edge. */
  node: Purchase;
};

/** Continu GraphQL Queries */
export type Query = {
  __typename?: 'Query';
  /** Retrieve a list of Assignments by filter criteria. */
  assignments: AssignmentContainer;
  /** Retrieve the number of users returned from an audience filter. */
  audienceCount: AudienceCount;
  /** Retrieve a Badge. */
  badge: Badge;
  /** Retrieve a list of Badge Awards by filter criteria. */
  badgeAwards: BadgeAwardContainer;
  /** Retrieve a list of Badges by filter criteria. */
  badges: BadgeContainer;
  /** Retrieve company base product */
  baseProduct: Product;
  /** Bulk user search by emails. */
  bulkUserSearch: BulkUserRead;
  /** Retrieve a single Company's integration data by their internal ID. */
  companyIntegrations: CompanyIntegration;
  /** Retrieve company user statistics by company ID. */
  companyUserStats: CompanyUserStats;
  /** Retrieve a single content by ID */
  content: Content;
  /** Retrieve a list of Engagements by filter criteria. */
  engagements: EngagementContainer;
  /** Retrieve ai generated description from the provided text. */
  generativeDescription: Scalars['String']['output'];
  /** Retrieve ai generated description using content id. */
  generativeDescriptionById: Scalars['String']['output'];
  /** Retrieve a list of hopefully relevant keywords from the provided text. */
  generativeKeywords: Array<Scalars['String']['output']>;
  /** Retrieve ai generated keyword arguments using content id. */
  generativeKeywordsById: Array<Scalars['String']['output']>;
  /** Retrieve a list of hopefully relevant learning points from the provided text. */
  generativeTopics: Array<Scalars['String']['output']>;
  /** Retrieve a response and references with a provided prompt. */
  getPromptResponse: AiPromptResponse;
  /** Retrieve a user content item from the context id. */
  getUserContent: UserContentFromContext;
  /** Get single UserContentView record. */
  getUserContentView: UserContentView;
  /** Get single Workflow */
  getWorkflow: Workflow;
  /** Retrieve a list of instructors by filter criteria. */
  instructors: InstructorContainer;
  /** List notifications */
  listNotifications: NotificationContainer;
  /** Retrieve a list of groups for segmentation. */
  listSegmentationGroups: GroupContainer;
  /** List UserContentView records by filter criteria. */
  listUserContentViews: UserContentViewContainer;
  /** List Workflows */
  listWorkflows: WorkflowContainer;
  /** Retrieve a single notification by ID. */
  notification: Notification;
  /** Retrieve a single Partner by their internal ID. */
  partner: Partner;
  /** Retrieve a list of Partners by various filtering criteria. */
  partners: PartnerContainer;
  /** Retrieve payment method for purchaser with setup intent */
  paymentMethodDataFromSetupIntent: PaymentMethodGto;
  /** Retrieve payments for purchaser */
  payments: Array<PaymentsGto>;
  /** Retrieve a single Product by ID. */
  product: Product;
  /** Retrieve a list of content by product ID */
  productContentList: Array<ProductContentReadModel>;
  /** Retrieve data for Product charts by date filter criteria. */
  productReport: ProductReportDataContainer;
  /** Retrieve a list of Products by filter criteria. */
  products: ProductContainer;
  /** Retrieve a list of active Purchases by filter criteria. */
  purchases: PurchaseContainer;
  /** Retrieve a single Segmentation by ID. */
  segmentation: SegmentationRead;
  /** Retrieve a list of User by various filtering criteria. */
  segmentations: SegmentationContainer;
  /** Retrieve payment methods for stripe user */
  stripeGetLastCustomerPaymentMethod: StripeRetrievePaymentMethods;
  /** Retrieve a single User by their internal ID. */
  user: User;
  /** Retrieve a list of User by various filtering criteria. */
  users: UserContainer;
  /** Retrieve an overview of company workflows */
  workflowOverview: WorkflowOverview;
  /** Retrieve a single workflow result group by ID. */
  workflowResultGroup: WorkflowResultGroup;
  /** Retrieve a list of workflow result groups by filter criteria. */
  workflowResultGroups: ResultGroupContainer;
  /** Retrieve assignment statistics for a workflow */
  workflowStats: WorkflowStats;
};


/** Continu GraphQL Queries */
export type QueryAssignmentsArgs = {
  assigneeId?: InputMaybe<IdQueryOperatorArgs>;
  assigneeName?: InputMaybe<StringQueryOperatorArgs>;
  assigner?: InputMaybe<IdQueryOperatorArgs>;
  completed?: InputMaybe<BooleanQueryOperatorArgs>;
  completedDate?: InputMaybe<DateQueryOperatorArgs>;
  completionStatus?: InputMaybe<StringQueryOperatorArgs>;
  contentId?: InputMaybe<IdQueryOperatorArgs>;
  createdAt?: InputMaybe<DateQueryOperatorArgs>;
  dueDate?: InputMaybe<DateQueryOperatorArgs>;
  groupId?: InputMaybe<IdQueryOperatorArgs>;
  includeTotalCount?: Scalars['Boolean']['input'];
  ordering?: InputMaybe<Array<OrderBy>>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  unassigned?: InputMaybe<BooleanQueryOperatorArgs>;
  workflowId?: InputMaybe<IdQueryOperatorArgs>;
};


/** Continu GraphQL Queries */
export type QueryAudienceCountArgs = {
  audience: Array<AudienceCountInput>;
};


/** Continu GraphQL Queries */
export type QueryBadgeArgs = {
  id: Scalars['String']['input'];
};


/** Continu GraphQL Queries */
export type QueryBadgeAwardsArgs = {
  acquiredDate?: InputMaybe<DateQueryOperatorArgs>;
  badge?: InputMaybe<IdQueryOperatorArgs>;
  includeTotalCount?: Scalars['Boolean']['input'];
  ordering?: InputMaybe<Array<OrderBy>>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  user?: InputMaybe<IdQueryOperatorArgs>;
};


/** Continu GraphQL Queries */
export type QueryBadgesArgs = {
  id?: InputMaybe<IdQueryOperatorArgs>;
  includeTotalCount?: Scalars['Boolean']['input'];
  ordering?: InputMaybe<Array<OrderBy>>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  title?: InputMaybe<StringQueryOperatorArgs>;
};


/** Continu GraphQL Queries */
export type QueryBulkUserSearchArgs = {
  userEmails: Array<Scalars['String']['input']>;
};


/** Continu GraphQL Queries */
export type QueryContentArgs = {
  contextid?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
  userid: Scalars['String']['input'];
};


/** Continu GraphQL Queries */
export type QueryEngagementsArgs = {
  content?: InputMaybe<IdQueryOperatorArgs>;
  includeTotalCount?: Scalars['Boolean']['input'];
  ordering?: InputMaybe<Array<OrderBy>>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  user?: InputMaybe<IdQueryOperatorArgs>;
};


/** Continu GraphQL Queries */
export type QueryGenerativeDescriptionArgs = {
  persona?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};


/** Continu GraphQL Queries */
export type QueryGenerativeDescriptionByIdArgs = {
  id: Scalars['String']['input'];
  persona?: InputMaybe<Scalars['String']['input']>;
};


/** Continu GraphQL Queries */
export type QueryGenerativeKeywordsArgs = {
  text: Scalars['String']['input'];
};


/** Continu GraphQL Queries */
export type QueryGenerativeKeywordsByIdArgs = {
  id: Scalars['String']['input'];
};


/** Continu GraphQL Queries */
export type QueryGenerativeTopicsArgs = {
  trackid: Scalars['String']['input'];
};


/** Continu GraphQL Queries */
export type QueryGetPromptResponseArgs = {
  prompt: Scalars['String']['input'];
};


/** Continu GraphQL Queries */
export type QueryGetUserContentArgs = {
  contentType: ContentTypes;
  contextId: Scalars['String']['input'];
};


/** Continu GraphQL Queries */
export type QueryGetUserContentViewArgs = {
  id: Scalars['String']['input'];
};


/** Continu GraphQL Queries */
export type QueryGetWorkflowArgs = {
  id: Scalars['String']['input'];
};


/** Continu GraphQL Queries */
export type QueryInstructorsArgs = {
  id?: InputMaybe<IdQueryOperatorArgs>;
  includeTotalCount?: Scalars['Boolean']['input'];
  name?: InputMaybe<StringQueryOperatorArgs>;
  ordering?: InputMaybe<Array<OrderBy>>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
};


/** Continu GraphQL Queries */
export type QueryListNotificationsArgs = {
  id?: InputMaybe<IdQueryOperatorArgs>;
  includeTotalCount?: Scalars['Boolean']['input'];
  ordering?: InputMaybe<Array<OrderBy>>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
};


/** Continu GraphQL Queries */
export type QueryListSegmentationGroupsArgs = {
  id?: InputMaybe<IdQueryOperatorArgs>;
  includeTotalCount?: Scalars['Boolean']['input'];
  name?: InputMaybe<StringQueryOperatorArgs>;
  ordering?: InputMaybe<Array<OrderBy>>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
};


/** Continu GraphQL Queries */
export type QueryListUserContentViewsArgs = {
  contentTitle?: InputMaybe<StringQueryOperatorArgs>;
  contentType?: InputMaybe<StringQueryOperatorArgs>;
  includeTotalCount?: Scalars['Boolean']['input'];
  ordering?: InputMaybe<Array<OrderBy>>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  user?: InputMaybe<IdQueryOperatorArgs>;
};


/** Continu GraphQL Queries */
export type QueryListWorkflowsArgs = {
  contentId?: InputMaybe<IdQueryOperatorArgs>;
  includeTotalCount?: Scalars['Boolean']['input'];
  name?: InputMaybe<StringQueryOperatorArgs>;
  ordering?: InputMaybe<Array<OrderBy>>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  pointInTime?: InputMaybe<BooleanQueryOperatorArgs>;
  userId?: InputMaybe<IdQueryOperatorArgs>;
};


/** Continu GraphQL Queries */
export type QueryNotificationArgs = {
  id: Scalars['String']['input'];
};


/** Continu GraphQL Queries */
export type QueryPartnerArgs = {
  id: Scalars['String']['input'];
};


/** Continu GraphQL Queries */
export type QueryPartnersArgs = {
  id?: InputMaybe<IdQueryOperatorArgs>;
  includeTotalCount?: Scalars['Boolean']['input'];
  name?: InputMaybe<StringQueryOperatorArgs>;
  ordering?: InputMaybe<Array<OrderBy>>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
};


/** Continu GraphQL Queries */
export type QueryPaymentMethodDataFromSetupIntentArgs = {
  setupIntentId: Scalars['String']['input'];
};


/** Continu GraphQL Queries */
export type QueryProductArgs = {
  id: Scalars['String']['input'];
};


/** Continu GraphQL Queries */
export type QueryProductContentListArgs = {
  id: Scalars['String']['input'];
};


/** Continu GraphQL Queries */
export type QueryProductReportArgs = {
  dateFilter?: InputMaybe<DateQueryOperatorArgs>;
  type: Scalars['String']['input'];
};


/** Continu GraphQL Queries */
export type QueryProductsArgs = {
  archived?: BooleanQueryOperatorArgs;
  id?: InputMaybe<IdQueryOperatorArgs>;
  includeTotalCount?: Scalars['Boolean']['input'];
  ordering?: InputMaybe<Array<OrderBy>>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  title?: InputMaybe<StringQueryOperatorArgs>;
};


/** Continu GraphQL Queries */
export type QueryPurchasesArgs = {
  id?: InputMaybe<IdQueryOperatorArgs>;
  includeTotalCount?: Scalars['Boolean']['input'];
  ordering?: InputMaybe<Array<OrderBy>>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  product?: InputMaybe<IdQueryOperatorArgs>;
  purchaseConfirmedDate?: InputMaybe<DateQueryOperatorArgs>;
  subscriptionActive?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<IdQueryOperatorArgs>;
};


/** Continu GraphQL Queries */
export type QuerySegmentationArgs = {
  id: Scalars['String']['input'];
};


/** Continu GraphQL Queries */
export type QuerySegmentationsArgs = {
  id?: InputMaybe<IdQueryOperatorArgs>;
  includeTotalCount?: Scalars['Boolean']['input'];
  name?: InputMaybe<StringQueryOperatorArgs>;
  ordering?: InputMaybe<Array<OrderBy>>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  segmentationType?: InputMaybe<StringQueryOperatorArgs>;
};


/** Continu GraphQL Queries */
export type QueryUserArgs = {
  id: Scalars['String']['input'];
};


/** Continu GraphQL Queries */
export type QueryUsersArgs = {
  email?: InputMaybe<StringQueryOperatorArgs>;
  id?: InputMaybe<IdQueryOperatorArgs>;
  includeTotalCount?: Scalars['Boolean']['input'];
  name?: InputMaybe<StringQueryOperatorArgs>;
  ordering?: InputMaybe<Array<OrderBy>>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  suspended?: InputMaybe<BooleanQueryOperatorArgs>;
};


/** Continu GraphQL Queries */
export type QueryWorkflowResultGroupArgs = {
  id: Scalars['String']['input'];
};


/** Continu GraphQL Queries */
export type QueryWorkflowResultGroupsArgs = {
  assigneeId?: InputMaybe<IdQueryOperatorArgs>;
  contentId?: InputMaybe<IdQueryOperatorArgs>;
  createdAt?: InputMaybe<DateQueryOperatorArgs>;
  includeTotalCount?: Scalars['Boolean']['input'];
  ordering?: InputMaybe<Array<OrderBy>>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  workflow?: InputMaybe<IdQueryOperatorArgs>;
};


/** Continu GraphQL Queries */
export type QueryWorkflowStatsArgs = {
  id: Scalars['String']['input'];
};

/** Assessment questions */
export type QuestionData = {
  __typename?: 'QuestionData';
  /** Options for answer choices */
  choiceOptions?: Maybe<Array<ChoiceOptionData>>;
  /** Question format */
  format?: Maybe<Scalars['String']['output']>;
  /** Question id */
  id?: Maybe<Scalars['String']['output']>;
  /** Page number where question is located */
  page?: Maybe<Scalars['Float']['output']>;
  /** Position of question in assessment */
  position?: Maybe<Scalars['Float']['output']>;
  /** Question */
  question?: Maybe<Scalars['String']['output']>;
  /** Question media link */
  questionAsset?: Maybe<Scalars['String']['output']>;
  /** Question media type */
  questionAssetType?: Maybe<Scalars['String']['output']>;
  /** Options for questions */
  questionOptions?: Maybe<Array<QuestionOptionUnion>>;
  /** Does the question use a rubric for grading? */
  rubricGrading: Scalars['Boolean']['output'];
  /** Options for rubric */
  rubricOptions?: Maybe<Array<RubricOptionData>>;
};

/** Union of types to be returned in question option value */
export type QuestionOptionUnion = BooleanType | NumberType | StringType;

/** Configuration for rating system */
export type RatingConfig = {
  __typename?: 'RatingConfig';
  /** Does content allow edits? */
  allowEdits: Scalars['Boolean']['output'];
  /** Does content allow feedback? */
  allowFeedback: Scalars['Boolean']['output'];
  /** Does content allow rating? */
  allowRating: Scalars['Boolean']['output'];
  /** Messaging information for individuals and slack channels */
  messaging?: Maybe<RatingMessaging>;
  /** Does user receive notification on feedback only? */
  notifyFeedbackOnly: Scalars['Boolean']['output'];
  /** Does content show user ratings? */
  showUsersRating: Scalars['Boolean']['output'];
  /** Total value of rating */
  totalValue: Scalars['Float']['output'];
};

/** Input type for creating a Rating */
export type RatingInput = {
  /** Does content allow edits? */
  allowEdits: Scalars['Boolean']['input'];
  /** Does content allow feedback? */
  allowFeedback: Scalars['Boolean']['input'];
  /** Does content allow rating? */
  allowRating: Scalars['Boolean']['input'];
  /** Messaging information for individuals and slack channels */
  messaging?: InputMaybe<RatingMessagingInput>;
  /** Does user receive notification on feedback only? */
  notifyFeedbackOnly: Scalars['Boolean']['input'];
  /** Does content show user ratings? */
  showUsersRating: Scalars['Boolean']['input'];
  /** Total value of rating */
  totalValue: Scalars['Float']['input'];
};

/** Messaging info for ratings */
export type RatingMessaging = {
  __typename?: 'RatingMessaging';
  /** Individuals */
  individuals: Array<ContentCollaborator>;
  /** Slack channels */
  slackChannels: Array<MessagingSlackChannel>;
};

/** Input type for creating a Rating Messaging object */
export type RatingMessagingInput = {
  /** Individuals */
  individuals: Array<CollaboratorInput>;
  /** Slack channels */
  slackChannels: Array<SlackChannelInput>;
};

/** Assigned content that has been completed. */
export type ReminderMessage = {
  __typename?: 'ReminderMessage';
  /** Notification ID. */
  message: Scalars['ID']['output'];
  /** How many days before reminders are due. */
  timeBeforeDue?: Maybe<Scalars['Float']['output']>;
};

/** A workflow result group container object. */
export type ResultGroupContainer = {
  __typename?: 'ResultGroupContainer';
  /** A list of edges. */
  edges: Array<ResultGroupEdge>;
  /** The pagination details. */
  pageInfo: PageInfo;
};

/** A container for workflow result groups. */
export type ResultGroupEdge = {
  __typename?: 'ResultGroupEdge';
  /** The cursor for this edge. */
  cursor: Scalars['String']['output'];
  /** The node for this edge. */
  node: WorkflowResultGroup;
};

/** Input type for updating an existing Workflow. */
export type ResultGroupUpdateInput = {
  /** The number of days a user has to complete the assignment resulting from a workflow. */
  daysToComplete?: InputMaybe<Scalars['Float']['input']>;
  /** Due Date of the assignment */
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Whether a workflow-created assignment should be due from the time of hire or from assigned date. */
  dueFromHired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the assignment resulting from a workflow response being overdue should escalate to a buddy. */
  escalateBuddy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the assignment resulting from a workflow response being overdue should escalate to the manager. */
  escalateManager?: InputMaybe<Scalars['Boolean']['input']>;
  /** The contacts to notify if the assignment resulting from a workflow is overdue. */
  escalationContacts?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Messages set to send in relation to workflow response. */
  nonReminderMessages?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Messages sent when workflow response is overdue and has reminders set. */
  overdueMessages?: InputMaybe<Array<WorkflowOverdueMessageInput>>;
  /** Messages sent when workflow response is due and has reminders set. */
  reminderMessages?: InputMaybe<Array<WorkflowReminderMessageInput>>;
};

/** Optional settings for rubric */
export type RubricOptionData = {
  __typename?: 'RubricOptionData';
  /** Rubric description */
  description?: Maybe<Scalars['String']['output']>;
  /** ID of rubric */
  id?: Maybe<Scalars['String']['output']>;
  /** Name of rubric */
  name?: Maybe<Scalars['String']['output']>;
  /** Points assigned to question */
  points?: Maybe<Scalars['Float']['output']>;
};

/** Connection details for binding a new Salesforce org to a company. */
export type SalesforceConnect = {
  __typename?: 'SalesforceConnect';
  /** The Continu dashboard URL paired with this Salesforce connection. */
  dashboardUrl?: Maybe<Scalars['String']['output']>;
};

/** Input type for connecting a Salesforce instance. */
export type SalesforceConnectInput = {
  /** The Salesforce identifier to bind to a Continu company. */
  salesforceIdentifier: Scalars['String']['input'];
};

/** Completable content data of journey */
export type SatisfiableEntityData = {
  __typename?: 'SatisfiableEntityData';
  /** Active status of satisfiable content */
  active: Scalars['Boolean']['output'];
  /** User who added the satisfiable content to journey */
  addedBy: Scalars['String']['output'];
  /** Number of days before satisfiable content becomes available */
  availabilityDelayInDays?: Maybe<Scalars['Float']['output']>;
  /** Date satisfiable content was added to journey */
  dateAdded?: Maybe<Scalars['DateTime']['output']>;
  /** Description of satisfiable content */
  description?: Maybe<Scalars['String']['output']>;
  /** Satisfiable content identifier */
  entity: Scalars['String']['output'];
  /** Satisfiable content type */
  entityType: Scalars['String']['output'];
};

/** Information specific to scorm content */
export type ScormExtras = {
  __typename?: 'ScormExtras';
  /** Name of author */
  author?: Maybe<Scalars['String']['output']>;
  /** Description of content */
  description?: Maybe<Scalars['String']['output']>;
  /** Estimated time to complete content */
  duration?: Maybe<Scalars['Float']['output']>;
  /** Additional properties of scorm content */
  properties?: Maybe<Array<ScormProperties>>;
  /** Scorm content view settings */
  sslaConfig: Ssla;
  /** Name of Content */
  title?: Maybe<Scalars['String']['output']>;
};

/** Scorm properties data */
export type ScormProperties = {
  __typename?: 'ScormProperties';
  /** Name of property */
  name?: Maybe<Scalars['String']['output']>;
  /** Value of property */
  value?: Maybe<Scalars['String']['output']>;
};

/** Continu Segmentations provide a method for grouping and providing access controls to content visibility for users. */
export type Segmentation = {
  __typename?: 'Segmentation';
  /** A list of the category IDs of the children of this category. */
  children: Array<Scalars['String']['output']>;
  /** The ID of the segmentation */
  id: Scalars['ID']['output'];
  /** How deep the category is in the tree.  Root categories are 1, their children are 2, etc. */
  level: Scalars['Float']['output'];
  /** Visible name used in the segmentation when translating to a specific language.  Format is <language>:<name>,<language>:<name> */
  localizedNames: Scalars['String']['output'];
  /** Visible name used in the segmentation when localizedNames are not provided. */
  name: Scalars['String']['output'];
  /** A list of the content IDs (articles, media, etc.) of the content items that have a relation to this segmentation. */
  order: Array<Scalars['String']['output']>;
  /** If this category has a parent, the ID of that parent. */
  parent?: Maybe<Scalars['String']['output']>;
  /** Type of segmentation.  Valid values are: category, location, department, team, org_level, grade. */
  segmentationType: Scalars['String']['output'];
  /** Can this segmentation be viewed by external users? */
  showExternal: Scalars['Boolean']['output'];
  /** Category's placement relative to the other children.  Lower numbers come sooner in visual representations of the list. */
  sortOrderIndex: Scalars['Float']['output'];
};

/** A Segmentation connection-like un-paginatable object. */
export type SegmentationConnectionless = {
  __typename?: 'SegmentationConnectionless';
  /** A list of edges. */
  edges: Array<SegmentationEdge>;
};

/** A Segmentation list container object. */
export type SegmentationContainer = {
  __typename?: 'SegmentationContainer';
  /** A list of edges. */
  edges: Array<SegmentationEdge>;
  /** The pagination and cursor details. */
  pageInfo: PageInfo;
};

/** A container for segmentations. */
export type SegmentationEdge = {
  __typename?: 'SegmentationEdge';
  /** The cursor for this edge. */
  cursor: Scalars['String']['output'];
  /** The node for this edge. */
  node: Segmentation;
};

/** Continu Segmentations provide a method for grouping and providing access controls to content visibility for users. */
export type SegmentationRead = {
  __typename?: 'SegmentationRead';
  /** A list of the category IDs of the children of this category. */
  children: Array<Scalars['String']['output']>;
  /** The ID of the segmentation */
  id: Scalars['ID']['output'];
  /** How deep the category is in the tree.  Root categories are 1, their children are 2, etc. */
  level: Scalars['Float']['output'];
  /** Visible name used in the segmentation when translating to a specific language.  Format is <language>:<name>,<language>:<name> */
  localizedNames: Scalars['String']['output'];
  /** Visible name used in the segmentation when localizedNames are not provided. */
  name: Scalars['String']['output'];
  /** A list of the content IDs (articles, media, etc.) of the content items that have a relation to this segmentation. */
  order: Array<Scalars['String']['output']>;
  /** If this category has a parent, the ID of that parent. */
  parent?: Maybe<Scalars['String']['output']>;
  /** Type of segmentation.  Valid values are: category, location, department, team, org_level, grade. */
  segmentationType: Scalars['String']['output'];
  /** Can this segmentation be viewed by external users? */
  showExternal: Scalars['Boolean']['output'];
  /** Category's placement relative to the other children.  Lower numbers come sooner in visual representations of the list. */
  sortOrderIndex: Scalars['Float']['output'];
};

/** Overrideable Workflow settings */
export type SettingsOverrides = {
  /** Delay option for assignments. */
  assignmentOptions?: InputMaybe<AssignmentOptionInput>;
  /** Filters around the audience that receives the workflow response. */
  conditionals?: InputMaybe<Array<WorkflowConditionalInput>>;
  /** The number of days a user has to complete the assignment resulting from a workflow. */
  daysToComplete?: InputMaybe<Scalars['Float']['input']>;
  /** Whether a workflow-created assignment should be due from the time of hire or from assigned date. */
  dueFromHired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the assignment resulting from a workflow response being overdue should escalate to a buddy. */
  escalateBuddy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the assignment resulting from a workflow response being overdue should escalate to the manager. */
  escalateManager?: InputMaybe<Scalars['Boolean']['input']>;
  /** The contacts to notify if the assignment resulting from a workflow is overdue. */
  escalationContacts?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Workflow name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Messages set to send in relation to workflow response. */
  nonReminderMessages?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The number of custom days that triggers the workflow. */
  objectNumber?: InputMaybe<Scalars['Float']['input']>;
  /** The type of event or content completed that triggers the workflow. */
  objectType?: InputMaybe<WorkflowObjectType>;
  /** Messages sent when workflow response is overdue and has reminders set. */
  overdueMessages?: InputMaybe<Array<WorkflowOverdueMessageInput>>;
  /** The permission level (tenant, partner, or both) for the workflow. */
  partnerPermissions?: InputMaybe<PartnerPermissionTypes>;
  /** Messages sent when workflow response is due and has reminders set. */
  reminderMessages?: InputMaybe<Array<WorkflowReminderMessageInput>>;
  /** Whether the workflow-created assignment requires re-completion. */
  requireRecompletion?: InputMaybe<Scalars['Boolean']['input']>;
  /** The action triggered by the workflow. */
  responses?: InputMaybe<Array<WorkflowResponseInput>>;
  /** Email setting options for Shares. */
  shareOptions?: InputMaybe<ShareOptionInput>;
  /** The ID of the event or content that triggers the workflow. */
  triggerObject?: InputMaybe<Scalars['String']['input']>;
  /** Workflow type. */
  type?: InputMaybe<WorkflowType>;
};

/** Options related to the response. */
export type ShareOption = {
  __typename?: 'ShareOption';
  /** Body of the email. */
  emailBody?: Maybe<Scalars['String']['output']>;
  /** The email of the sender. */
  emailFromEmail?: Maybe<Scalars['String']['output']>;
  /** Who the email is from. */
  emailFromName?: Maybe<Scalars['String']['output']>;
  /** The subject of the email. */
  emailSubject?: Maybe<Scalars['String']['output']>;
};

/** Email setting options for Shares. */
export type ShareOptionInput = {
  /** Body of the email. */
  emailBody?: InputMaybe<Scalars['String']['input']>;
  /** The email of the sender. */
  emailFromEmail?: InputMaybe<Scalars['String']['input']>;
  /** Who the email is from. */
  emailFromName?: InputMaybe<Scalars['String']['input']>;
  /** The subject of the email. */
  emailSubject?: InputMaybe<Scalars['String']['input']>;
};

/** Agreement Text and ID of agreement text user is signing off on */
export type SignatureAgreementText = {
  __typename?: 'SignatureAgreementText';
  /** Agreement Text ID */
  id: Scalars['String']['output'];
  /** Agreement Text */
  text: Scalars['String']['output'];
};

/** Input type for creating a slack channel */
export type SlackChannelInput = {
  /** Slack channel identifier */
  id: Scalars['String']['input'];
  /** Slack channel name */
  name: Scalars['String']['input'];
};

/** Scorm content view settings data */
export type Ssla = {
  __typename?: 'Ssla';
  /** Should scorm content open in a new window? */
  openScoInNewWindow?: Maybe<Scalars['Boolean']['output']>;
  /** Scorm content view window height */
  scoWindowHeight?: Maybe<Scalars['Float']['output']>;
  /** Should scorm content fill the screen? */
  scoWindowTryFullscreen?: Maybe<Scalars['Boolean']['output']>;
  /** Scorm content view window width */
  scoWindowWidth?: Maybe<Scalars['Float']['output']>;
};

/** A general matcher for types that are string-like. */
export type StringQueryOperatorArgs = {
  /** A value that will be matched as a single word somewhere in the string. */
  contains?: InputMaybe<Scalars['String']['input']>;
  /** A list of values that will be matched as a single word somewhere in the string. */
  containsIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A specific single value to match. */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** A list of values to match. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Question option value is of type string */
export type StringType = {
  __typename?: 'StringType';
  /** Name of question option setting */
  name?: Maybe<Scalars['String']['output']>;
  /** Value is a string */
  value?: Maybe<Scalars['String']['output']>;
};

/** Input type for configuring a Stripe account to work with the current tenant. */
export type StripeCompleteAccount = {
  /** Account ID from Stripe. */
  account: Scalars['String']['input'];
  /** Verification Token to confirm account registration from Stripe. */
  verificationToken: Scalars['String']['input'];
};

/** Setup state for initiating Stripe account creation. */
export type StripeInitiateAccount = {
  __typename?: 'StripeInitiateAccount';
  /** Setup URL for initiating Stripe account creation. */
  url: Scalars['String']['output'];
};

/** Initial payment method responses from Stripe setup. */
export type StripeInitiatePaymentMethodCreation = {
  __typename?: 'StripeInitiatePaymentMethodCreation';
  /** The client secret for the payment method creation. */
  clientSecret: Scalars['String']['output'];
  /** The Stripe payment method identifier. */
  id: Scalars['ID']['output'];
};

/** Integration for Stripe for Ecommerce */
export type StripeIntegrationData = {
  __typename?: 'StripeIntegrationData';
  /** Account Id provided by Stripe */
  account: Scalars['String']['output'];
  /** Account Token for verifying Stripe account between our services */
  accountVerificationToken: Scalars['String']['output'];
  /** Date verified */
  verifiedOn: Scalars['DateTime']['output'];
};

/** Input type for submitting a one time payment to Stripe */
export type StripePaymentData = {
  /** Cost of product */
  amount: Scalars['Float']['input'];
  /** Method Id for Selected Payment */
  paymentMethodId: Scalars['String']['input'];
  /** ID of product being purchased */
  productId: Scalars['String']['input'];
};

/** The status of a payment attempt */
export type StripePaymentStatus = {
  __typename?: 'StripePaymentStatus';
  /** Status of stripe payment attempt. */
  status: Scalars['String']['output'];
};

/** Stripe Accounts */
export type StripeRetrievePaymentMethods = {
  __typename?: 'StripeRetrievePaymentMethods';
  /** ID of most recently added payment method. */
  paymentId: Scalars['String']['output'];
};

/** The ID of a successfully created subscription */
export type StripeSubscriptionId = {
  __typename?: 'StripeSubscriptionID';
  /** The returned ID from a newly created subscription  */
  id: Scalars['String']['output'];
};

/** Input type for a subscription */
export type SubscriptionData = {
  /** ID of product */
  productId: Scalars['String']['input'];
};

/** Input type for updating payment attached to a subscription */
export type SubscriptionUpdatePaymentData = {
  /** ID of the Stripe Setup Intent */
  stripeSetupIntentId: Scalars['String']['input'];
  /** Continu ID of subscription */
  subscriptionId: Scalars['String']['input'];
};

/** Input type for creating a survey */
export type SurveyInput = {
  /** Survey ID */
  id: Scalars['String']['input'];
  /** Survey title */
  title: Scalars['String']['input'];
};

/** The different states of text generation progress */
export enum TextGenerationStatus {
  /** Text generation has completed */
  Completed = 'COMPLETED',
  /** Text generation has failed */
  Failed = 'FAILED',
  /** Text generation is in progress */
  InProgress = 'IN_PROGRESS'
}

/** Data of courses in track section */
export type TrackCourse = {
  __typename?: 'TrackCourse';
  /** Has user completed this course? */
  complete?: Maybe<Scalars['Boolean']['output']>;
  /** ID of track course content */
  id: Scalars['String']['output'];
  /** Position of course */
  position: Scalars['Float']['output'];
  /** Name of course */
  title: Scalars['String']['output'];
  /** Content type of track course */
  type: Scalars['String']['output'];
};

/** Information specific to track content */
export type TrackExtras = {
  __typename?: 'TrackExtras';
  /** Name of author */
  author?: Maybe<Scalars['String']['output']>;
  /** Description of content */
  description?: Maybe<Scalars['String']['output']>;
  /** Draft state of content */
  draft: Scalars['Boolean']['output'];
  /** Instructor Information */
  instructors: Array<InstructorReadModel>;
  /** Main learning objectives */
  learnItems?: Maybe<Array<Scalars['String']['output']>>;
  /** Should progress be diabled until SCORM course is complete? */
  lockScorm: Scalars['Boolean']['output'];
  /** Is the purpose of the track to serve as a source of information? */
  resource: Scalars['Boolean']['output'];
  /** Track section */
  sections?: Maybe<Array<TrackSectionData>>;
  /** Does track need to be completed in sequential order? */
  sequential: Scalars['Boolean']['output'];
  /** Name of Content */
  title?: Maybe<Scalars['String']['output']>;
};

/** Data contained in track section */
export type TrackSectionData = {
  __typename?: 'TrackSectionData';
  /** Has user completed this track section? */
  complete?: Maybe<Scalars['Boolean']['output']>;
  /** Courses in the track section */
  courses?: Maybe<Array<TrackCourse>>;
  /** Desccription of track section */
  description?: Maybe<Scalars['String']['output']>;
  /** ID of track section */
  id: Scalars['String']['output'];
  /** Name of track section */
  name: Scalars['String']['output'];
  /** Position of track section in series */
  position: Scalars['Float']['output'];
};

/** A user with potential access to the Continu LMS and adjacent products. */
export type User = {
  __typename?: 'User';
  /** General description of the user. */
  about?: Maybe<Scalars['String']['output']>;
  /** ID of the access profile this user is subscribed to. */
  accessProfile?: Maybe<Scalars['String']['output']>;
  /** Address. */
  address?: Maybe<Scalars['String']['output']>;
  /** Dashboard banner image. */
  bannerImage?: Maybe<Scalars['String']['output']>;
  /** User's birthday. */
  birthday?: Maybe<Scalars['DateTime']['output']>;
  /** Email address tos end notifications to for workflows that involve buddy contact. */
  buddyEmail?: Maybe<Scalars['String']['output']>;
  /** Retrieve user content statistics by user ID. */
  contentStats: UserContentStats;
  /** User's country. */
  country?: Maybe<Scalars['String']['output']>;
  /** Textual description of user's department.  For segmentation by department, see `linked_department`. */
  department?: Maybe<Scalars['String']['output']>;
  /** Distributor. */
  distributor?: Maybe<Scalars['String']['output']>;
  /** User's education. */
  education?: Maybe<Scalars['String']['output']>;
  /** Email address. */
  email: Scalars['String']['output'];
  /** Date of the first time the user logged into the system. */
  firstLogin: Scalars['DateTime']['output'];
  /** First name. */
  firstName: Scalars['String']['output'];
  /** Full name. */
  fullName?: Maybe<Scalars['String']['output']>;
  /** Gender. */
  gender?: Maybe<Scalars['String']['output']>;
  /** Google access token for user authorization. */
  googleAccessToken?: Maybe<Scalars['String']['output']>;
  /** Google Auth ID. */
  googleAuthId?: Maybe<Scalars['String']['output']>;
  /** Configuration for integration with Google Meets. */
  googleMeets?: Maybe<UserGoogleMeets>;
  /** Google refresh token to create a new access token. */
  googleRefreshToken?: Maybe<Scalars['String']['output']>;
  /** Expiration date of the Google access token. */
  googleTokenExpiry?: Maybe<Scalars['String']['output']>;
  /** Group (textual only).  Not a group segmentation ID, see `groups` for those. */
  group?: Maybe<Scalars['String']['output']>;
  /** IDs of group segmentations the user is included in. */
  groups?: Maybe<Array<Scalars['ID']['output']>>;
  /** Hipchat ID. */
  hipchat?: Maybe<Scalars['String']['output']>;
  /** Hired date. */
  hired?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier for the user. */
  id: Scalars['ID']['output'];
  /** Avatar image. */
  image?: Maybe<Scalars['String']['output']>;
  /** Can this user create content? */
  isCollaborator: Scalars['Boolean']['output'];
  /** Indicates if user has manager-level access to the system. */
  isManager: Scalars['Boolean']['output'];
  /** Can the user purchase content? */
  isPurchaser?: Maybe<Scalars['Boolean']['output']>;
  /** Job title. */
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** Job type. */
  jobType?: Maybe<Scalars['String']['output']>;
  /** Default language for UI messaging and display. */
  language?: Maybe<Scalars['String']['output']>;
  /** Date of the last time the user logged into the system. */
  lastLogin: Scalars['DateTime']['output'];
  /** Last name. */
  lastName: Scalars['String']['output'];
  /** Date of the last time the user was sent an onboarding email to Continu. */
  lastOnboardingEmail: Scalars['DateTime']['output'];
  /** Last date the user was sent a reminder email from any notification. */
  lastRemindedEmail: Scalars['DateTime']['output'];
  /** IDs of department segmentations the user is included in. */
  linkedDepartments?: Maybe<Array<Scalars['ID']['output']>>;
  /** ID of a grade segmentation the user is included in. */
  linkedGrade?: Maybe<Scalars['String']['output']>;
  /** IDs of location segmentations the user is included in. */
  linkedLocations?: Maybe<Array<Scalars['ID']['output']>>;
  /** ID of an org level segmentation the user is included in. */
  linkedOrgLevel?: Maybe<Scalars['String']['output']>;
  /** ID of a team segmentation the user is included in. */
  linkedTeams?: Maybe<Array<Scalars['ID']['output']>>;
  /** LinkedIn ID. */
  linkedin?: Maybe<Scalars['String']['output']>;
  /** Contains the user-specific set of permissions available if the user is marked as a manager. */
  managerConfiguration?: Maybe<UserManagerConfiguration>;
  /** Email address to send notifications to for workflows that involve manager contact. */
  managerEmail?: Maybe<Scalars['String']['output']>;
  /** Segmentation groups this user is a manager of. */
  managingGroups?: Maybe<Array<Scalars['ID']['output']>>;
  /** Storage for custom fields data for this user. */
  metadata?: Maybe<Array<UserMetadataEntry>>;
  /** Integration details for Microsoft Teams. */
  microsoftTeamsConfig?: Maybe<UserMicrosoftTeams>;
  /** Has user established connection with Microsoft Teams? */
  microsoftTeamsIntegrated?: Maybe<Scalars['Boolean']['output']>;
  /** Is the user a new hire? */
  newHire?: Maybe<Scalars['Boolean']['output']>;
  /** Notes about user. */
  notes?: Maybe<Scalars['String']['output']>;
  /** Office location. */
  officeLocation?: Maybe<Scalars['String']['output']>;
  /** Partner ID. */
  partner?: Maybe<Scalars['String']['output']>;
  /** Shared secret for user to be verified as part of invite process. */
  provisioningKey?: Maybe<Scalars['String']['output']>;
  /** Current state of the user's ability to register and interact with our system. */
  provisioningStatus: ProvisioningStatus;
  /** Region. */
  region?: Maybe<Scalars['String']['output']>;
  /** Level of permission the user has in the system. */
  role: UserRole;
  /** All of the linked segmentations this user is associated with, in a hydrated and explorable format. */
  segmentations: SegmentationConnectionless;
  /** List of tags indicating user's known skills. */
  skills?: Maybe<Array<Scalars['String']['output']>>;
  /** Slack integration token. */
  slackDc?: Maybe<Scalars['String']['output']>;
  /** User's identifier on their Slack instance. */
  slackId?: Maybe<Scalars['String']['output']>;
  /** Last time a Slack notification was attempted. */
  slackLastAttempt: Scalars['DateTime']['output'];
  /**
   * Link to a social site related to this user.
   * @deprecated Replaced by socialLinks.
   */
  socialLink?: Maybe<Scalars['String']['output']>;
  /** Key/value for store for identifiers for social sharing sites. */
  socialLinks?: Maybe<Array<UserSocialLink>>;
  /** Can the user log in and use Continu?  If true, the user is suspended and cannot log in. */
  suspended?: Maybe<Scalars['Boolean']['output']>;
  /** Date the user was suspended on. */
  suspendedOn?: Maybe<Scalars['DateTime']['output']>;
  /** User's local timezone. */
  timezone?: Maybe<Scalars['String']['output']>;
  /** User token. */
  token?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the user from another platform/data source.  These must be unique for all users in a company. */
  userid?: Maybe<Scalars['String']['output']>;
};


/** A user with potential access to the Continu LMS and adjacent products. */
export type UserContentStatsArgs = {
  id: Scalars['String']['input'];
};

/** A User list container object. */
export type UserContainer = {
  __typename?: 'UserContainer';
  /** A list of edges. */
  edges: Array<UserEdge>;
  /** The pagination and cursor details. */
  pageInfo: PageInfo;
};

/** User Content record */
export type UserContentFromContext = {
  __typename?: 'UserContentFromContext';
  /** Completion/Satisifed status of user content */
  satisfied: Scalars['Boolean']['output'];
};

/** The content statistics for a user. */
export type UserContentStats = {
  __typename?: 'UserContentStats';
  /** Number of assignment notifications sent to this user. */
  assignmentNotifications: Scalars['Float']['output'];
  /** Unique assignment count (not unique assigned contents) for user. */
  assignments: Scalars['Float']['output'];
  /** Awarded badge count. */
  awardedBadges: Scalars['Float']['output'];
  /** Total content views (including duplicate views). */
  contentViews: Scalars['Float']['output'];
  /** Number of engaged-in + assigned learning tracks. */
  learningTracks: Scalars['Float']['output'];
  /** Number of workshop instances the user did any of the following: enrolled in, engaged in, attended, did not attend, has not yet attended, and any other valid workshop instance state. */
  workshopInstances: Scalars['Float']['output'];
};

/** A view record of a user and a piece of content. */
export type UserContentView = {
  __typename?: 'UserContentView';
  /** The content id, title, and type. */
  content: ContentListItemInstance;
  /** Creation date of the view record. */
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the UserContentView record */
  id: Scalars['ID']['output'];
  /** User who viewed the content. */
  user: UserListItemInstance;
};

/** An UserContentView list container object. */
export type UserContentViewContainer = {
  __typename?: 'UserContentViewContainer';
  /** A list of edges. */
  edges: Array<UserContentViewEdge>;
  /** The pagination details. */
  pageInfo: PageInfo;
};

/** Input type for creating a new UserContentView. */
export type UserContentViewCreateInput = {
  /** The ID of the content that was viewed. This links the view to a specific piece of content. */
  contentId: Scalars['String']['input'];
  /** The ContentType of the content that was viewed. This indicates the type of content (e.g., article, video, etc.). */
  contentType: ContentTypes;
};

/** A container for UserContentView objects. */
export type UserContentViewEdge = {
  __typename?: 'UserContentViewEdge';
  /** The cursor for this edge. */
  cursor: Scalars['String']['output'];
  /** The node for this edge. */
  node: UserContentView;
};

/** Input type for creating a new User. */
export type UserCreateInput = {
  /** General description of the user. */
  about?: InputMaybe<Scalars['String']['input']>;
  /** ID of the access profile this user is subscribed to. */
  accessProfile?: InputMaybe<Scalars['String']['input']>;
  /** Address. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Dashboard banner image. */
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  /** User's birthday. */
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  /** Email address tos end notifications to for workflows that involve buddy contact. */
  buddyEmail?: InputMaybe<Scalars['String']['input']>;
  /** User's country. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Textual description of user's department.  For segmentation by department, see `linked_department`. */
  department?: InputMaybe<Scalars['String']['input']>;
  /** Distributor. */
  distributor?: InputMaybe<Scalars['String']['input']>;
  /** User's education. */
  education?: InputMaybe<Scalars['String']['input']>;
  /** Email address. */
  email: Scalars['String']['input'];
  /** First name. */
  firstName: Scalars['String']['input'];
  /** Full name. */
  fullName?: InputMaybe<Scalars['String']['input']>;
  /** Gender. */
  gender?: InputMaybe<Scalars['String']['input']>;
  /** Google access token for user authorization. */
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  /** Google Auth ID. */
  googleAuthId?: InputMaybe<Scalars['String']['input']>;
  /** Configuration for integration with Google Meets. */
  googleMeets?: InputMaybe<UserGoogleMeetsInput>;
  /** Google refresh token to create a new access token. */
  googleRefreshToken?: InputMaybe<Scalars['String']['input']>;
  /** Expiration date of the Google access token. */
  googleTokenExpiry?: InputMaybe<Scalars['String']['input']>;
  /** Group (textual only).  Not a group segmentation ID, see `groups` for those. */
  group?: InputMaybe<Scalars['String']['input']>;
  /** IDs of group segmentations the user is included in. */
  groups?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Hipchat ID. */
  hipchat?: InputMaybe<Scalars['String']['input']>;
  /** Hired date. */
  hired?: InputMaybe<Scalars['DateTime']['input']>;
  /** Avatar image. */
  image?: InputMaybe<Scalars['String']['input']>;
  /** Can this user create content? */
  isCollaborator?: Scalars['Boolean']['input'];
  /** Indicates if user has manager-level access to the system. */
  isManager?: Scalars['Boolean']['input'];
  /** Can the user purchase content? */
  isPurchaser?: InputMaybe<Scalars['Boolean']['input']>;
  /** Job title. */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Job type. */
  jobType?: InputMaybe<Scalars['String']['input']>;
  /** Default language for UI messaging and display. */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Last name. */
  lastName: Scalars['String']['input'];
  /** IDs of department segmentations the user is included in. */
  linkedDepartments?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ID of a grade segmentation the user is included in. */
  linkedGrade?: InputMaybe<Scalars['String']['input']>;
  /** IDs of location segmentations the user is included in. */
  linkedLocations?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ID of an org level segmentation the user is included in. */
  linkedOrgLevel?: InputMaybe<Scalars['String']['input']>;
  /** ID of a team segmentation the user is included in. */
  linkedTeams?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** LinkedIn ID. */
  linkedin?: InputMaybe<Scalars['String']['input']>;
  /** Contains the user-specific set of permissions available if the user is marked as a manager. */
  managerConfiguration?: InputMaybe<UserManagerConfigurationInput>;
  /** Email address to send notifications to for workflows that involve manager contact. */
  managerEmail?: InputMaybe<Scalars['String']['input']>;
  /** Segmentation groups this user is a manager of. */
  managingGroups?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Storage for custom fields data for this user. */
  metadata?: InputMaybe<Array<UserMetadataEntryInput>>;
  /** Integration details for Microsoft Teams. */
  microsoftTeamsConfig?: InputMaybe<UserMicrosoftTeamsInput>;
  /** Has user established connection with Microsoft Teams? */
  microsoftTeamsIntegrated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is the user a new hire? */
  newHire?: InputMaybe<Scalars['Boolean']['input']>;
  /** Notes about user. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Office location. */
  officeLocation?: InputMaybe<Scalars['String']['input']>;
  /** Partner ID. */
  partner?: InputMaybe<Scalars['String']['input']>;
  /** Shared secret for user to be verified as part of invite process. */
  provisioningKey?: InputMaybe<Scalars['String']['input']>;
  /** Current state of the user's ability to register and interact with our system. */
  provisioningStatus: ProvisioningStatus;
  /** Region. */
  region?: InputMaybe<Scalars['String']['input']>;
  /** Level of permission the user has in the system. */
  role: UserRole;
  /** List of tags indicating user's known skills. */
  skills?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Slack integration token. */
  slackDc?: InputMaybe<Scalars['String']['input']>;
  /** User's identifier on their Slack instance. */
  slackId?: InputMaybe<Scalars['String']['input']>;
  /** Link to a social site related to this user. */
  socialLink?: InputMaybe<Scalars['String']['input']>;
  /** Key/value for store for identifiers for social sharing sites. */
  socialLinks?: InputMaybe<Array<UserSocialLinkInput>>;
  /** Can the user log in and use Continu?  If true, the user is suspended and cannot log in. */
  suspended?: InputMaybe<Scalars['Boolean']['input']>;
  /** Date the user was suspended on. */
  suspendedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** User's local timezone. */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** User token. */
  token?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the user from another platform/data source.  These must be unique for all users in a company. */
  userid?: InputMaybe<Scalars['String']['input']>;
};

/** A container for users. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** The cursor for this edge. */
  cursor: Scalars['String']['output'];
  /** The node for this edge. */
  node: User;
};

/** User-specific configuration items for Google Meets integrations. */
export type UserGoogleMeets = {
  __typename?: 'UserGoogleMeets';
  /** Google Meets access token to authenticate the user. */
  accessToken: Scalars['String']['output'];
  /** Expiration date of the Google Meet access token. */
  expiryDate: Scalars['Float']['output'];
  /** Google Meets redirect URI to redirect the user to after authentication. */
  redirectUri: Scalars['String']['output'];
  /** Google Meets refresh token to refresh the access token. */
  refreshToken: Scalars['String']['output'];
  /** Google Meets OAuth scope. */
  scope: Scalars['String']['output'];
  /** Google Meet OAuth token type. */
  tokenType: Scalars['String']['output'];
};

/** User-specific configuration items for Google Meets integrations. */
export type UserGoogleMeetsInput = {
  /** Google Meets access token to authenticate the user. */
  accessToken: Scalars['String']['input'];
  /** Expiration date of the Google Meet access token. */
  expiryDate: Scalars['Float']['input'];
  /** Google Meets redirect URI to redirect the user to after authentication. */
  redirectUri: Scalars['String']['input'];
  /** Google Meets refresh token to refresh the access token. */
  refreshToken: Scalars['String']['input'];
  /** Google Meets OAuth scope. */
  scope: Scalars['String']['input'];
  /** Google Meet OAuth token type. */
  tokenType: Scalars['String']['input'];
};

/** A user with minimal fields for it to be displayed on a list. */
export type UserListItemInstance = {
  __typename?: 'UserListItemInstance';
  /** Email address. */
  email: Scalars['String']['output'];
  /** First name. */
  firstName: Scalars['String']['output'];
  /** Unique identifier for the user. */
  id: Scalars['ID']['output'];
  /** Last name. */
  lastName: Scalars['String']['output'];
  /** Level of permission the user has in the system. */
  role: UserRole;
  /** A unique identifier for the user from another platform/data source.  These must be unique for all users in a company. */
  userid?: Maybe<Scalars['String']['output']>;
};

/** Configuration of the manager's capabilities. */
export type UserManagerConfiguration = {
  __typename?: 'UserManagerConfiguration';
  /** Can this manager add managers to the system? */
  allowAddingGroupManager: Scalars['Boolean']['output'];
  /** Can this user suspend a direct report? */
  allowDirectReportSuspension: Scalars['Boolean']['output'];
  /** Can this user force a password reset on a direct report? */
  allowPasswordReset: Scalars['Boolean']['output'];
  /** Can this manager create users? */
  allowUserCreation: Scalars['Boolean']['output'];
  /** Can this manager edit direct report's user records? */
  allowUserEdit: Scalars['Boolean']['output'];
  /** Can this manager view completions of direct report's assignments? */
  disableAssignmentCompletion: Scalars['Boolean']['output'];
  /** Can this manager edit direct report's assignments? */
  disableAssignmentEdit: Scalars['Boolean']['output'];
  /** Can this manager remove direct report's assignments? */
  disableAssignmentRemoval: Scalars['Boolean']['output'];
  /** Can this manager view direct report's assignments? */
  disableAssignments: Scalars['Boolean']['output'];
  /** Can this user see groups they do not manage? */
  hideNonManagingGroups: Scalars['Boolean']['output'];
  /** Options that can be hidden from a manager when configuring user segmentations. */
  hideOptions: Array<ManagerConfigurationHideOptions>;
  /** List of fields that cannot be edited by this manager. */
  restrictedEditableFields: Array<Scalars['String']['output']>;
  /** Can this manager edit direct report's user records? */
  restrictedUserEdit: Scalars['Boolean']['output'];
  /** Segmentations that must be applied to manager's users. */
  segmentationRequired: Array<Scalars['ID']['output']>;
  /** Available segmentations the manager can interact with for their reports. */
  segmentationSubset: Array<Scalars['ID']['output']>;
};

/** Configuration of the manager's capabilities. */
export type UserManagerConfigurationInput = {
  /** Can this manager add managers to the system? */
  allowAddingGroupManager: Scalars['Boolean']['input'];
  /** Can this user suspend a direct report? */
  allowDirectReportSuspension: Scalars['Boolean']['input'];
  /** Can this user force a password reset on a direct report? */
  allowPasswordReset: Scalars['Boolean']['input'];
  /** Can this manager create users? */
  allowUserCreation: Scalars['Boolean']['input'];
  /** Can this manager edit direct report's user records? */
  allowUserEdit: Scalars['Boolean']['input'];
  /** Can this manager view completions of direct report's assignments? */
  disableAssignmentCompletion: Scalars['Boolean']['input'];
  /** Can this manager edit direct report's assignments? */
  disableAssignmentEdit: Scalars['Boolean']['input'];
  /** Can this manager remove direct report's assignments? */
  disableAssignmentRemoval: Scalars['Boolean']['input'];
  /** Can this manager view direct report's assignments? */
  disableAssignments: Scalars['Boolean']['input'];
  /** Can this user see groups they do not manage? */
  hideNonManagingGroups: Scalars['Boolean']['input'];
  /** Options that can be hidden from a manager when configuring user segmentations. */
  hideOptions: Array<ManagerConfigurationHideOptions>;
  /** List of fields that cannot be edited by this manager. */
  restrictedEditableFields: Array<Scalars['String']['input']>;
  /** Can this manager edit direct report's user records? */
  restrictedUserEdit: Scalars['Boolean']['input'];
  /** Segmentations that must be applied to manager's users. */
  segmentationRequired: Array<Scalars['ID']['input']>;
  /** Available segmentations the manager can interact with for their reports. */
  segmentationSubset: Array<Scalars['ID']['input']>;
};

/** Custom fields user-specific value store. */
export type UserMetadataEntry = {
  __typename?: 'UserMetadataEntry';
  /** Custom field name. */
  key: Scalars['String']['output'];
  /** Custom field value. */
  value: Scalars['String']['output'];
};

/** Custom fields user-specific value store. */
export type UserMetadataEntryInput = {
  /** Custom field name. */
  key: Scalars['String']['input'];
  /** Custom field value. */
  value: Scalars['String']['input'];
};

/** User-specific configuration items for Microsoft Teams integrations. */
export type UserMicrosoftTeams = {
  __typename?: 'UserMicrosoftTeams';
  /** Microsoft teams authorization token. */
  authCode: Scalars['String']['output'];
  /** Microsoft teams refresh token to refresh the authorization token. */
  refreshToken: Scalars['String']['output'];
};

/** User-specific configuration items for Microsoft Teams integrations. */
export type UserMicrosoftTeamsInput = {
  /** Microsoft teams authorization token. */
  authCode: Scalars['String']['input'];
  /** Microsoft teams refresh token to refresh the authorization token. */
  refreshToken: Scalars['String']['input'];
};

/** Permission levels available to users in the system. */
export enum UserRole {
  /** Role allows full access to the system */
  Admin = 'ADMIN',
  /** Role allows student-level access to the system and the ability to create content. */
  Creator = 'CREATOR',
  /** Role only allows student-level access to the system. */
  User = 'USER'
}

/** Social link service storage for user identifiers. */
export type UserSocialLink = {
  __typename?: 'UserSocialLink';
  /** The social link service name. */
  name: Scalars['String']['output'];
  /** The social link service URL or other relevant identifer. */
  value: Scalars['String']['output'];
};

/** Social link service storage for user identifiers. */
export type UserSocialLinkInput = {
  /** The social link service name. */
  name: Scalars['String']['input'];
  /** The social link service URL or other relevant identifer. */
  value: Scalars['String']['input'];
};

/** Input type for updating a User. */
export type UserUpdateInput = {
  /** General description of the user. */
  about?: InputMaybe<Scalars['String']['input']>;
  /** ID of the access profile this user is subscribed to. */
  accessProfile?: InputMaybe<Scalars['String']['input']>;
  /** Address. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Dashboard banner image. */
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  /** User's birthday. */
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  /** Email address tos end notifications to for workflows that involve buddy contact. */
  buddyEmail?: InputMaybe<Scalars['String']['input']>;
  /** User's country. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Textual description of user's department.  For segmentation by department, see `linked_department`. */
  department?: InputMaybe<Scalars['String']['input']>;
  /** Distributor. */
  distributor?: InputMaybe<Scalars['String']['input']>;
  /** User's education. */
  education?: InputMaybe<Scalars['String']['input']>;
  /** Email address. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Full name. */
  fullName?: InputMaybe<Scalars['String']['input']>;
  /** Gender. */
  gender?: InputMaybe<Scalars['String']['input']>;
  /** Google access token for user authorization. */
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  /** Google Auth ID. */
  googleAuthId?: InputMaybe<Scalars['String']['input']>;
  /** Configuration for integration with Google Meets. */
  googleMeets?: InputMaybe<UserGoogleMeetsInput>;
  /** Google refresh token to create a new access token. */
  googleRefreshToken?: InputMaybe<Scalars['String']['input']>;
  /** Expiration date of the Google access token. */
  googleTokenExpiry?: InputMaybe<Scalars['String']['input']>;
  /** Group (textual only).  Not a group segmentation ID, see `groups` for those. */
  group?: InputMaybe<Scalars['String']['input']>;
  /** IDs of group segmentations the user is included in. */
  groups?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Hipchat ID. */
  hipchat?: InputMaybe<Scalars['String']['input']>;
  /** Hired date. */
  hired?: InputMaybe<Scalars['DateTime']['input']>;
  /** Avatar image. */
  image?: InputMaybe<Scalars['String']['input']>;
  /** Can this user create content? */
  isCollaborator?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if user has manager-level access to the system. */
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  /** Can the user purchase content? */
  isPurchaser?: InputMaybe<Scalars['Boolean']['input']>;
  /** Job title. */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Job type. */
  jobType?: InputMaybe<Scalars['String']['input']>;
  /** Default language for UI messaging and display. */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** IDs of department segmentations the user is included in. */
  linkedDepartments?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ID of a grade segmentation the user is included in. */
  linkedGrade?: InputMaybe<Scalars['String']['input']>;
  /** IDs of location segmentations the user is included in. */
  linkedLocations?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ID of an org level segmentation the user is included in. */
  linkedOrgLevel?: InputMaybe<Scalars['String']['input']>;
  /** ID of a team segmentation the user is included in. */
  linkedTeams?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** LinkedIn ID. */
  linkedin?: InputMaybe<Scalars['String']['input']>;
  /** Contains the user-specific set of permissions available if the user is marked as a manager. */
  managerConfiguration?: InputMaybe<UserManagerConfigurationInput>;
  /** Email address to send notifications to for workflows that involve manager contact. */
  managerEmail?: InputMaybe<Scalars['String']['input']>;
  /** Segmentation groups this user is a manager of. */
  managingGroups?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Storage for custom fields data for this user. */
  metadata?: InputMaybe<Array<UserMetadataEntryInput>>;
  /** Integration details for Microsoft Teams. */
  microsoftTeamsConfig?: InputMaybe<UserMicrosoftTeamsInput>;
  /** Has user established connection with Microsoft Teams? */
  microsoftTeamsIntegrated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is the user a new hire? */
  newHire?: InputMaybe<Scalars['Boolean']['input']>;
  /** Notes about user. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Office location. */
  officeLocation?: InputMaybe<Scalars['String']['input']>;
  /** Partner ID. */
  partner?: InputMaybe<Scalars['String']['input']>;
  /** Shared secret for user to be verified as part of invite process. */
  provisioningKey?: InputMaybe<Scalars['String']['input']>;
  /** Current state of the user's ability to register and interact with our system. */
  provisioningStatus?: InputMaybe<ProvisioningStatus>;
  /** Region. */
  region?: InputMaybe<Scalars['String']['input']>;
  /** Level of permission the user has in the system. */
  role?: InputMaybe<UserRole>;
  /** List of tags indicating user's known skills. */
  skills?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Slack integration token. */
  slackDc?: InputMaybe<Scalars['String']['input']>;
  /** User's identifier on their Slack instance. */
  slackId?: InputMaybe<Scalars['String']['input']>;
  /** Link to a social site related to this user. */
  socialLink?: InputMaybe<Scalars['String']['input']>;
  /** Key/value for store for identifiers for social sharing sites. */
  socialLinks?: InputMaybe<Array<UserSocialLinkInput>>;
  /** Can the user log in and use Continu?  If true, the user is suspended and cannot log in. */
  suspended?: InputMaybe<Scalars['Boolean']['input']>;
  /** Date the user was suspended on. */
  suspendedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** User's local timezone. */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** User token. */
  token?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the user from another platform/data source.  These must be unique for all users in a company. */
  userid?: InputMaybe<Scalars['String']['input']>;
};

/** Data specific to videos */
export type VideoExtras = {
  __typename?: 'VideoExtras';
  /** Name of author */
  author?: Maybe<Scalars['String']['output']>;
  /** Description of content */
  description?: Maybe<Scalars['String']['output']>;
  /** Draft state of content */
  draft: Scalars['Boolean']['output'];
  /** Estimated time to complete content */
  duration?: Maybe<Scalars['Float']['output']>;
  /** Link to media */
  link: Scalars['String']['output'];
  /** Content source */
  source?: Maybe<Scalars['String']['output']>;
  /** Source identifier */
  sourceId?: Maybe<Scalars['String']['output']>;
  /** Identifier of AI text generation job */
  textGenerationJob?: Maybe<Scalars['String']['output']>;
  /** Status of AI text generation */
  textGenerationStatus?: Maybe<TextGenerationStatus>;
  /** Name of Content */
  title?: Maybe<Scalars['String']['output']>;
  /** Is video transcoding? */
  transcoding: Scalars['Boolean']['output'];
  /** AI generated transcript for media */
  transcript?: Maybe<Scalars['String']['output']>;
  /** Does media use generative ai? */
  useGenerativeAi?: Maybe<Scalars['Boolean']['output']>;
  /** Video vtt files */
  vttFiles: Array<VttFile>;
};

/** Vtt information */
export type VttFile = {
  __typename?: 'VttFile';
  /** Type of vtt file */
  kind?: Maybe<Scalars['String']['output']>;
  /** Vtt locale */
  locale?: Maybe<Scalars['String']['output']>;
  /** Link to vtt file */
  url?: Maybe<Scalars['String']['output']>;
};

/** An action that can be triggered by a user or system event */
export type Workflow = {
  __typename?: 'Workflow';
  /** The audience for the workflow. */
  audience: Array<AudienceInstance>;
  /** Time the Workflow was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Whether or not the workflow is enabled */
  enabled: Scalars['Boolean']['output'];
  /** The ID of the workflow */
  id: Scalars['ID']['output'];
  /** The percent of the audience that has completed the workflow. */
  percentComplete: Scalars['Float']['output'];
  /** The number of times a workflow has been triggered. */
  resultCount: Scalars['Float']['output'];
  /** The number of groups or instances associated with a workflow. */
  resultGroupCount: Scalars['Float']['output'];
  /** The settings for the workflow. */
  settings: WorkflowSettings;
  /** The number of users a workflow was triggered for. */
  triggeredForUsersCount: Scalars['Float']['output'];
  /** Time the Workflow was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User who created the Workflow */
  user?: Maybe<PopulatedUser>;
};

/** Assigner data. */
export type WorkflowAssigner = {
  __typename?: 'WorkflowAssigner';
  /** The ID of the workflow assigner. */
  id: Scalars['ID']['output'];
  /** The name of the workflow assigner. */
  name: Scalars['String']['output'];
};

/** Assignment result data of workflow */
export type WorkflowAssignmentResult = {
  __typename?: 'WorkflowAssignmentResult';
  /** The ID of the assignment result record. */
  result: Scalars['ID']['output'];
  /** The type of workflow result. */
  resultType: Scalars['String']['output'];
};

/** Filter around the audience that receives the workflow response. */
export type WorkflowConditional = {
  __typename?: 'WorkflowConditional';
  /** The Number associated with conditionals that include a custom number of days. */
  days?: Maybe<Scalars['Float']['output']>;
  /** The id of the audience filter. */
  id?: Maybe<Scalars['String']['output']>;
  /** The id of the audience filter. */
  name?: Maybe<Scalars['String']['output']>;
  /** The type of audience filter. */
  type: ConditionalObjectType;
};

/** Filter around the audience that receives the workflow response. */
export type WorkflowConditionalInput = {
  /** The Number associated with conditionals that include a custom number of days. */
  days?: InputMaybe<Scalars['Float']['input']>;
  /** The ID of the audience filter (Group ID, Location ID, etc.). */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The type of audience filter. */
  type: ConditionalObjectType;
};

/** A Workflow list container object. */
export type WorkflowContainer = {
  __typename?: 'WorkflowContainer';
  /** A list of edges. */
  edges: Array<WorkflowEdge>;
  /** The pagination details. */
  pageInfo: PageInfo;
};

/** Input type for creating a new Worflow. */
export type WorkflowCreateInput = {
  /** The audience for the workflow. */
  audience: Array<AudienceInput>;
  /** Whether the workflow is enabled. */
  enabled?: Scalars['Boolean']['input'];
  /** Settings for the workflow. */
  settings: WorkflowSettingsInput;
};

/** A container for workflows. */
export type WorkflowEdge = {
  __typename?: 'WorkflowEdge';
  /** The cursor for this edge. */
  cursor: Scalars['String']['output'];
  /** The node for this edge. */
  node: Workflow;
};

/** Type of object or event that triggers a workflow. */
export enum WorkflowObjectType {
  /** Workflow is triggered by an article completion or assignment. */
  Article = 'ARTICLE',
  /** Workflow is triggered by an assessment completion or assignment. */
  Assessment = 'ASSESSMENT',
  /** Workflow is triggered by an event. */
  Event = 'EVENT',
  /** Workflow is triggered by a file completion or assignment. */
  File = 'FILE',
  /** Workflow is triggered by imported content completion or assignment. */
  ImportedContent = 'IMPORTED_CONTENT',
  /** Workflow is triggered by a journey completion or assignment. */
  Journey = 'JOURNEY',
  /** Workflow is triggered by a poll completion or assignment. */
  Poll = 'POLL',
  /** Workflow is triggered by a presentation completion or assignment. */
  Presentation = 'PRESENTATION',
  /** Workflow is triggered by a quiz completion or assignment. */
  Quiz = 'QUIZ',
  /** Workflow is triggered by a SCORM completion or assignment. */
  Scorm = 'SCORM',
  /** Workflow is triggered by a track completion or assignment. */
  Track = 'TRACK',
  /** Workflow is triggered by a user event. */
  User = 'USER',
  /** Workflow is triggered by a video completion or assignment. */
  Video = 'VIDEO',
  /** Workflow is triggered by a workshop registration or attendance. */
  Workshop = 'WORKSHOP'
}

/** Message sent when workflow response is overdue and has reminders set. */
export type WorkflowOverdueMessage = {
  __typename?: 'WorkflowOverdueMessage';
  /** The cadence of the overdue message. */
  cadence: Cadence;
  /** Message Data */
  message: NotificationReadModel;
  /** The total number of overdue messages to send. */
  totalMessages: Scalars['Float']['output'];
};

/** Message sent when workflow response is overdue and has reminders set. */
export type WorkflowOverdueMessageInput = {
  /** Frequency of message delivery */
  cadence: Cadence;
  /** Message around overdue status. */
  message: Scalars['String']['input'];
  /** Total number of messages to send. */
  totalMessages: Scalars['Float']['input'];
};

/** The overview of company workflows. */
export type WorkflowOverview = {
  __typename?: 'WorkflowOverview';
  /** Total number of automated workflows. */
  automatedWorkflowCount: Scalars['Float']['output'];
  /** Total number of direct workflows */
  directWorkflowCount: Scalars['Float']['output'];
  /** Total number of workflows created all time. */
  totalWorkflowCount: Scalars['Float']['output'];
};

/** Message sent when workflow response is due and has reminders set. */
export type WorkflowReminder = {
  __typename?: 'WorkflowReminder';
  /** Message Data */
  message: NotificationReadModel;
  /** Days before reminders are due. */
  timeBeforeDue?: Maybe<Scalars['Float']['output']>;
};

/** Message sent when workflow response is due and has reminders set. */
export type WorkflowReminderMessageInput = {
  /** Notification ID. */
  message: Scalars['String']['input'];
  /** How many days before reminders are due. */
  timeBeforeDue?: InputMaybe<Scalars['Float']['input']>;
};

/** Type of response a workflow triggers. */
export enum WorkflowReponseType {
  /** Assigns specified content. */
  Assignment = 'ASSIGNMENT',
  /** Shares specified content. */
  Share = 'SHARE'
}

/** The action triggered by the workflow. */
export type WorkflowResponse = {
  __typename?: 'WorkflowResponse';
  /** The content title and id. */
  content?: Maybe<ContentInstance>;
  /** The type of response (Share or Assignment). */
  type: WorkflowReponseType;
};

/** The action triggered by the workflow. */
export type WorkflowResponseInput = {
  /** The content title and id. */
  content?: InputMaybe<ContentInstanceInput>;
  /** The type of response (Share or Assignment). */
  type: WorkflowReponseType;
};

/** Workflow result data. */
export type WorkflowResult = {
  __typename?: 'WorkflowResult';
  /** The ID of the workflow result record. */
  id: Scalars['ID']['output'];
  /** Data on results of the workflow result */
  results: Array<WorkflowAssignmentResult>;
  /** The ID of the workflow assignee. */
  user: Scalars['ID']['output'];
};

/** A group of workflow results */
export type WorkflowResultGroup = {
  __typename?: 'WorkflowResultGroup';
  /** Name of assigner */
  assigner: WorkflowAssigner;
  /** The audience for the workflow. */
  audience: Array<AudienceInstance>;
  /** Number of completed assignments in workflow */
  completedAssignments: Scalars['Float']['output'];
  /** Time the Workflow was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Assignment due date */
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the workflow */
  id: Scalars['ID']['output'];
  /** The number of times a workflow has been triggered. */
  resultCount: Scalars['Float']['output'];
  /** Workflow results part of the group */
  results: Array<WorkflowResult>;
  /** The settings for the workflow. */
  settings: WorkflowSettings;
  /** Number of all assignments in workflow */
  totalAssignments: Scalars['Float']['output'];
  /** Users who received the workflow */
  triggeredForUsers: Array<Scalars['ID']['output']>;
  /** The number of users a workflow was triggered for. */
  triggeredForUsersCount: Scalars['Float']['output'];
  /** Time the Workflow was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the workflow. */
  workflow: Scalars['ID']['output'];
};

/** The settings for the workflow. */
export type WorkflowSettings = {
  __typename?: 'WorkflowSettings';
  /** Delay option for assignments. */
  assignmentOptions: AssignmentOption;
  /** Filters around the audience that receives the workflow response. */
  conditionals: Array<WorkflowConditional>;
  /** The number of days a user has to complete the assignment resulting from a workflow. */
  daysToComplete?: Maybe<Scalars['Float']['output']>;
  /** Whether a workflow-created assignment should be due from the time of hire or from assigned date. */
  dueFromHired: Scalars['Boolean']['output'];
  /** Whether the assignment resulting from a workflow response being overdue should escalate to a buddy. */
  escalateBuddy: Scalars['Boolean']['output'];
  /** Whether the assignment resulting from a workflow response being overdue should escalate to the manager. */
  escalateManager: Scalars['Boolean']['output'];
  /** The contacts to notify if the assignment resulting from a workflow is overdue. */
  escalationContacts: Array<EscalationContact>;
  /** Workflow name. */
  name: Scalars['String']['output'];
  /** Messages set to send in relation to workflow response. */
  nonReminderMessages: Array<NotificationReadModel>;
  /** The number of custom days that triggers the workflow. */
  objectNumber?: Maybe<Scalars['Float']['output']>;
  /** The type of event or content completed that triggers the workflow. */
  objectType?: Maybe<WorkflowObjectType>;
  /** Message sent when workflow response is overdue and has reminders set. */
  overdueMessages: Array<WorkflowOverdueMessage>;
  /** The permission level (tenant, partner, or both) for the workflow. */
  partnerPermissions: PartnerPermissionTypes;
  /** Messages set to send when workflow response is due and has reminders set. */
  reminderMessages: Array<WorkflowReminder>;
  /** Whether the workflow-created assignment requires re-completion. */
  requireRecompletion: Scalars['Boolean']['output'];
  /** The action(s) triggered by the workflow. */
  responses: Array<WorkflowResponse>;
  /** Email setting options for Shares. */
  shareOptions: ShareOption;
  /** The event or content that triggers the workflow. */
  triggerObject?: Maybe<ObjectInstance>;
  /** Workflow type. */
  type: WorkflowType;
};

/** The settings for the workflow. */
export type WorkflowSettingsInput = {
  /** Delay option for assignments. */
  assignmentOptions?: AssignmentOptionInput;
  /** Filters around the audience that receives the workflow response. */
  conditionals?: Array<WorkflowConditionalInput>;
  /** The number of days a user has to complete the assignment resulting from a workflow. */
  daysToComplete?: InputMaybe<Scalars['Float']['input']>;
  /** Whether a workflow-created assignment should be due from the time of hire or from assigned date. */
  dueFromHired?: Scalars['Boolean']['input'];
  /** Whether the assignment resulting from a workflow response being overdue should escalate to a buddy. */
  escalateBuddy?: Scalars['Boolean']['input'];
  /** Whether the assignment resulting from a workflow response being overdue should escalate to the manager. */
  escalateManager?: Scalars['Boolean']['input'];
  /** The contacts to notify if the assignment resulting from a workflow is overdue. */
  escalationContacts?: Array<Scalars['String']['input']>;
  /** Workflow name. */
  name: Scalars['String']['input'];
  /** Messages set to send in relation to workflow response. */
  nonReminderMessages?: Array<Scalars['String']['input']>;
  /** The number of custom days that triggers the workflow. */
  objectNumber?: InputMaybe<Scalars['Float']['input']>;
  /** The type of event or content completed that triggers the workflow. */
  objectType?: InputMaybe<WorkflowObjectType>;
  /** Messages sent when workflow response is overdue and has reminders set. */
  overdueMessages?: Array<WorkflowOverdueMessageInput>;
  /** The permission level (tenant, partner, or both) for the workflow. */
  partnerPermissions?: InputMaybe<PartnerPermissionTypes>;
  /** Messages sent when workflow response is due and has reminders set. */
  reminderMessages?: Array<WorkflowReminderMessageInput>;
  /** Whether the workflow-created assignment requires re-completion. */
  requireRecompletion?: Scalars['Boolean']['input'];
  /** The action triggered by the workflow. */
  responses: Array<WorkflowResponseInput>;
  /** Email setting options for Shares. */
  shareOptions?: ShareOptionInput;
  /** The ID of the event or content that triggers the workflow. */
  triggerObject?: InputMaybe<Scalars['String']['input']>;
  /** Workflow type. */
  type: WorkflowType;
};

/** The assignment statistics for a workflow. */
export type WorkflowStats = {
  __typename?: 'WorkflowStats';
  /** Total assignments completed late. */
  completedLate: Scalars['Float']['output'];
  /** Total assignments completed on time. */
  completedOnTime: Scalars['Float']['output'];
  /** Percentage of completed assignments. */
  completedPercentage: Scalars['Float']['output'];
  /** Total assignments in progress with no due date. */
  inProgress: Scalars['Float']['output'];
  /** Total assignments not started yet. */
  notStarted: Scalars['Float']['output'];
  /** Total open assignments. */
  openAssignments: Scalars['Float']['output'];
  /** Total assignments overdue. */
  overdue: Scalars['Float']['output'];
  /** Percentage of assignments overdue. */
  overduePercentage: Scalars['Float']['output'];
  /** Total assignments pending on time. */
  pendingOnTime: Scalars['Float']['output'];
  /** Total assignments created all time. */
  totalAssignments: Scalars['Float']['output'];
  /** Total groups created all time. */
  totalGroups: Scalars['Float']['output'];
};

/** Input type for triggering a workflow manually. */
export type WorkflowTriggerData = {
  /** List of audience objects for the workflow */
  audience: Array<AudienceInput>;
  /** Workflow settings to override for the new instance that will trigger */
  settingsOverrides?: SettingsOverrides;
  /** ID of workflow */
  workflowId: Scalars['String']['input'];
};

/** Type of Workflow. */
export enum WorkflowType {
  /** A user attended a workshop. */
  AttendedWorkshop = 'ATTENDED_WORKSHOP',
  /** And assignment is completed. */
  CompletedAssignment = 'COMPLETED_ASSIGNMENT',
  /** Content is completed. */
  CompletedContent = 'COMPLETED_CONTENT',
  /** A user was hired 60 days ago. */
  Hired_60 = 'HIRED_60',
  /** A user was hired 90 days ago. */
  Hired_90 = 'HIRED_90',
  /** A user was hired a custom number of days ago. */
  HiredCustom = 'HIRED_CUSTOM',
  /** A user was hired today. */
  HiredToday = 'HIRED_TODAY',
  /** A workflow is triggered manually or is scheduled to trigger at a specific point in time. */
  PointInTime = 'POINT_IN_TIME',
  /** A user registered for a workshop. */
  RegisteredWorkshop = 'REGISTERED_WORKSHOP',
  /** User is added to the system. */
  UserAdded = 'USER_ADDED',
  /** User is added or updated in the system. */
  UserAddedOrUpdated = 'USER_ADDED_OR_UPDATED',
  /** User is updated in the system. */
  UserUpdated = 'USER_UPDATED'
}

/** Input type for updating an existing Workflow. */
export type WorkflowUpdateInput = {
  /** The audience for the workflow. */
  audience?: InputMaybe<Array<AudienceInput>>;
  /** Whether the workflow is enabled. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Settings of the workflow */
  settings?: InputMaybe<WorkflowSettingsInput>;
};

/** Workshop cohort information */
export type WorkshopCohort = {
  __typename?: 'WorkshopCohort';
  /** Workshop instance */
  instances: Array<Scalars['ID']['output']>;
  /** Workshop cohort name */
  name: Scalars['String']['output'];
};

/** Data specific to workshops */
export type WorkshopExtras = {
  __typename?: 'WorkshopExtras';
  /** Does workshop allow re-registration? */
  allowReregistration: Scalars['Boolean']['output'];
  /** Child workshops */
  childWorkshops: Array<Scalars['ID']['output']>;
  /** Cohort data for workshop */
  cohorts: Array<WorkshopCohort>;
  /** Description of content */
  description?: Maybe<Scalars['String']['output']>;
  /** Has workshop been published? */
  published: Scalars['Boolean']['output'];
  /** Has workshop registration been disabled? */
  registrationDisabled: Scalars['Boolean']['output'];
  /** Related workshops */
  relatedWorkshops: Array<Scalars['ID']['output']>;
  /** Does workshop require attendance for registration? */
  requireAttendanceForReregistration: Scalars['Boolean']['output'];
  /** Workshop registration type */
  signupType?: Maybe<MultiSessionWorkshopTypes>;
  /** Name of Content */
  title?: Maybe<Scalars['String']['output']>;
};

export type NotificationMessageDetailsFragmentFragment = { __typename: 'NotificationReadModel', channels: Array<string>, contentId?: string | null, contentType: NotificationContentType, createdAt: any, creator: string, id: string, name: string, scheduled: boolean, scheduledDuration?: number | null, type: NotificationType, updatedAt: any, messaging: { __typename?: 'MessagingSettings', email: Array<{ __typename?: 'ChannelSettings', name: string, value: string }>, inApp: Array<{ __typename?: 'ChannelSettings', name: string, value: string }>, slack: Array<{ __typename?: 'ChannelSettings', name: string, value: string }> }, options: Array<{ __typename?: 'NotificationOption', name: string, value: string }> } & { ' $fragmentName'?: 'NotificationMessageDetailsFragmentFragment' };

export type CreateWorkflowMutationVariables = Exact<{
  workflow: WorkflowCreateInput;
}>;


export type CreateWorkflowMutation = { __typename?: 'Mutation', createWorkflow: { __typename: 'NewEntityID', id: string } };

export type CreateNotificationMutationVariables = Exact<{
  notification: NotificationCreateInput;
}>;


export type CreateNotificationMutation = { __typename?: 'Mutation', createNotification: { __typename: 'NotificationMutationResponse', id: string } };

export type UpdateNotificationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  notification: NotificationUpdateInput;
}>;


export type UpdateNotificationMutation = { __typename?: 'Mutation', updateNotification: { __typename: 'NotificationMutationResponse', id: string } };

export type TriggerPointInTimeWorkflowMutationVariables = Exact<{
  workflowTriggerData: WorkflowTriggerData;
}>;


export type TriggerPointInTimeWorkflowMutation = { __typename?: 'Mutation', triggerPointInTimeWorkflow: boolean };

export type UpdateWorkflowMutationVariables = Exact<{
  id: Scalars['String']['input'];
  workflowUpdateInput: WorkflowUpdateInput;
}>;


export type UpdateWorkflowMutation = { __typename?: 'Mutation', updateWorkflow: { __typename: 'NewEntityID', id: string } };

export type UpdateWorkflowResultGroupMutationVariables = Exact<{
  id: Scalars['String']['input'];
  resultGroupUpdateInput: ResultGroupUpdateInput;
}>;


export type UpdateWorkflowResultGroupMutation = { __typename?: 'Mutation', updateResultGroup: { __typename: 'NewEntityID', id: string } };

export type MarkAssignmentCompletedMutationVariables = Exact<{
  completeAssignmentInput: AssignmentActionInput;
}>;


export type MarkAssignmentCompletedMutation = { __typename?: 'Mutation', completeAssignments: boolean };

export type ArchiveAssignmentsMutationVariables = Exact<{
  archiveAssignmentInput: AssignmentActionInput;
}>;


export type ArchiveAssignmentsMutation = { __typename?: 'Mutation', archiveAssignments: boolean };

export type SendAssignmentReminderMutationVariables = Exact<{
  assignmentReminderInput: AssignmentActionInput;
}>;


export type SendAssignmentReminderMutation = { __typename?: 'Mutation', sendAssignmentReminder: boolean };

export type BulkUserSearchFromEmailQueryVariables = Exact<{
  userEmails: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type BulkUserSearchFromEmailQuery = { __typename?: 'Query', bulkUserSearch: { __typename?: 'BulkUserRead', users: Array<{ __typename: 'User', id: string, fullName?: string | null, image?: string | null }> } };

export type AssignmentAudienceCountQueryVariables = Exact<{
  audience: Array<AudienceCountInput> | AudienceCountInput;
}>;


export type AssignmentAudienceCountQuery = { __typename?: 'Query', audienceCount: { __typename?: 'AudienceCount', totalUsers: number } };

export type GetWorkflowDetailsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetWorkflowDetailsQuery = { __typename?: 'Query', getWorkflow: { __typename: 'Workflow', enabled: boolean, id: string, createdAt: any, updatedAt?: any | null, percentComplete: number, user?: { __typename?: 'PopulatedUser', id: string, fullName: string } | null, audience: Array<{ __typename?: 'AudienceInstance', id?: string | null, days?: number | null, matchingCriteria: MatchingCriteria, name: string, type: AudienceType, segmentationType: string, dateRange?: { __typename?: 'AudienceDateRange', after?: any | null, before?: any | null } | null }>, settings: { __typename?: 'WorkflowSettings', daysToComplete?: number | null, dueFromHired: boolean, escalateBuddy: boolean, escalateManager: boolean, name: string, objectNumber?: number | null, objectType?: WorkflowObjectType | null, partnerPermissions: PartnerPermissionTypes, requireRecompletion: boolean, type: WorkflowType, assignmentOptions: { __typename?: 'AssignmentOption', delay?: string | null }, conditionals: Array<{ __typename?: 'WorkflowConditional', id?: string | null, name?: string | null, days?: number | null, type: ConditionalObjectType }>, escalationContacts: Array<{ __typename?: 'EscalationContact', id: string, fullName: string, image?: string | null }>, nonReminderMessages: Array<(
        { __typename?: 'NotificationReadModel' }
        & { ' $fragmentRefs'?: { 'NotificationMessageDetailsFragmentFragment': NotificationMessageDetailsFragmentFragment } }
      )>, overdueMessages: Array<{ __typename?: 'WorkflowOverdueMessage', cadence: Cadence, totalMessages: number, message: (
          { __typename?: 'NotificationReadModel' }
          & { ' $fragmentRefs'?: { 'NotificationMessageDetailsFragmentFragment': NotificationMessageDetailsFragmentFragment } }
        ) }>, reminderMessages: Array<{ __typename?: 'WorkflowReminder', timeBeforeDue?: number | null, message: (
          { __typename?: 'NotificationReadModel' }
          & { ' $fragmentRefs'?: { 'NotificationMessageDetailsFragmentFragment': NotificationMessageDetailsFragmentFragment } }
        ) }>, responses: Array<{ __typename?: 'WorkflowResponse', type: WorkflowReponseType, content?: { __typename?: 'ContentInstance', contentType: ContentTypes, id?: string | null, title?: string | null, isRecompletable?: string | null } | null }>, shareOptions: { __typename?: 'ShareOption', emailBody?: string | null, emailFromEmail?: string | null, emailFromName?: string | null, emailSubject?: string | null }, triggerObject?: { __typename?: 'ObjectInstance', id?: string | null, title?: string | null } | null } } };

export type GetWorkflowOverviewTotalsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWorkflowOverviewTotalsQueryQuery = { __typename?: 'Query', workflowOverview: { __typename: 'WorkflowOverview', automatedWorkflowCount: number, directWorkflowCount: number, totalWorkflowCount: number } };

export type GetWorkflowResultGroupQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetWorkflowResultGroupQuery = { __typename?: 'Query', workflowResultGroup: { __typename?: 'WorkflowResultGroup', completedAssignments: number, createdAt: any, dueDate?: any | null, id: string, resultCount: number, totalAssignments: number, triggeredForUsers: Array<string>, updatedAt?: any | null, workflow: string, assigner: { __typename?: 'WorkflowAssigner', id: string, name: string }, audience: Array<{ __typename?: 'AudienceInstance', days?: number | null, id?: string | null, matchingCriteria: MatchingCriteria, name: string, type: AudienceType, segmentationType: string, image?: string | null, dateRange?: { __typename?: 'AudienceDateRange', after?: any | null, before?: any | null } | null }>, results: Array<{ __typename?: 'WorkflowResult', id: string, user: string, results: Array<{ __typename?: 'WorkflowAssignmentResult', result: string, resultType: string }> }>, settings: { __typename?: 'WorkflowSettings', daysToComplete?: number | null, dueFromHired: boolean, escalateBuddy: boolean, escalateManager: boolean, name: string, objectNumber?: number | null, objectType?: WorkflowObjectType | null, partnerPermissions: PartnerPermissionTypes, requireRecompletion: boolean, type: WorkflowType, assignmentOptions: { __typename?: 'AssignmentOption', delay?: string | null }, conditionals: Array<{ __typename?: 'WorkflowConditional', days?: number | null, id?: string | null, name?: string | null, type: ConditionalObjectType }>, escalationContacts: Array<{ __typename?: 'EscalationContact', id: string, fullName: string, image?: string | null }>, nonReminderMessages: Array<(
        { __typename?: 'NotificationReadModel' }
        & { ' $fragmentRefs'?: { 'NotificationMessageDetailsFragmentFragment': NotificationMessageDetailsFragmentFragment } }
      )>, overdueMessages: Array<{ __typename?: 'WorkflowOverdueMessage', cadence: Cadence, totalMessages: number, message: (
          { __typename?: 'NotificationReadModel' }
          & { ' $fragmentRefs'?: { 'NotificationMessageDetailsFragmentFragment': NotificationMessageDetailsFragmentFragment } }
        ) }>, reminderMessages: Array<{ __typename?: 'WorkflowReminder', timeBeforeDue?: number | null, message: (
          { __typename?: 'NotificationReadModel' }
          & { ' $fragmentRefs'?: { 'NotificationMessageDetailsFragmentFragment': NotificationMessageDetailsFragmentFragment } }
        ) }>, responses: Array<{ __typename?: 'WorkflowResponse', type: WorkflowReponseType, content?: { __typename?: 'ContentInstance', contentType: ContentTypes, id?: string | null, title?: string | null } | null }>, shareOptions: { __typename?: 'ShareOption', emailBody?: string | null, emailFromEmail?: string | null, emailFromName?: string | null, emailSubject?: string | null }, triggerObject?: { __typename?: 'ObjectInstance', id?: string | null, title?: string | null } | null } } };

export type GetWorkflowStatsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetWorkflowStatsQuery = { __typename?: 'Query', workflowStats: { __typename?: 'WorkflowStats', completedLate: number, completedOnTime: number, completedPercentage: number, inProgress: number, notStarted: number, openAssignments: number, overdue: number, overduePercentage: number, pendingOnTime: number, totalAssignments: number, totalGroups: number } };

export type ListAssignmentRecipientsQueryQueryVariables = Exact<{
  assigneeId?: InputMaybe<IdQueryOperatorArgs>;
  assigneeName?: InputMaybe<StringQueryOperatorArgs>;
  assigner?: InputMaybe<IdQueryOperatorArgs>;
  completed?: InputMaybe<BooleanQueryOperatorArgs>;
  completedDate?: InputMaybe<DateQueryOperatorArgs>;
  completionStatus?: InputMaybe<StringQueryOperatorArgs>;
  contentId?: InputMaybe<IdQueryOperatorArgs>;
  createdAt?: InputMaybe<DateQueryOperatorArgs>;
  dueDate?: InputMaybe<DateQueryOperatorArgs>;
  groupId?: InputMaybe<IdQueryOperatorArgs>;
  includeTotalCount?: Scalars['Boolean']['input'];
  ordering?: InputMaybe<Array<OrderBy> | OrderBy>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  workflowId?: InputMaybe<IdQueryOperatorArgs>;
  unassigned?: InputMaybe<BooleanQueryOperatorArgs>;
}>;


export type ListAssignmentRecipientsQueryQuery = { __typename?: 'Query', assignments: { __typename?: 'AssignmentContainer', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, totalCount?: number | null }, edges: Array<{ __typename?: 'AssignmentEdge', node: { __typename?: 'Assignment', id: string, completionStatus: CompletionStatus, completionPercentage: number, createdAt: any, dueDate?: any | null, completedDate?: any | null, assignee: { __typename?: 'AssigneeData', id: string, fullName: string } } }> } };

export type ListSegmentationGroupsQueryVariables = Exact<{
  id?: InputMaybe<IdQueryOperatorArgs>;
  includeTotalCount?: Scalars['Boolean']['input'];
  name?: InputMaybe<StringQueryOperatorArgs>;
  ordering?: InputMaybe<Array<OrderBy> | OrderBy>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
}>;


export type ListSegmentationGroupsQuery = { __typename?: 'Query', listSegmentationGroups: { __typename?: 'GroupContainer', edges: Array<{ __typename?: 'GroupEdge', node: { __typename: 'Group', createdAt: any, description?: string | null, externalId?: string | null, id: string, name: string, updatedAt?: any | null } }> } };

export type ListWorkflowResultGroupsQueryVariables = Exact<{
  assigneeId?: InputMaybe<IdQueryOperatorArgs>;
  contentId?: InputMaybe<IdQueryOperatorArgs>;
  createdAt?: InputMaybe<DateQueryOperatorArgs>;
  includeTotalCount?: Scalars['Boolean']['input'];
  ordering?: InputMaybe<Array<OrderBy> | OrderBy>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  workflow?: InputMaybe<IdQueryOperatorArgs>;
}>;


export type ListWorkflowResultGroupsQuery = { __typename?: 'Query', workflowResultGroups: { __typename?: 'ResultGroupContainer', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, totalCount?: number | null }, edges: Array<{ __typename?: 'ResultGroupEdge', node: { __typename?: 'WorkflowResultGroup', id: string, createdAt: any, triggeredForUsers: Array<string>, totalAssignments: number, completedAssignments: number, audience: Array<{ __typename?: 'AudienceInstance', days?: number | null, id?: string | null, image?: string | null, matchingCriteria: MatchingCriteria, name: string, segmentationType: string, type: AudienceType, dateRange?: { __typename?: 'AudienceDateRange', after?: any | null, before?: any | null } | null }>, settings: { __typename?: 'WorkflowSettings', daysToComplete?: number | null, dueFromHired: boolean, escalateBuddy: boolean, escalateManager: boolean, name: string, objectNumber?: number | null, objectType?: WorkflowObjectType | null, partnerPermissions: PartnerPermissionTypes, requireRecompletion: boolean, type: WorkflowType, assignmentOptions: { __typename?: 'AssignmentOption', delay?: string | null }, conditionals: Array<{ __typename?: 'WorkflowConditional', days?: number | null, id?: string | null, name?: string | null, type: ConditionalObjectType }>, escalationContacts: Array<{ __typename?: 'EscalationContact', fullName: string, id: string, image?: string | null }>, nonReminderMessages: Array<(
            { __typename?: 'NotificationReadModel' }
            & { ' $fragmentRefs'?: { 'NotificationMessageDetailsFragmentFragment': NotificationMessageDetailsFragmentFragment } }
          )>, overdueMessages: Array<{ __typename?: 'WorkflowOverdueMessage', cadence: Cadence, totalMessages: number, message: (
              { __typename?: 'NotificationReadModel' }
              & { ' $fragmentRefs'?: { 'NotificationMessageDetailsFragmentFragment': NotificationMessageDetailsFragmentFragment } }
            ) }>, reminderMessages: Array<{ __typename?: 'WorkflowReminder', timeBeforeDue?: number | null, message: (
              { __typename?: 'NotificationReadModel' }
              & { ' $fragmentRefs'?: { 'NotificationMessageDetailsFragmentFragment': NotificationMessageDetailsFragmentFragment } }
            ) }>, responses: Array<{ __typename?: 'WorkflowResponse', type: WorkflowReponseType, content?: { __typename?: 'ContentInstance', contentType: ContentTypes, id?: string | null, title?: string | null, isRecompletable?: string | null } | null }>, shareOptions: { __typename?: 'ShareOption', emailBody?: string | null, emailFromEmail?: string | null, emailFromName?: string | null, emailSubject?: string | null }, triggerObject?: { __typename?: 'ObjectInstance', id?: string | null, title?: string | null } | null }, assigner: { __typename?: 'WorkflowAssigner', id: string, name: string } } }> } };

export type ListWorkflowsQueryVariables = Exact<{
  contentId?: InputMaybe<IdQueryOperatorArgs>;
  includeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<StringQueryOperatorArgs>;
  ordering?: InputMaybe<Array<OrderBy> | OrderBy>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pointInTime?: InputMaybe<BooleanQueryOperatorArgs>;
  userId?: InputMaybe<IdQueryOperatorArgs>;
}>;


export type ListWorkflowsQuery = { __typename?: 'Query', listWorkflows: { __typename?: 'WorkflowContainer', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, totalCount?: number | null, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'WorkflowEdge', node: { __typename?: 'Workflow', id: string, createdAt: any, resultCount: number, resultGroupCount: number, percentComplete: number, enabled: boolean, user?: { __typename?: 'PopulatedUser', fullName: string, id: string } | null, settings: { __typename?: 'WorkflowSettings', type: WorkflowType, name: string, dueFromHired: boolean, responses: Array<{ __typename?: 'WorkflowResponse', content?: { __typename?: 'ContentInstance', id?: string | null, contentType: ContentTypes, title?: string | null } | null }> } } }> } };

export type ListSegmentationsQueryVariables = Exact<{
  includeTotalCount?: Scalars['Boolean']['input'];
  name?: InputMaybe<StringQueryOperatorArgs>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
}>;


export type ListSegmentationsQuery = { __typename?: 'Query', segmentations: { __typename?: 'SegmentationContainer', edges: Array<{ __typename?: 'SegmentationEdge', node: { __typename: 'Segmentation', id: string, name: string, segmentationType: string } }> } };

export type ListUsersQueryVariables = Exact<{
  email?: InputMaybe<StringQueryOperatorArgs>;
  name?: InputMaybe<StringQueryOperatorArgs>;
  suspended?: InputMaybe<BooleanQueryOperatorArgs>;
  includeTotalCount?: Scalars['Boolean']['input'];
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
}>;


export type ListUsersQuery = { __typename?: 'Query', users: { __typename?: 'UserContainer', edges: Array<{ __typename?: 'UserEdge', node: { __typename: 'User', id: string, fullName?: string | null, image?: string | null } }> } };

export type GetPromptResponseQueryVariables = Exact<{
  prompt: Scalars['String']['input'];
}>;


export type GetPromptResponseQuery = { __typename?: 'Query', getPromptResponse: { __typename?: 'AIPromptResponse', response: string, references: Array<{ __typename?: 'AIKnowledgeBaseReference', id: string, contentType: ContentTypes, name: string }> } };

export type GetUserContentFromContextIdQueryVariables = Exact<{
  contentType: ContentTypes;
  contextId: Scalars['String']['input'];
}>;


export type GetUserContentFromContextIdQuery = { __typename?: 'Query', getUserContent: { __typename?: 'UserContentFromContext', satisfied: boolean } };

export type CreateAgreementTextMutationVariables = Exact<{
  text: Scalars['String']['input'];
  companyDefault: Scalars['Boolean']['input'];
}>;


export type CreateAgreementTextMutation = { __typename?: 'Mutation', createAgreementText: { __typename?: 'NewEntityID', id: string } };

export type GetImportedContentTypeQueryVariables = Exact<{
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
  userid: Scalars['String']['input'];
}>;


export type GetImportedContentTypeQuery = { __typename?: 'Query', content: { __typename?: 'Content', currentVersion?: { __typename?: 'ArticleExtras' } | { __typename?: 'AssessmentExtras' } | { __typename?: 'FileExtras' } | { __typename?: 'ImportedContentExtras', vendor: string } | { __typename?: 'JourneyExtras' } | { __typename?: 'ScormExtras' } | { __typename?: 'TrackExtras' } | { __typename?: 'VideoExtras' } | { __typename?: 'WorkshopExtras' } | null } };

export type GetContentForEditorQueryVariables = Exact<{
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
  userid: Scalars['String']['input'];
}>;


export type GetContentForEditorQuery = { __typename?: 'Query', content: { __typename?: 'Content', id: string, company: string, creator: string, contentType: ContentTypes, private?: boolean | null, image?: string | null, bannerImage?: string | null, coverJustification?: string | null, featuredJustification?: string | null, exploreHide: boolean, approvalRequired?: boolean | null, signatureRequired?: boolean | null, tags?: Array<string> | null, totalLikes?: number | null, averageRating?: number | null, allowComments?: boolean | null, archived: boolean, partnerPermissions?: PartnerPermissionTypes | null, certificate?: boolean | null, currentVersion?: { __typename?: 'ArticleExtras', title?: string | null, author?: string | null, description?: string | null, html?: string | null, duration?: number | null } | { __typename?: 'AssessmentExtras', title?: string | null, assessmentType: string, allowRetake: boolean, showUserGrade: boolean, showUserCorrect: boolean, showUserCorrectAfterFail: boolean, numberOfRetakes?: number | null, percentToPass?: number | null, description?: string | null, author?: string | null, hideCover: boolean, allowManagerGrading?: boolean | null, allowBuddyGrading?: boolean | null, assignManagerGrading?: boolean | null, assignBuddyGrading?: boolean | null, questions: Array<{ __typename?: 'QuestionData', page?: number | null, position?: number | null, format?: string | null, id?: string | null, question?: string | null, rubricGrading: boolean, questionAsset?: string | null, questionAssetType?: string | null, rubricOptions?: Array<{ __typename?: 'RubricOptionData', id?: string | null, points?: number | null, name?: string | null, description?: string | null }> | null, choiceOptions?: Array<{ __typename?: 'ChoiceOptionData', points?: number | null, position?: number | null, copy?: string | null, image?: string | null, id?: string | null }> | null, questionOptions?: Array<{ __typename?: 'BooleanType', name?: string | null, value1?: boolean | null } | { __typename?: 'NumberType', name?: string | null, value2?: number | null } | { __typename?: 'StringType', value?: string | null, name?: string | null }> | null }>, assignedGraders?: Array<{ __typename?: 'AssignedGrader', id: string, name: string, image?: string | null }> | null } | { __typename?: 'FileExtras', title?: string | null, author?: string | null, duration?: number | null, link: string, description?: string | null, downloadable: boolean, useGenerativeAi?: boolean | null, textGenerationStatus?: TextGenerationStatus | null, transcript?: string | null, textGenerationJob?: string | null, draft: boolean, embed: boolean, sourceV2?: string | null } | { __typename?: 'ImportedContentExtras', title?: string | null, description?: string | null, duration?: number | null, vendor: string, vendorLink?: string | null, vendorFullLink?: string | null, vendorContentId: string, published: boolean, learnItems?: Array<string> | null, instructors: Array<{ __typename?: 'InstructorReadModel', id: string, name: string, email?: string | null, image?: string | null, bio?: string | null, notes?: string | null, reusable: boolean, socials?: { __typename?: 'InstructorSocialLinks', linkedin?: string | null, twitter?: string | null, facebook?: string | null, slack?: string | null, github?: string | null, instagram?: string | null, youtube?: string | null, dribbble?: string | null } | null }>, lilStructure: Array<{ __typename?: 'ImportedContentSection', duration?: number | null, difficulty?: string | null, type?: string | null, title: string, children: Array<{ __typename?: 'ImportedContentSection', duration?: number | null, difficulty?: string | null, type?: string | null, title: string, children: Array<{ __typename?: 'ImportedContentSection', duration?: number | null, difficulty?: string | null, type?: string | null, title: string }> }> }> } | { __typename?: 'JourneyExtras' } | { __typename?: 'ScormExtras', title?: string | null, author?: string | null, duration?: number | null, description?: string | null, sslaConfig: { __typename?: 'Ssla', openScoInNewWindow?: boolean | null, scoWindowWidth?: number | null, scoWindowHeight?: number | null, scoWindowTryFullscreen?: boolean | null }, properties?: Array<{ __typename?: 'ScormProperties', name?: string | null, value?: string | null }> | null } | { __typename?: 'TrackExtras', draft: boolean, title?: string | null, resource: boolean, description?: string | null, author?: string | null, sequential: boolean, lockScorm: boolean, learnItems?: Array<string> | null, instructors: Array<{ __typename?: 'InstructorReadModel', id: string, name: string, email?: string | null, image?: string | null, bio?: string | null, notes?: string | null, reusable: boolean, socials?: { __typename?: 'InstructorSocialLinks', linkedin?: string | null, twitter?: string | null, facebook?: string | null, slack?: string | null, github?: string | null, instagram?: string | null, youtube?: string | null, dribbble?: string | null } | null }>, sections?: Array<{ __typename?: 'TrackSectionData', id: string, name: string, description?: string | null, position: number, courses?: Array<{ __typename?: 'TrackCourse', id: string, title: string, type: string, position: number }> | null }> | null } | { __typename?: 'VideoExtras', title?: string | null, author?: string | null, duration?: number | null, link: string, description?: string | null, useGenerativeAi?: boolean | null, textGenerationStatus?: TextGenerationStatus | null, transcript?: string | null, textGenerationJob?: string | null, source?: string | null, transcoding: boolean, vttFiles: Array<{ __typename?: 'VttFile', kind?: string | null, url?: string | null, locale?: string | null }> } | { __typename?: 'WorkshopExtras' } | null, signatureAgreementText?: { __typename?: 'SignatureAgreementText', id: string, text: string } | null, ratingConfiguration: { __typename?: 'RatingConfig', allowRating: boolean, allowFeedback: boolean, allowEdits: boolean, notifyFeedbackOnly: boolean, showUsersRating: boolean, totalValue: number, messaging?: { __typename?: 'RatingMessaging', individuals: Array<{ __typename?: 'ContentCollaborator', id: string, name: string, linkedDepartments: Array<{ __typename?: 'ContentCategory', id?: string | null, name?: string | null }>, linkedLocations: Array<{ __typename?: 'ContentCategory', id?: string | null, name?: string | null }>, linkedTeams: Array<{ __typename?: 'ContentCategory', id?: string | null, name?: string | null }>, linkedOrgLevel: { __typename?: 'ContentCategory', id?: string | null, name?: string | null }, linkedGrade: { __typename?: 'ContentCategory', id?: string | null, name?: string | null }, groups: Array<{ __typename?: 'ContentGroup', id: string, name: string }> }>, slackChannels: Array<{ __typename?: 'MessagingSlackChannel', id: string, name: string }> } | null }, surveys?: Array<{ __typename?: 'ContentSurvey', id: string, title: string }> | null, privacyCollaborators?: Array<{ __typename?: 'ContentCollaborator', id: string, name: string, linkedDepartments: Array<{ __typename?: 'ContentCategory', id?: string | null, name?: string | null }>, linkedLocations: Array<{ __typename?: 'ContentCategory', id?: string | null, name?: string | null }>, linkedTeams: Array<{ __typename?: 'ContentCategory', id?: string | null, name?: string | null }>, linkedOrgLevel: { __typename?: 'ContentCategory', id?: string | null, name?: string | null }, linkedGrade: { __typename?: 'ContentCategory', id?: string | null, name?: string | null }, groups: Array<{ __typename?: 'ContentGroup', id: string, name: string }> }> | null, privacyLocations?: Array<{ __typename?: 'CategoryLineage', id?: string | null, name?: string | null, parent?: { __typename?: 'CategoryLineage', id?: string | null, name?: string | null, parent?: { __typename?: 'CategoryLineage', id?: string | null, name?: string | null } | null } | null }> | null, privacyDepartments?: Array<{ __typename?: 'CategoryLineage', id?: string | null, name?: string | null, parent?: { __typename?: 'CategoryLineage', id?: string | null, name?: string | null, parent?: { __typename?: 'CategoryLineage', id?: string | null, name?: string | null } | null } | null }> | null, privacyTeams?: Array<{ __typename?: 'CategoryLineage', id?: string | null, name?: string | null, parent?: { __typename?: 'CategoryLineage', id?: string | null, name?: string | null, parent?: { __typename?: 'CategoryLineage', id?: string | null, name?: string | null } | null } | null }> | null, privacyOrgLevels?: Array<{ __typename?: 'CategoryLineage', id?: string | null, name?: string | null, parent?: { __typename?: 'CategoryLineage', id?: string | null, name?: string | null, parent?: { __typename?: 'CategoryLineage', id?: string | null, name?: string | null } | null } | null }> | null, privacyGrades?: Array<{ __typename?: 'CategoryLineage', id?: string | null, name?: string | null, parent?: { __typename?: 'CategoryLineage', id?: string | null, name?: string | null, parent?: { __typename?: 'CategoryLineage', id?: string | null, name?: string | null } | null } | null }> | null, privacyGroups?: Array<{ __typename?: 'ContentGroup', id: string, name: string }> | null, linkedCategory?: Array<{ __typename?: 'CategoryLineage', id?: string | null, name?: string | null, parent?: { __typename?: 'CategoryLineage', id?: string | null, name?: string | null, parent?: { __typename?: 'CategoryLineage', id?: string | null, name?: string | null } | null } | null }> | null, certificateData?: Array<{ __typename?: 'ContentCertificateData', name: string, value?: string | null }> | null } };

export type CreateInstructorMutationVariables = Exact<{
  payload: InstructorCreateInput;
}>;


export type CreateInstructorMutation = { __typename?: 'Mutation', createInstructor: { __typename?: 'NewEntityID', id: string } };

export type SearchInstructorsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchInstructorsQuery = { __typename?: 'Query', instructors: { __typename?: 'InstructorContainer', edges: Array<{ __typename?: 'InstructorEdge', node: { __typename?: 'Instructor', id: string, name: string, email?: string | null, bio?: string | null, image?: string | null, notes?: string | null, reusable: boolean, createdAt: any, updatedAt?: any | null, socials?: { __typename?: 'InstructorSocialLinks', dribbble?: string | null, facebook?: string | null, github?: string | null, instagram?: string | null, linkedin?: string | null, slack?: string | null, twitter?: string | null, youtube?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, totalCount?: number | null } } };

export type UpdateInstructorMutationVariables = Exact<{
  id: Scalars['String']['input'];
  payload: InstructorUpdateInput;
}>;


export type UpdateInstructorMutation = { __typename?: 'Mutation', updateInstructor: { __typename?: 'InstructorReadModel', id: string, name: string, email?: string | null, bio?: string | null, notes?: string | null, image?: string | null, reusable: boolean, archived: boolean, createdAt: any, updatedAt?: any | null, socials?: { __typename?: 'InstructorSocialLinks', dribbble?: string | null, facebook?: string | null, github?: string | null, instagram?: string | null, linkedin?: string | null, slack?: string | null, twitter?: string | null, youtube?: string | null } | null } };

export type GenerativeKeywordsQueryVariables = Exact<{
  text: Scalars['String']['input'];
}>;


export type GenerativeKeywordsQuery = { __typename?: 'Query', generativeKeywords: Array<string> };

export type GenerativeKeywordsByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GenerativeKeywordsByIdQuery = { __typename?: 'Query', generativeKeywordsById: Array<string> };

export type GenerativeDescriptionByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GenerativeDescriptionByIdQuery = { __typename?: 'Query', generativeDescriptionById: string };

export type GetTextGenerationStatusQueryVariables = Exact<{
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
  userid: Scalars['String']['input'];
}>;


export type GetTextGenerationStatusQuery = { __typename?: 'Query', content: { __typename?: 'Content', id: string, company: string, currentVersion?: { __typename?: 'ArticleExtras' } | { __typename?: 'AssessmentExtras' } | { __typename?: 'FileExtras', textGenerationStatus?: TextGenerationStatus | null } | { __typename?: 'ImportedContentExtras' } | { __typename?: 'JourneyExtras' } | { __typename?: 'ScormExtras' } | { __typename?: 'TrackExtras' } | { __typename?: 'VideoExtras', textGenerationStatus?: TextGenerationStatus | null, vttFiles: Array<{ __typename?: 'VttFile', url?: string | null, locale?: string | null, kind?: string | null }> } | { __typename?: 'WorkshopExtras' } | null } };

export type GenerativeTopicsQueryVariables = Exact<{
  trackid: Scalars['String']['input'];
}>;


export type GenerativeTopicsQuery = { __typename?: 'Query', generativeTopics: Array<string> };

export type PartnerContainerQueryVariables = Exact<{
  includeTotalCount: Scalars['Boolean']['input'];
  name?: InputMaybe<StringQueryOperatorArgs>;
  ordering?: InputMaybe<Array<OrderBy> | OrderBy>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type PartnerContainerQuery = { __typename?: 'Query', partners: { __typename?: 'PartnerContainer', edges: Array<{ __typename?: 'PartnerEdge', node: { __typename?: 'Partner', active: boolean, creator: string, id: string, name: string, seats: number, createdAt: any, branding: { __typename?: 'PartnerBranding', backgroundImageUrls?: Array<string> | null, colorPrimary?: string | null, logoUrl?: string | null } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null, totalCount?: number | null } } };

export type ProductsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  includeTotalCount: Scalars['Boolean']['input'];
  title?: InputMaybe<StringQueryOperatorArgs>;
  id?: InputMaybe<IdQueryOperatorArgs>;
  ordering?: InputMaybe<Array<OrderBy> | OrderBy>;
}>;


export type ProductsQuery = { __typename?: 'Query', products: { __typename?: 'ProductContainer', edges: Array<{ __typename?: 'ProductEdge', node: { __typename?: 'Product', title: string, description: string, currency?: string | null, id: string, images: Array<string>, licensingType: ProductLicensingType, price: number, default?: boolean | null, productType: ProductType, updatedAt?: any | null, createdAt: any, published: boolean, subscriptionDuration: ProductSubscriptionDuration } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null, totalCount?: number | null } } };

export type AdminProductsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  includeTotalCount: Scalars['Boolean']['input'];
  title?: InputMaybe<StringQueryOperatorArgs>;
  id?: InputMaybe<IdQueryOperatorArgs>;
  ordering?: InputMaybe<Array<OrderBy> | OrderBy>;
  archived?: InputMaybe<BooleanQueryOperatorArgs>;
}>;


export type AdminProductsQuery = { __typename?: 'Query', products: { __typename?: 'ProductContainer', edges: Array<{ __typename?: 'ProductEdge', node: { __typename?: 'Product', title: string, description: string, currency?: string | null, id: string, images: Array<string>, licensingType: ProductLicensingType, price: number, productType: ProductType, updatedAt?: any | null, createdAt: any, published: boolean, subscriptionDuration: ProductSubscriptionDuration, purchaseCount: number, totalRefunded: number, archived: boolean, default?: boolean | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null, totalCount?: number | null } } };

export type ProductQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ProductQuery = { __typename?: 'Query', product: { __typename?: 'Product', id: string, title: string, description: string, currency?: string | null, images: Array<string>, price: number, licensingType: ProductLicensingType, productType: ProductType, published: boolean, subscriptionDuration: ProductSubscriptionDuration, default?: boolean | null, allowRelatedProducts: boolean, relatedProducts: Array<string>, contentListDetails?: Array<{ __typename?: 'ContentDetails', id: string, name?: string | null, title?: string | null, displayName: string, type: string, image?: string | null }> | null } };

export type BaseProductQueryVariables = Exact<{ [key: string]: never; }>;


export type BaseProductQuery = { __typename?: 'Query', baseProduct: { __typename?: 'Product', id: string, title: string, description: string, currency?: string | null, images: Array<string>, price: number, licensingType: ProductLicensingType, productType: ProductType, published: boolean, subscriptionDuration: ProductSubscriptionDuration, default?: boolean | null, allowRelatedProducts: boolean, relatedProducts: Array<string>, contentListDetails?: Array<{ __typename?: 'ContentDetails', id: string, name?: string | null, title?: string | null, displayName: string, type: string, image?: string | null }> | null } };

export type PurchasesContainerQueryVariables = Exact<{
  includeTotalCount: Scalars['Boolean']['input'];
  user?: InputMaybe<IdQueryOperatorArgs>;
  id?: InputMaybe<IdQueryOperatorArgs>;
  product?: InputMaybe<IdQueryOperatorArgs>;
  subscriptionActive?: InputMaybe<Scalars['Boolean']['input']>;
  purchaseConfirmedDate?: InputMaybe<DateQueryOperatorArgs>;
  ordering?: InputMaybe<Array<OrderBy> | OrderBy>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type PurchasesContainerQuery = { __typename?: 'Query', purchases: { __typename?: 'PurchaseContainer', edges: Array<{ __typename?: 'PurchaseEdge', node: { __typename?: 'Purchase', id: string, purchaseInitiatedDate?: any | null, purchaseConfirmedDate?: any | null, nextScheduledPayment?: any | null, product: string, subscriptionActive: boolean, recurring: boolean, user: string, userName: string, paymentAttempts: Array<{ __typename?: 'PaymentAttempt', currency?: string | null, paymentMethod?: string | null, paymentSettledDate?: any | null, price?: number | null, successful?: boolean | null }>, productDetails: { __typename?: 'Product', title: string, description: string, currency?: string | null, id: string, images: Array<string>, licensingType: ProductLicensingType, price: number, productType: ProductType, subscriptionDuration: ProductSubscriptionDuration, allowRelatedProducts: boolean, relatedProducts: Array<string> } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null, totalCount?: number | null } } };

export type PurchasesContainerSingleUserQueryVariables = Exact<{
  includeTotalCount: Scalars['Boolean']['input'];
  user?: InputMaybe<IdQueryOperatorArgs>;
  id?: InputMaybe<IdQueryOperatorArgs>;
  product?: InputMaybe<IdQueryOperatorArgs>;
  subscriptionActive?: InputMaybe<Scalars['Boolean']['input']>;
  purchaseConfirmedDate?: InputMaybe<DateQueryOperatorArgs>;
  ordering?: InputMaybe<Array<OrderBy> | OrderBy>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type PurchasesContainerSingleUserQuery = { __typename?: 'Query', purchases: { __typename?: 'PurchaseContainer', edges: Array<{ __typename?: 'PurchaseEdge', node: { __typename?: 'Purchase', id: string, purchaseInitiatedDate?: any | null, purchaseConfirmedDate?: any | null, nextScheduledPayment?: any | null, product: string, subscriptionActive: boolean, recurring: boolean, user: string, userName: string, paymentAttempts: Array<{ __typename?: 'PaymentAttempt', currency?: string | null, paymentMethod?: string | null, paymentSettledDate?: any | null, price?: number | null, successful?: boolean | null }>, productDetails: { __typename?: 'Product', title: string, description: string, currency?: string | null, id: string, images: Array<string>, licensingType: ProductLicensingType, price: number, productType: ProductType, subscriptionDuration: ProductSubscriptionDuration, allowRelatedProducts: boolean, relatedProducts: Array<string> }, cardDetails?: { __typename?: 'CardDetails', brand: string, lastFour: string } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null, totalCount?: number | null } } };

export type CreateProductMutationVariables = Exact<{
  title: Scalars['String']['input'];
  description: Scalars['String']['input'];
  licensingType: ProductLicensingType;
  currency?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  subscriptionDuration: ProductSubscriptionDuration;
  contentList?: InputMaybe<Array<ProductContentInput> | ProductContentInput>;
  productType: ProductType;
  images?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  allowRelatedProducts?: InputMaybe<Scalars['Boolean']['input']>;
  relatedProducts?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type CreateProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'ProductMutationResponse', id: string } };

export type UpdateProductMutationVariables = Exact<{
  id: Scalars['String']['input'];
  title: Scalars['String']['input'];
  description: Scalars['String']['input'];
  licensingType: ProductLicensingType;
  currency?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  contentList?: InputMaybe<Array<ProductContentInput> | ProductContentInput>;
  productType: ProductType;
  images?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  subscriptionDuration: ProductSubscriptionDuration;
  allowRelatedProducts?: InputMaybe<Scalars['Boolean']['input']>;
  relatedProducts?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'ProductMutationResponse', id: string } };

export type ArchiveProductMutationVariables = Exact<{
  id: Scalars['String']['input'];
  archive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ArchiveProductMutation = { __typename?: 'Mutation', archiveProduct: { __typename?: 'NewEntityID', id: string } };

export type ProductReportDataContainerQueryVariables = Exact<{
  dateFilter: DateQueryOperatorArgs;
  type: Scalars['String']['input'];
}>;


export type ProductReportDataContainerQuery = { __typename?: 'Query', productReport: { __typename?: 'ProductReportDataContainer', edges: Array<{ __typename?: 'ProductReportDatumEdge', node: { __typename?: 'ProductReportDatum', permanent?: number | null, subscription?: number | null } }> } };

export type PaymentsQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentsQuery = { __typename?: 'Query', payments: Array<{ __typename?: 'PaymentsGTO', productId: string, stripeProductId: string, productTitle: string, paymentMethod: string, paymentType: string, paymentDate: any, paymentTotal: number, invoiceUrl: string }> };

export type StripeInitiateAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type StripeInitiateAccountMutation = { __typename?: 'Mutation', stripeInitiateAccount: { __typename?: 'StripeInitiateAccount', url: string } };

export type StripeInitiatePaymentMethodMutationVariables = Exact<{ [key: string]: never; }>;


export type StripeInitiatePaymentMethodMutation = { __typename?: 'Mutation', stripeInitiatePaymentMethod: { __typename?: 'StripeInitiatePaymentMethodCreation', id: string, clientSecret: string } };

export type StripeCompleteAccountMutationVariables = Exact<{
  account: Scalars['String']['input'];
  verificationToken: Scalars['String']['input'];
}>;


export type StripeCompleteAccountMutation = { __typename?: 'Mutation', stripeCompleteAccount: boolean };

export type CompanyIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyIntegrationsQuery = { __typename?: 'Query', companyIntegrations: { __typename?: 'CompanyIntegration', stripe: { __typename?: 'StripeIntegrationData', account: string } } };

export type StripeGetLastCustomerPaymentMethodQueryVariables = Exact<{ [key: string]: never; }>;


export type StripeGetLastCustomerPaymentMethodQuery = { __typename?: 'Query', stripeGetLastCustomerPaymentMethod: { __typename?: 'StripeRetrievePaymentMethods', paymentId: string } };

export type StripeSubmitOneTimePaymentMutationVariables = Exact<{
  paymentMethodId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
}>;


export type StripeSubmitOneTimePaymentMutation = { __typename?: 'Mutation', stripeSubmitOneTimePayment: { __typename?: 'StripePaymentStatus', status: string } };

export type CreateSubscriptionMutationVariables = Exact<{
  productId: Scalars['String']['input'];
}>;


export type CreateSubscriptionMutation = { __typename?: 'Mutation', createSubscription: { __typename?: 'StripeSubscriptionID', id: string } };

export type CancelSubscriptionMutationVariables = Exact<{
  productId: Scalars['String']['input'];
}>;


export type CancelSubscriptionMutation = { __typename?: 'Mutation', cancelSubscription: { __typename?: 'StripeSubscriptionID', id: string } };

export type UpdateSubscriptionPaymentMethodMutationVariables = Exact<{
  setupIntentId: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
}>;


export type UpdateSubscriptionPaymentMethodMutation = { __typename?: 'Mutation', updateSubscriptionPaymentMethod: { __typename?: 'StripeSubscriptionID', id: string } };

export type PaymentMethodDataFromSetupIntentQueryVariables = Exact<{
  setupIntentId: Scalars['String']['input'];
}>;


export type PaymentMethodDataFromSetupIntentQuery = { __typename?: 'Query', paymentMethodDataFromSetupIntent: { __typename?: 'PaymentMethodGTO', id: string, brand: string, lastFour: number } };

export type UserContentStatsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UserContentStatsQuery = { __typename?: 'Query', user: { __typename?: 'User', contentStats: { __typename?: 'UserContentStats', assignmentNotifications: number, assignments: number, awardedBadges: number, contentViews: number, learningTracks: number, workshopInstances: number } } };

export type UserStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserStatsQuery = { __typename?: 'Query', companyUserStats: { __typename?: 'CompanyUserStats', activeUsers: number, firstLoginLastThirty: number, lastLoginThisMonth: number, availableSeats: number, pendingUsers: number, externalUsers: number, adminUsers: number, creatorUsers: number, suspendedUsers: number } };

export const NotificationMessageDetailsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationMessageDetailsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationReadModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"contentId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"creator"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"messaging"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inApp"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slack"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduled"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledDuration"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<NotificationMessageDetailsFragmentFragment, unknown>;
export const CreateWorkflowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateWorkflow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workflow"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createWorkflow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workflow"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workflow"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<CreateWorkflowMutation, CreateWorkflowMutationVariables>;
export const CreateNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notification"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createNotification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"create"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notification"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<CreateNotificationMutation, CreateNotificationMutationVariables>;
export const UpdateNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notification"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateNotification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notification"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpdateNotificationMutation, UpdateNotificationMutationVariables>;
export const TriggerPointInTimeWorkflowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TriggerPointInTimeWorkflow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workflowTriggerData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowTriggerData"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"triggerPointInTimeWorkflow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workflowData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workflowTriggerData"}}}]}]}}]} as unknown as DocumentNode<TriggerPointInTimeWorkflowMutation, TriggerPointInTimeWorkflowMutationVariables>;
export const UpdateWorkflowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateWorkflow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workflowUpdateInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateWorkflow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"workflowUpdateInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workflowUpdateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpdateWorkflowMutation, UpdateWorkflowMutationVariables>;
export const UpdateWorkflowResultGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateWorkflowResultGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resultGroupUpdateInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResultGroupUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateResultGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"resultGroupUpdateInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resultGroupUpdateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpdateWorkflowResultGroupMutation, UpdateWorkflowResultGroupMutationVariables>;
export const MarkAssignmentCompletedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkAssignmentCompleted"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"completeAssignmentInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignmentActionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeAssignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"completeInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"completeAssignmentInput"}}}]}]}}]} as unknown as DocumentNode<MarkAssignmentCompletedMutation, MarkAssignmentCompletedMutationVariables>;
export const ArchiveAssignmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ArchiveAssignments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"archiveAssignmentInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignmentActionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archiveAssignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"archiveInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"archiveAssignmentInput"}}}]}]}}]} as unknown as DocumentNode<ArchiveAssignmentsMutation, ArchiveAssignmentsMutationVariables>;
export const SendAssignmentReminderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendAssignmentReminder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assignmentReminderInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignmentActionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendAssignmentReminder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reminderInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assignmentReminderInput"}}}]}]}}]} as unknown as DocumentNode<SendAssignmentReminderMutation, SendAssignmentReminderMutationVariables>;
export const BulkUserSearchFromEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BulkUserSearchFromEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userEmails"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUserSearch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userEmails"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userEmails"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]} as unknown as DocumentNode<BulkUserSearchFromEmailQuery, BulkUserSearchFromEmailQueryVariables>;
export const AssignmentAudienceCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AssignmentAudienceCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"audience"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AudienceCountInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"audienceCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"audience"},"value":{"kind":"Variable","name":{"kind":"Name","value":"audience"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalUsers"}}]}}]}}]} as unknown as DocumentNode<AssignmentAudienceCountQuery, AssignmentAudienceCountQueryVariables>;
export const GetWorkflowDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkflowDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getWorkflow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"percentComplete"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"audience"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dateRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"after"}},{"kind":"Field","name":{"kind":"Name","value":"before"}}]}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"matchingCriteria"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"segmentationType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delay"}}]}},{"kind":"Field","name":{"kind":"Name","value":"conditionals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"daysToComplete"}},{"kind":"Field","name":{"kind":"Name","value":"dueFromHired"}},{"kind":"Field","name":{"kind":"Name","value":"escalateBuddy"}},{"kind":"Field","name":{"kind":"Name","value":"escalateManager"}},{"kind":"Field","name":{"kind":"Name","value":"escalationContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nonReminderMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationMessageDetailsFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectNumber"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"overdueMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cadence"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationMessageDetailsFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalMessages"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partnerPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"reminderMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationMessageDetailsFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeBeforeDue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requireRecompletion"}},{"kind":"Field","name":{"kind":"Name","value":"responses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isRecompletable"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shareOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailBody"}},{"kind":"Field","name":{"kind":"Name","value":"emailFromEmail"}},{"kind":"Field","name":{"kind":"Name","value":"emailFromName"}},{"kind":"Field","name":{"kind":"Name","value":"emailSubject"}}]}},{"kind":"Field","name":{"kind":"Name","value":"triggerObject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationMessageDetailsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationReadModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"contentId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"creator"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"messaging"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inApp"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slack"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduled"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledDuration"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<GetWorkflowDetailsQuery, GetWorkflowDetailsQueryVariables>;
export const GetWorkflowOverviewTotalsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkflowOverviewTotalsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflowOverview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"automatedWorkflowCount"}},{"kind":"Field","name":{"kind":"Name","value":"directWorkflowCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalWorkflowCount"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<GetWorkflowOverviewTotalsQueryQuery, GetWorkflowOverviewTotalsQueryQueryVariables>;
export const GetWorkflowResultGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkflowResultGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflowResultGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assigner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"audience"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"after"}},{"kind":"Field","name":{"kind":"Name","value":"before"}}]}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"matchingCriteria"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"segmentationType"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedAssignments"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resultCount"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"resultType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delay"}}]}},{"kind":"Field","name":{"kind":"Name","value":"conditionals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"daysToComplete"}},{"kind":"Field","name":{"kind":"Name","value":"dueFromHired"}},{"kind":"Field","name":{"kind":"Name","value":"escalateBuddy"}},{"kind":"Field","name":{"kind":"Name","value":"escalateManager"}},{"kind":"Field","name":{"kind":"Name","value":"escalationContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nonReminderMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationMessageDetailsFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectNumber"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"overdueMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cadence"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationMessageDetailsFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalMessages"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partnerPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"reminderMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationMessageDetailsFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeBeforeDue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requireRecompletion"}},{"kind":"Field","name":{"kind":"Name","value":"responses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shareOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailBody"}},{"kind":"Field","name":{"kind":"Name","value":"emailFromEmail"}},{"kind":"Field","name":{"kind":"Name","value":"emailFromName"}},{"kind":"Field","name":{"kind":"Name","value":"emailSubject"}}]}},{"kind":"Field","name":{"kind":"Name","value":"triggerObject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalAssignments"}},{"kind":"Field","name":{"kind":"Name","value":"triggeredForUsers"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"workflow"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationMessageDetailsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationReadModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"contentId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"creator"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"messaging"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inApp"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slack"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduled"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledDuration"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<GetWorkflowResultGroupQuery, GetWorkflowResultGroupQueryVariables>;
export const GetWorkflowStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkflowStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflowStats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completedLate"}},{"kind":"Field","name":{"kind":"Name","value":"completedOnTime"}},{"kind":"Field","name":{"kind":"Name","value":"completedPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"inProgress"}},{"kind":"Field","name":{"kind":"Name","value":"notStarted"}},{"kind":"Field","name":{"kind":"Name","value":"openAssignments"}},{"kind":"Field","name":{"kind":"Name","value":"overdue"}},{"kind":"Field","name":{"kind":"Name","value":"overduePercentage"}},{"kind":"Field","name":{"kind":"Name","value":"pendingOnTime"}},{"kind":"Field","name":{"kind":"Name","value":"totalAssignments"}},{"kind":"Field","name":{"kind":"Name","value":"totalGroups"}}]}}]}}]} as unknown as DocumentNode<GetWorkflowStatsQuery, GetWorkflowStatsQueryVariables>;
export const ListAssignmentRecipientsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListAssignmentRecipientsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assigneeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IDQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assigneeName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StringQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assigner"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IDQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"completed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BooleanQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"completedDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"completionStatus"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StringQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IDQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dueDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IDQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeTotalCount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"defaultValue":{"kind":"BooleanValue","value":true}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ordering"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"500"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workflowId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IDQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unassigned"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BooleanQueryOperatorArgs"}},"defaultValue":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"BooleanValue","value":true},{"kind":"BooleanValue","value":false}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assigneeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assigneeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"assigneeName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assigneeName"}}},{"kind":"Argument","name":{"kind":"Name","value":"assigner"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assigner"}}},{"kind":"Argument","name":{"kind":"Name","value":"completed"},"value":{"kind":"Variable","name":{"kind":"Name","value":"completed"}}},{"kind":"Argument","name":{"kind":"Name","value":"completedDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"completedDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"completionStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"completionStatus"}}},{"kind":"Argument","name":{"kind":"Name","value":"contentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"dueDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dueDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeTotalCount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeTotalCount"}}},{"kind":"Argument","name":{"kind":"Name","value":"ordering"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ordering"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"workflowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workflowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"unassigned"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unassigned"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"completionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"completedDate"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListAssignmentRecipientsQueryQuery, ListAssignmentRecipientsQueryQueryVariables>;
export const ListSegmentationGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListSegmentationGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IDQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeTotalCount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"defaultValue":{"kind":"BooleanValue","value":true}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StringQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ordering"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listSegmentationGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeTotalCount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeTotalCount"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"ordering"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ordering"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListSegmentationGroupsQuery, ListSegmentationGroupsQueryVariables>;
export const ListWorkflowResultGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListWorkflowResultGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assigneeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IDQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IDQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeTotalCount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"defaultValue":{"kind":"BooleanValue","value":true}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ordering"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"7"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workflow"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IDQueryOperatorArgs"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflowResultGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assigneeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assigneeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeTotalCount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeTotalCount"}}},{"kind":"Argument","name":{"kind":"Name","value":"ordering"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ordering"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"workflow"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workflow"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"triggeredForUsers"}},{"kind":"Field","name":{"kind":"Name","value":"totalAssignments"}},{"kind":"Field","name":{"kind":"Name","value":"completedAssignments"}},{"kind":"Field","name":{"kind":"Name","value":"audience"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"after"}},{"kind":"Field","name":{"kind":"Name","value":"before"}}]}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"matchingCriteria"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"segmentationType"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delay"}}]}},{"kind":"Field","name":{"kind":"Name","value":"conditionals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"daysToComplete"}},{"kind":"Field","name":{"kind":"Name","value":"dueFromHired"}},{"kind":"Field","name":{"kind":"Name","value":"escalateBuddy"}},{"kind":"Field","name":{"kind":"Name","value":"escalateManager"}},{"kind":"Field","name":{"kind":"Name","value":"escalationContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nonReminderMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationMessageDetailsFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectNumber"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"overdueMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cadence"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationMessageDetailsFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalMessages"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partnerPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"reminderMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationMessageDetailsFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeBeforeDue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requireRecompletion"}},{"kind":"Field","name":{"kind":"Name","value":"responses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isRecompletable"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shareOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailBody"}},{"kind":"Field","name":{"kind":"Name","value":"emailFromEmail"}},{"kind":"Field","name":{"kind":"Name","value":"emailFromName"}},{"kind":"Field","name":{"kind":"Name","value":"emailSubject"}}]}},{"kind":"Field","name":{"kind":"Name","value":"triggerObject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assigner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationMessageDetailsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationReadModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"contentId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"creator"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"messaging"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inApp"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slack"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduled"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledDuration"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<ListWorkflowResultGroupsQuery, ListWorkflowResultGroupsQueryVariables>;
export const ListWorkflowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListWorkflows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IDQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeTotalCount"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StringQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ordering"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pointInTime"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BooleanQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IDQueryOperatorArgs"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listWorkflows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeTotalCount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeTotalCount"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"ordering"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ordering"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"pointInTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pointInTime"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"resultCount"}},{"kind":"Field","name":{"kind":"Name","value":"resultGroupCount"}},{"kind":"Field","name":{"kind":"Name","value":"percentComplete"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"responses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dueFromHired"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListWorkflowsQuery, ListWorkflowsQueryVariables>;
export const ListSegmentationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListSegmentations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeTotalCount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StringQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"segmentations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeTotalCount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeTotalCount"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"segmentationType"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListSegmentationsQuery, ListSegmentationsQueryVariables>;
export const ListUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StringQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StringQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"suspended"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BooleanQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeTotalCount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"suspended"},"value":{"kind":"Variable","name":{"kind":"Name","value":"suspended"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeTotalCount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeTotalCount"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListUsersQuery, ListUsersQueryVariables>;
export const GetPromptResponseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPromptResponse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"prompt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPromptResponse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"prompt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"prompt"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"references"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"response"}}]}}]}}]} as unknown as DocumentNode<GetPromptResponseQuery, GetPromptResponseQueryVariables>;
export const GetUserContentFromContextIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserContentFromContextId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentTypes"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contextId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserContent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contentType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentType"}}},{"kind":"Argument","name":{"kind":"Name","value":"contextId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contextId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"satisfied"}}]}}]}}]} as unknown as DocumentNode<GetUserContentFromContextIdQuery, GetUserContentFromContextIdQueryVariables>;
export const CreateAgreementTextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAgreementText"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyDefault"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAgreementText"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyDefault"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyDefault"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateAgreementTextMutation, CreateAgreementTextMutationVariables>;
export const GetImportedContentTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetImportedContentType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"userid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImportedContentExtras"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetImportedContentTypeQuery, GetImportedContentTypeQueryVariables>;
export const GetContentForEditorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetContentForEditor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"userid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"creator"}},{"kind":"Field","name":{"kind":"Name","value":"currentVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScormExtras"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"sslaConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openScoInNewWindow"}},{"kind":"Field","name":{"kind":"Name","value":"scoWindowWidth"}},{"kind":"Field","name":{"kind":"Name","value":"scoWindowHeight"}},{"kind":"Field","name":{"kind":"Name","value":"scoWindowTryFullscreen"}}]}},{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoExtras"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"useGenerativeAi"}},{"kind":"Field","name":{"kind":"Name","value":"textGenerationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"transcript"}},{"kind":"Field","name":{"kind":"Name","value":"textGenerationJob"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"transcoding"}},{"kind":"Field","name":{"kind":"Name","value":"vttFiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileExtras"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"downloadable"}},{"kind":"Field","name":{"kind":"Name","value":"useGenerativeAi"}},{"kind":"Field","name":{"kind":"Name","value":"textGenerationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"transcript"}},{"kind":"Field","name":{"kind":"Name","value":"textGenerationJob"}},{"kind":"Field","name":{"kind":"Name","value":"draft"}},{"kind":"Field","name":{"kind":"Name","value":"embed"}},{"kind":"Field","name":{"kind":"Name","value":"sourceV2"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleExtras"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TrackExtras"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"draft"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"resource"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"sequential"}},{"kind":"Field","name":{"kind":"Name","value":"lockScorm"}},{"kind":"Field","name":{"kind":"Name","value":"learnItems"}},{"kind":"Field","name":{"kind":"Name","value":"instructors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"reusable"}},{"kind":"Field","name":{"kind":"Name","value":"socials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkedin"}},{"kind":"Field","name":{"kind":"Name","value":"twitter"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"slack"}},{"kind":"Field","name":{"kind":"Name","value":"github"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"youtube"}},{"kind":"Field","name":{"kind":"Name","value":"dribbble"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"courses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImportedContentExtras"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"instructors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"reusable"}},{"kind":"Field","name":{"kind":"Name","value":"socials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkedin"}},{"kind":"Field","name":{"kind":"Name","value":"twitter"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"slack"}},{"kind":"Field","name":{"kind":"Name","value":"github"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"youtube"}},{"kind":"Field","name":{"kind":"Name","value":"dribbble"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendor"}},{"kind":"Field","name":{"kind":"Name","value":"vendorLink"}},{"kind":"Field","name":{"kind":"Name","value":"vendorFullLink"}},{"kind":"Field","name":{"kind":"Name","value":"vendorContentId"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"learnItems"}},{"kind":"Field","name":{"kind":"Name","value":"lilStructure"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"difficulty"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"difficulty"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"difficulty"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssessmentExtras"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"rubricGrading"}},{"kind":"Field","name":{"kind":"Name","value":"questionAsset"}},{"kind":"Field","name":{"kind":"Name","value":"questionAssetType"}},{"kind":"Field","name":{"kind":"Name","value":"rubricOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"choiceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"copy"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"questionOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StringType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BooleanType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value1"},"name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NumberType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value2"},"name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessmentType"}},{"kind":"Field","name":{"kind":"Name","value":"assignedGraders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowRetake"}},{"kind":"Field","name":{"kind":"Name","value":"showUserGrade"}},{"kind":"Field","name":{"kind":"Name","value":"showUserCorrect"}},{"kind":"Field","name":{"kind":"Name","value":"showUserCorrectAfterFail"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfRetakes"}},{"kind":"Field","name":{"kind":"Name","value":"percentToPass"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"hideCover"}},{"kind":"Field","name":{"kind":"Name","value":"allowManagerGrading"}},{"kind":"Field","name":{"kind":"Name","value":"allowBuddyGrading"}},{"kind":"Field","name":{"kind":"Name","value":"assignManagerGrading"}},{"kind":"Field","name":{"kind":"Name","value":"assignBuddyGrading"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"private"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"bannerImage"}},{"kind":"Field","name":{"kind":"Name","value":"coverJustification"}},{"kind":"Field","name":{"kind":"Name","value":"featuredJustification"}},{"kind":"Field","name":{"kind":"Name","value":"exploreHide"}},{"kind":"Field","name":{"kind":"Name","value":"approvalRequired"}},{"kind":"Field","name":{"kind":"Name","value":"signatureRequired"}},{"kind":"Field","name":{"kind":"Name","value":"signatureAgreementText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"totalLikes"}},{"kind":"Field","name":{"kind":"Name","value":"averageRating"}},{"kind":"Field","name":{"kind":"Name","value":"ratingConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowRating"}},{"kind":"Field","name":{"kind":"Name","value":"allowFeedback"}},{"kind":"Field","name":{"kind":"Name","value":"allowEdits"}},{"kind":"Field","name":{"kind":"Name","value":"notifyFeedbackOnly"}},{"kind":"Field","name":{"kind":"Name","value":"showUsersRating"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"messaging"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"individuals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"linkedDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedTeams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedOrgLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedGrade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"slackChannels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowComments"}},{"kind":"Field","name":{"kind":"Name","value":"surveys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"privacyCollaborators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"linkedDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedTeams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedOrgLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedGrade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"privacyLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"privacyDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"privacyTeams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"privacyOrgLevels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"privacyGrades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"privacyGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"partnerPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"certificate"}},{"kind":"Field","name":{"kind":"Name","value":"certificateData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<GetContentForEditorQuery, GetContentForEditorQueryVariables>;
export const CreateInstructorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateInstructor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InstructorCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createInstructor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"create"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateInstructorMutation, CreateInstructorMutationVariables>;
export const SearchInstructorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchInstructors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"instructors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"reusable"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"socials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dribbble"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"github"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"linkedin"}},{"kind":"Field","name":{"kind":"Name","value":"slack"}},{"kind":"Field","name":{"kind":"Name","value":"twitter"}},{"kind":"Field","name":{"kind":"Name","value":"youtube"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<SearchInstructorsQuery, SearchInstructorsQueryVariables>;
export const UpdateInstructorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateInstructor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InstructorUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateInstructor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"reusable"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"socials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dribbble"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"github"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"linkedin"}},{"kind":"Field","name":{"kind":"Name","value":"slack"}},{"kind":"Field","name":{"kind":"Name","value":"twitter"}},{"kind":"Field","name":{"kind":"Name","value":"youtube"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateInstructorMutation, UpdateInstructorMutationVariables>;
export const GenerativeKeywordsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GenerativeKeywords"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generativeKeywords"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}}]}]}}]} as unknown as DocumentNode<GenerativeKeywordsQuery, GenerativeKeywordsQueryVariables>;
export const GenerativeKeywordsByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GenerativeKeywordsById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generativeKeywordsById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<GenerativeKeywordsByIdQuery, GenerativeKeywordsByIdQueryVariables>;
export const GenerativeDescriptionByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GenerativeDescriptionById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generativeDescriptionById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<GenerativeDescriptionByIdQuery, GenerativeDescriptionByIdQueryVariables>;
export const GetTextGenerationStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTextGenerationStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"userid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"currentVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoExtras"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"textGenerationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"vttFiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileExtras"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"textGenerationStatus"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTextGenerationStatusQuery, GetTextGenerationStatusQueryVariables>;
export const GenerativeTopicsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GenerativeTopics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trackid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generativeTopics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"trackid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trackid"}}}]}]}}]} as unknown as DocumentNode<GenerativeTopicsQuery, GenerativeTopicsQueryVariables>;
export const PartnerContainerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerContainer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeTotalCount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StringQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ordering"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeTotalCount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeTotalCount"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"ordering"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ordering"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"branding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backgroundImageUrls"}},{"kind":"Field","name":{"kind":"Name","value":"colorPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"seats"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<PartnerContainerQuery, PartnerContainerQueryVariables>;
export const ProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Products"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeTotalCount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StringQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IDQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ordering"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeTotalCount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeTotalCount"}}},{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"ordering"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ordering"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"images"}},{"kind":"Field","name":{"kind":"Name","value":"licensingType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionDuration"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<ProductsQuery, ProductsQueryVariables>;
export const AdminProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeTotalCount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StringQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IDQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ordering"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"archived"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BooleanQueryOperatorArgs"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeTotalCount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeTotalCount"}}},{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"ordering"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ordering"}}},{"kind":"Argument","name":{"kind":"Name","value":"archived"},"value":{"kind":"Variable","name":{"kind":"Name","value":"archived"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"images"}},{"kind":"Field","name":{"kind":"Name","value":"licensingType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionDuration"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalRefunded"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"default"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<AdminProductsQuery, AdminProductsQueryVariables>;
export const ProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Product"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"images"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"licensingType"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionDuration"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"allowRelatedProducts"}},{"kind":"Field","name":{"kind":"Name","value":"relatedProducts"}},{"kind":"Field","name":{"kind":"Name","value":"contentListDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}}]}}]}}]} as unknown as DocumentNode<ProductQuery, ProductQueryVariables>;
export const BaseProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BaseProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"images"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"licensingType"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionDuration"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"allowRelatedProducts"}},{"kind":"Field","name":{"kind":"Name","value":"relatedProducts"}},{"kind":"Field","name":{"kind":"Name","value":"contentListDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}}]}}]}}]} as unknown as DocumentNode<BaseProductQuery, BaseProductQueryVariables>;
export const PurchasesContainerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PurchasesContainer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeTotalCount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IDQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IDQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"product"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IDQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionActive"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"purchaseConfirmedDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ordering"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeTotalCount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeTotalCount"}}},{"kind":"Argument","name":{"kind":"Name","value":"user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"product"},"value":{"kind":"Variable","name":{"kind":"Name","value":"product"}}},{"kind":"Argument","name":{"kind":"Name","value":"subscriptionActive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionActive"}}},{"kind":"Argument","name":{"kind":"Name","value":"purchaseConfirmedDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"purchaseConfirmedDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"ordering"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ordering"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseInitiatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseConfirmedDate"}},{"kind":"Field","name":{"kind":"Name","value":"nextScheduledPayment"}},{"kind":"Field","name":{"kind":"Name","value":"paymentAttempts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"paymentSettledDate"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"successful"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"productDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"images"}},{"kind":"Field","name":{"kind":"Name","value":"licensingType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionDuration"}},{"kind":"Field","name":{"kind":"Name","value":"allowRelatedProducts"}},{"kind":"Field","name":{"kind":"Name","value":"relatedProducts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionActive"}},{"kind":"Field","name":{"kind":"Name","value":"recurring"}},{"kind":"Field","name":{"kind":"Name","value":"user"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<PurchasesContainerQuery, PurchasesContainerQueryVariables>;
export const PurchasesContainerSingleUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PurchasesContainerSingleUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeTotalCount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IDQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IDQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"product"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IDQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionActive"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"purchaseConfirmedDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateQueryOperatorArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ordering"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeTotalCount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeTotalCount"}}},{"kind":"Argument","name":{"kind":"Name","value":"user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"product"},"value":{"kind":"Variable","name":{"kind":"Name","value":"product"}}},{"kind":"Argument","name":{"kind":"Name","value":"subscriptionActive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionActive"}}},{"kind":"Argument","name":{"kind":"Name","value":"purchaseConfirmedDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"purchaseConfirmedDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"ordering"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ordering"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseInitiatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseConfirmedDate"}},{"kind":"Field","name":{"kind":"Name","value":"nextScheduledPayment"}},{"kind":"Field","name":{"kind":"Name","value":"paymentAttempts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"paymentSettledDate"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"successful"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"productDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"images"}},{"kind":"Field","name":{"kind":"Name","value":"licensingType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionDuration"}},{"kind":"Field","name":{"kind":"Name","value":"allowRelatedProducts"}},{"kind":"Field","name":{"kind":"Name","value":"relatedProducts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cardDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"lastFour"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionActive"}},{"kind":"Field","name":{"kind":"Name","value":"recurring"}},{"kind":"Field","name":{"kind":"Name","value":"user"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<PurchasesContainerSingleUserQuery, PurchasesContainerSingleUserQueryVariables>;
export const CreateProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"licensingType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductLicensingType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"price"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionDuration"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductSubscriptionDuration"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentList"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductContentInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"images"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"published"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allowRelatedProducts"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"relatedProducts"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"licensingType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"licensingType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"currency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"price"},"value":{"kind":"Variable","name":{"kind":"Name","value":"price"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"subscriptionDuration"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionDuration"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"contentList"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentList"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"productType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"images"},"value":{"kind":"Variable","name":{"kind":"Name","value":"images"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"Variable","name":{"kind":"Name","value":"published"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"allowRelatedProducts"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allowRelatedProducts"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"relatedProducts"},"value":{"kind":"Variable","name":{"kind":"Name","value":"relatedProducts"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateProductMutation, CreateProductMutationVariables>;
export const UpdateProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"licensingType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductLicensingType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"price"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentList"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductContentInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"images"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"published"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionDuration"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductSubscriptionDuration"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allowRelatedProducts"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"relatedProducts"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"licensingType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"licensingType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"currency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"price"},"value":{"kind":"Variable","name":{"kind":"Name","value":"price"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"contentList"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentList"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"productType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"images"},"value":{"kind":"Variable","name":{"kind":"Name","value":"images"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"Variable","name":{"kind":"Name","value":"published"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"subscriptionDuration"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionDuration"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"allowRelatedProducts"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allowRelatedProducts"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"relatedProducts"},"value":{"kind":"Variable","name":{"kind":"Name","value":"relatedProducts"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateProductMutation, UpdateProductMutationVariables>;
export const ArchiveProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ArchiveProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"archive"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archiveProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"archiveInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"archive"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ArchiveProductMutation, ArchiveProductMutationVariables>;
export const ProductReportDataContainerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductReportDataContainer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateQueryOperatorArgs"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dateFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permanent"}},{"kind":"Field","name":{"kind":"Name","value":"subscription"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductReportDataContainerQuery, ProductReportDataContainerQueryVariables>;
export const PaymentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"stripeProductId"}},{"kind":"Field","name":{"kind":"Name","value":"productTitle"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}},{"kind":"Field","name":{"kind":"Name","value":"paymentDate"}},{"kind":"Field","name":{"kind":"Name","value":"paymentTotal"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceUrl"}}]}}]}}]} as unknown as DocumentNode<PaymentsQuery, PaymentsQueryVariables>;
export const StripeInitiateAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StripeInitiateAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripeInitiateAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<StripeInitiateAccountMutation, StripeInitiateAccountMutationVariables>;
export const StripeInitiatePaymentMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StripeInitiatePaymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripeInitiatePaymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clientSecret"}}]}}]}}]} as unknown as DocumentNode<StripeInitiatePaymentMethodMutation, StripeInitiatePaymentMethodMutationVariables>;
export const StripeCompleteAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StripeCompleteAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"account"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"verificationToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripeCompleteAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountData"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"account"},"value":{"kind":"Variable","name":{"kind":"Name","value":"account"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"verificationToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"verificationToken"}}}]}}]}]}}]} as unknown as DocumentNode<StripeCompleteAccountMutation, StripeCompleteAccountMutationVariables>;
export const CompanyIntegrationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompanyIntegrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyIntegrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"}}]}}]}}]}}]} as unknown as DocumentNode<CompanyIntegrationsQuery, CompanyIntegrationsQueryVariables>;
export const StripeGetLastCustomerPaymentMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StripeGetLastCustomerPaymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripeGetLastCustomerPaymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentId"}}]}}]}}]} as unknown as DocumentNode<StripeGetLastCustomerPaymentMethodQuery, StripeGetLastCustomerPaymentMethodQueryVariables>;
export const StripeSubmitOneTimePaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StripeSubmitOneTimePayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentMethodId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripeSubmitOneTimePayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"paymentData"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paymentMethodId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentMethodId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"productId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amount"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<StripeSubmitOneTimePaymentMutation, StripeSubmitOneTimePaymentMutationVariables>;
export const CreateSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSubscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subscriptionData"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"productId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;
export const CancelSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelSubscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subscriptionData"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"productId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;
export const UpdateSubscriptionPaymentMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSubscriptionPaymentMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"setupIntentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSubscriptionPaymentMethod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subscriptionUpdatePaymentData"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"stripeSetupIntentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"setupIntentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"subscriptionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateSubscriptionPaymentMethodMutation, UpdateSubscriptionPaymentMethodMutationVariables>;
export const PaymentMethodDataFromSetupIntentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PaymentMethodDataFromSetupIntent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"setupIntentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentMethodDataFromSetupIntent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"setupIntentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"setupIntentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"lastFour"}}]}}]}}]} as unknown as DocumentNode<PaymentMethodDataFromSetupIntentQuery, PaymentMethodDataFromSetupIntentQueryVariables>;
export const UserContentStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserContentStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentStats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentNotifications"}},{"kind":"Field","name":{"kind":"Name","value":"assignments"}},{"kind":"Field","name":{"kind":"Name","value":"awardedBadges"}},{"kind":"Field","name":{"kind":"Name","value":"contentViews"}},{"kind":"Field","name":{"kind":"Name","value":"learningTracks"}},{"kind":"Field","name":{"kind":"Name","value":"workshopInstances"}}]}}]}}]}}]} as unknown as DocumentNode<UserContentStatsQuery, UserContentStatsQueryVariables>;
export const UserStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyUserStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeUsers"}},{"kind":"Field","name":{"kind":"Name","value":"firstLoginLastThirty"}},{"kind":"Field","name":{"kind":"Name","value":"lastLoginThisMonth"}},{"kind":"Field","name":{"kind":"Name","value":"availableSeats"}},{"kind":"Field","name":{"kind":"Name","value":"pendingUsers"}},{"kind":"Field","name":{"kind":"Name","value":"externalUsers"}},{"kind":"Field","name":{"kind":"Name","value":"adminUsers"}},{"kind":"Field","name":{"kind":"Name","value":"creatorUsers"}},{"kind":"Field","name":{"kind":"Name","value":"suspendedUsers"}}]}}]}}]} as unknown as DocumentNode<UserStatsQuery, UserStatsQueryVariables>;